
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jNwD4", function(module, exports) {
$parcel$export(module.exports, "HomePage", function () { return $daaaefaf9f5b0b8c$export$36d69433c4f81145; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $l8kCZ = parcelRequire("l8kCZ");
parcelRequire("8DEtF");
var $FBmdN = parcelRequire("FBmdN");

var $32ng3 = parcelRequire("32ng3");
const $daaaefaf9f5b0b8c$export$36d69433c4f81145 = ()=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp737EnableIntercomChatHome);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l8kCZ.IntercomProvider), {
        appId: "p0ww63i2",
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FBmdN.HomePageTemplate), {})
    });
};

});
parcelRegister("8DEtF", function(module, exports) {
$parcel$export(module.exports, "HomePageTemplate", function () { return (parcelRequire("FBmdN")).HomePageTemplate; });
parcelRequire("FBmdN");

});
parcelRegister("FBmdN", function(module, exports) {
$parcel$export(module.exports, "HomePageTemplate", function () { return $c674efb55025af7f$export$4b59edb3aa07f6c9; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $bQjAr = parcelRequire("bQjAr");

var $doAVE = parcelRequire("doAVE");

var $jMhSx = parcelRequire("jMhSx");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");

var $ea4mV = parcelRequire("ea4mV");

var $4X0dO = parcelRequire("4X0dO");

var $2emUn = parcelRequire("2emUn");

var $32ng3 = parcelRequire("32ng3");

var $j6FQw = parcelRequire("j6FQw");

var $l4vdU = parcelRequire("l4vdU");
parcelRequire("4kWtc");
var $1LlXn = parcelRequire("1LlXn");
var $jmcAZ = parcelRequire("jmcAZ");
var $bD2wb = parcelRequire("bD2wb");
var $lE27E = parcelRequire("lE27E");
var $965Md = parcelRequire("965Md");
var $huInn = parcelRequire("huInn");
var $8nDIL = parcelRequire("8nDIL");
var $hICC7 = parcelRequire("hICC7");
var $bDxCN = parcelRequire("bDxCN");
var $9MOqA = parcelRequire("9MOqA");
var $chr3l = parcelRequire("chr3l");
var $9EccP = parcelRequire("9EccP");
var $6zyuZ = parcelRequire("6zyuZ");
var $aGCKc = parcelRequire("aGCKc");

var $5TYKZ = parcelRequire("5TYKZ");

var $azsFT = parcelRequire("azsFT");

var $02nCL = parcelRequire("02nCL");

var $ZhzbO = parcelRequire("ZhzbO");

var $98sVM = parcelRequire("98sVM");

var $7qO7m = parcelRequire("7qO7m");

var $7eYgY = parcelRequire("7eYgY");

var $8TCg5 = parcelRequire("8TCg5");

var $ggkMI = parcelRequire("ggkMI");

var $bOK36 = parcelRequire("bOK36");
const $c674efb55025af7f$export$4176c08728ac7e90 = /*#__PURE__*/ (0, $1oC0p.createContext)(undefined);
function $c674efb55025af7f$var$getHomePageQueryParams() {
    if (typeof window !== "undefined") return new URLSearchParams(window.location.search);
    if (globalThis.location) return new URLSearchParams(globalThis.location.search);
    return null;
}
/**
 * Determines which targeting cohort is enabled and returns the corresponding product.
 * Checks JSM first, then JPD, then Loom.
 */ const $c674efb55025af7f$var$useGetEnabledCrossflowProduct = ()=>{
    const isConfEnabled = (0, $doAVE.useLoggedInHasJiraAndNotConfluence)();
    const isJsmEnabled = (0, $doAVE.useHomePageJSMXflowTargetingCohort)();
    const isJpdEnabled = (0, $doAVE.useHomePageJPDXflowTargetingCohort)();
    const isLoomEnabled = (0, $doAVE.useHomePageLoomXflowTargetingCohort)();
    return (0, $1oC0p.useMemo)(()=>{
        if (isConfEnabled) return "confluence";
        if (isJsmEnabled) return "jsm";
        if (isJpdEnabled) return "jpd";
        if (isLoomEnabled) return "loom";
        return null;
    }, [
        isConfEnabled,
        isJsmEnabled,
        isJpdEnabled,
        isLoomEnabled
    ]);
};
/**
 * Default Jira CTA hero shown when user is not enrolled in any crossflow experiments
 */ const $c674efb55025af7f$var$DefaultJiraHero = ({ gwp10965XflowRecommendation: gwp10965XflowRecommendation = false, showJiraPlusRovoHomepageChanges: showJiraPlusRovoHomepageChanges = false } = {})=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $hICC7.HeroJiraCtaTemplate), {
        showJiraPlusRovoHomepageChanges: showJiraPlusRovoHomepageChanges,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ZhzbO.JiraLoggedInHeader), {
            gwp10965XflowRecommendation: gwp10965XflowRecommendation,
            showJiraPlusRovoHomepageChanges: showJiraPlusRovoHomepageChanges
        })
    });
/** Maps ML recommendation string to CrossflowProduct for hero selection. */ function $c674efb55025af7f$var$mapRecommendedProductToCrossflow(product) {
    const n = product.toLowerCase().trim();
    if (n === "confluence") return "confluence";
    if (n === "jira service management") return "jsm";
    if (n === "jira product discovery") return "jpd";
    if (n === "loom") return "loom";
    return null;
}
/**
 * Renders the logged-in crossflow hero for a product (cohort targeting and ML paths).
 * @param gwp10965XflowRecommendation — `true` in gwp10965 treatment (ML); `false` for cohort-only heroes.
 */ const $c674efb55025af7f$var$renderHeroForCrossflowProduct = (product, gwp10965XflowRecommendation)=>{
    switch(product){
        case "confluence":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2emUn.FeatureExposed), {
                experimentKey: "gwp-5831-homepage-confluence-xflow",
                group: "Test",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ggkMI.ProductProvider), {
                    product: "confluence",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bD2wb.ConfluenceCrossflowCTA), {
                        contentComponent: (0, $7qO7m.ContentTypesSection),
                        gwp10965XflowRecommendation: gwp10965XflowRecommendation
                    })
                })
            });
        case "jsm":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ggkMI.ProductProvider), {
                product: "jsm",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7eYgY.JSMCrossflowComponent), {
                    contentComponent: (0, $7qO7m.ContentTypesSection),
                    gwp10965XflowRecommendation: gwp10965XflowRecommendation
                })
            });
        case "jpd":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ggkMI.ProductProvider), {
                product: "jpd",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $98sVM.JPDCrossflowComponent), {
                    contentComponent: (0, $7qO7m.ContentTypesSection),
                    gwp10965XflowRecommendation: gwp10965XflowRecommendation
                })
            });
        case "loom":
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ggkMI.ProductProvider), {
                product: "loom",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8TCg5.LoomCrossflowComponent), {
                    contentComponent: (0, $7qO7m.ContentTypesSection),
                    gwp10965XflowRecommendation: gwp10965XflowRecommendation
                })
            });
        default:
            return /*#__PURE__*/ (0, $7VQPk.jsx)($c674efb55025af7f$var$DefaultJiraHero, {
                gwp10965XflowRecommendation: gwp10965XflowRecommendation
            });
    }
};
/**
 * Only mounted for gwp10965 experiment treatment. Calls useMlBasedXflowRecommendedProduct and renders
 * the NBP-driven hero with variant UI (hook runs only when this component is mounted).
 */ const $c674efb55025af7f$var$LoggedInHeroWithMLRecommendation = ()=>{
    const { product: recommendedProduct, requestInProgress: mlRecommendationRequestInProgress } = (0, $doAVE.useMlBasedXflowRecommendedProduct)();
    const mlRecommendationReady = !mlRecommendationRequestInProgress && recommendedProduct !== undefined;
    if (!mlRecommendationReady) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nDIL.HeroCTASkeleton), {});
    const crossflowProduct = recommendedProduct ? $c674efb55025af7f$var$mapRecommendedProductToCrossflow(recommendedProduct) : null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9MOqA.LoggedInHeroContainer), {
        children: $c674efb55025af7f$var$renderHeroForCrossflowProduct(crossflowProduct, true)
    });
};
const $c674efb55025af7f$export$4b59edb3aa07f6c9 = ()=>{
    const isLoggedIn = !(0, $doAVE.useLoggedOut)();
    const enabledCrossflowProduct = $c674efb55025af7f$var$useGetEnabledCrossflowProduct();
    const xflowRecommendationExperiment = (0, $ea4mV.useExperiment)((0, $4X0dO.experiments).gwp10965XflowRecommendation2NbpDriven);
    const gwp10965XflowRecommendation = xflowRecommendationExperiment.type === "enrolled" && xflowRecommendationExperiment.value === true;
    const checkJiraPlusRovoHomepageChangesExperiment = (0, $ea4mV.useExperiment)((0, $4X0dO.experiments).gwp10906WacHomepageHeroJiraPlusRovoChanges);
    const showJiraPlusRovoHomepageChanges = checkJiraPlusRovoHomepageChangesExperiment.type === "enrolled" && checkJiraPlusRovoHomepageChangesExperiment.value === true;
    const queryParams = $c674efb55025af7f$var$getHomePageQueryParams();
    const isTeamchangerVariant = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.get("teamchangerReferral")) === "true";
    const wacHomepageRovoVideoModuleUpdateGate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp10147WacHomepageRovoVideoModuleGate);
    const heroSection = (0, $1oC0p.useMemo)(()=>{
        if (isTeamchangerVariant) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $02nCL.HeroTeamworkCollection), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $azsFT.HeroTWCHeader), {})
        });
        if (!isLoggedIn) return /*#__PURE__*/ (0, $7VQPk.jsx)($c674efb55025af7f$var$DefaultJiraHero, {
            showJiraPlusRovoHomepageChanges: showJiraPlusRovoHomepageChanges
        });
        if (gwp10965XflowRecommendation) return /*#__PURE__*/ (0, $7VQPk.jsx)($c674efb55025af7f$var$LoggedInHeroWithMLRecommendation, {});
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9MOqA.LoggedInHeroContainer), {
            children: $c674efb55025af7f$var$renderHeroForCrossflowProduct(enabledCrossflowProduct, false)
        });
    }, [
        isTeamchangerVariant,
        isLoggedIn,
        gwp10965XflowRecommendation,
        showJiraPlusRovoHomepageChanges,
        enabledCrossflowProduct
    ]);
    let rovoVideoOrIntelligenceSection;
    if (wacHomepageRovoVideoModuleUpdateGate) rovoVideoOrIntelligenceSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bOK36.RovoInnovationsVideo), {});
    else rovoVideoOrIntelligenceSection = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1LlXn.AtlassianIntelligence), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "home-page-v2",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $l4vdU.default), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bDxCN.HomePageBannerAlert), {}),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.default), {
                            productKey: "home"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jmcAZ.BelowNavBannerAlert), {})
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                        id: "content",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $j6FQw.ParentScrollTracking), {
                            scrollTrackingEnabled: true,
                            pageId: "home-page-v2",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5TYKZ.HeroTakeoverTeam26), {}),
                                heroSection,
                                rovoVideoOrIntelligenceSection,
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aGCKc.TeamworkCollectionHero), {}),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $chr3l.ScrollPinnedSections), {}),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6zyuZ.TeamStats), {}),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9EccP.TabsAndIntegrationsSections), {}),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE27E.CustomerStories), {}),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $965Md.FutureOfTeamwork), {}),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $huInn.GetStartedCTA), {})
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
            ]
        })
    });
};

});
parcelRegister("4kWtc", function(module, exports) {
$parcel$export(module.exports, "AtlassianIntelligence", function () { return (parcelRequire("1LlXn")).AtlassianIntelligence; });
$parcel$export(module.exports, "HomePageBannerAlert", function () { return (parcelRequire("bDxCN")).HomePageBannerAlert; });
$parcel$export(module.exports, "CustomerStories", function () { return (parcelRequire("lE27E")).CustomerStories; });
$parcel$export(module.exports, "FutureOfTeamwork", function () { return (parcelRequire("965Md")).FutureOfTeamwork; });
$parcel$export(module.exports, "GetStartedCTA", function () { return (parcelRequire("huInn")).GetStartedCTA; });
$parcel$export(module.exports, "HeroJiraCtaTemplate", function () { return (parcelRequire("hICC7")).HeroJiraCtaTemplate; });
$parcel$export(module.exports, "ScrollPinnedSections", function () { return (parcelRequire("chr3l")).ScrollPinnedSections; });
$parcel$export(module.exports, "TabsAndIntegrationsSections", function () { return (parcelRequire("9EccP")).TabsAndIntegrationsSections; });
$parcel$export(module.exports, "TeamStats", function () { return (parcelRequire("6zyuZ")).TeamStats; });
$parcel$export(module.exports, "HeroCTASkeleton", function () { return (parcelRequire("8nDIL")).HeroCTASkeleton; });
$parcel$export(module.exports, "ConfluenceCrossflowCTA", function () { return (parcelRequire("bD2wb")).ConfluenceCrossflowCTA; });
$parcel$export(module.exports, "LoggedInHeroContainer", function () { return (parcelRequire("9MOqA")).LoggedInHeroContainer; });
$parcel$export(module.exports, "BelowNavBannerAlert", function () { return (parcelRequire("jmcAZ")).BelowNavBannerAlert; });
$parcel$export(module.exports, "TeamworkCollectionHero", function () { return (parcelRequire("aGCKc")).TeamworkCollectionHero; });
parcelRequire("1LlXn");
parcelRequire("bDxCN");
parcelRequire("lE27E");
parcelRequire("965Md");
parcelRequire("huInn");
parcelRequire("hICC7");
parcelRequire("fVzh7");
parcelRequire("jaEEJ");
parcelRequire("ZhzbO");
parcelRequire("chr3l");
parcelRequire("9EccP");
parcelRequire("6zyuZ");
parcelRequire("7HeQU");
parcelRequire("8nDIL");
parcelRequire("ichml");
parcelRequire("bD2wb");
parcelRequire("9MOqA");
parcelRequire("jmcAZ");
parcelRequire("aGCKc");
parcelRequire("bOK36");

});
parcelRegister("1LlXn", function(module, exports) {
$parcel$export(module.exports, "AtlassianIntelligence", function () { return $c8c5bb56237f8155$export$eec9700d5a261698; });
/* atlassian-intelligence.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $imIsw = parcelRequire("imIsw");

var $8EEDU = parcelRequire("8EEDU");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $32ng3 = parcelRequire("32ng3");
const $c8c5bb56237f8155$var$ArrowPencilPointRight = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "50",
        height: "17",
        viewBox: "0 0 72 25",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_tnrurdoj _1rfm1tcg _1vkhl52n _12rr12am"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fill: "currentColor",
            d: "M59.938 15.4c-.92-.48-1.816-.597-2.7-.75a7.975 7.975 0 0 0-2.872.044c-.848.163-1.709.062-2.511-.19-1.5-.473-3.039-.55-4.597-.555-.973-.005-1.959-.054-2.916-.202-.663-.104-1.292-.416-1.965-.642-.392.625-.992.599-1.612.367-1.278-.481-2.594-.57-3.947-.543-.736.014-1.463-.158-2.068-.635-.077-.056-.175-.084-.267-.117-.61.602-1.323.564-2.063.397-1.19-.262-2.387-.5-3.577-.762-.804-.18-1.606-.377-2.409-.569-.797-.196-1.56-.48-2.43-.276-1.08.253-2.16-.009-3.235-.18-1.226-.2-2.439-.518-3.666-.604-2.097-.152-4.158-.522-6.235-.81-.993-.14-1.991-.243-2.975-.423a42.808 42.808 0 0 1-2.978-.664c-1.046-.264-2.085-.582-3.121-.882C1.122 7.214.74 6.67.444 6.112.36 5.953.59 5.534.78 5.337c.594-.621 1.35-.92 2.211-.987 1.934-.153 3.86-.06 5.774.12 1.72.162 3.425.459 5.124.761 1.963.342 3.938.566 5.928.725 1.551.12 3.096.346 4.645.495 1.447.144 2.9.241 4.353.38 1.607.156 3.215.305 4.824.502 2.28.273 4.55.593 6.831.872 1.62.199 3.241.391 4.895.293.938-.058 1.897.126 2.828.295 1.34.24 2.692.28 4.046.348 1.651.082 3.303.158 4.96.246.474.026.944.098 1.42.124.13.013.267-.05.401-.072-.052-.126-.069-.295-.162-.37-.553-.454-1.127-.874-1.68-1.327-1.467-1.208-2.934-2.416-4.394-3.635-.563-.473-.885-1.124-1.227-1.76-.208-.387-.023-.71.165-1.002.18-.28.301-.676.723-.71.29-.024.579-.048.87-.041 1.45.024 2.74.566 4.009 1.184.906.442 1.796.925 2.718 1.344.386.178.62.43.782.807.114.264.204.591.615.274.182-.137.404-.09.571.125.246.314.537.602.782.921.167.222.358.277.63.3 1.026.064 1.83.574 2.406 1.407.371.537.868.9 1.432 1.15.655.29 1.24.663 1.702 1.185.85.958 1.653 1.953 2.45 2.954.341.43.245 1.248-.147 1.657-.703.737-1.431 1.44-2.117 2.191-.368.406-.66.885-1 1.323-.14.178-.285.415-.478.478-.75.258-1.239.837-1.802 1.342-.233.21-.48.442-.76.557-.915.379-1.838.732-2.774 1.043-.273.091-.606-.027-.91-.023-.139.004-.345.03-.402.12-.507.805-1.262 1.2-2.163 1.25-1.377.08-2.673.52-4.003.82-1.53.344-3.061.683-4.589 1.052a13.66 13.66 0 0 1-3.57.36c-.512-.011-.884-.266-1.065-.674-.39-.899-.488-.879.139-1.69.118-.155.253-.297.35-.466.372-.67 1.031-.793 1.682-1.007 1.115-.364 2.208-.796 3.296-1.234 1.425-.578 2.831-1.193 4.246-1.784.764-.322 1.542-.601 2.29-.949.75-.348 1.47-.753 2.287-1.178l.016-.034z"
        })
    });
};
const $c8c5bb56237f8155$var$ArrowPencilPointLeft = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        style: {
            color: props.color ? props.color : "currentColor",
            transform: `rotate(${props.rotate ? props.rotate : "0"}deg)`
        },
        width: "50",
        height: "17",
        viewBox: "0 0 72 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, $2jatx.default)([
            "_tnrurdoj _1rfm1tcg _1vkhl52n _12rr12am"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fill: "currentColor",
            d: "M11.923 9.891c.933.429 1.83.508 2.72.622a8.268 8.268 0 0 0 2.87-.149c.843-.189 1.706-.123 2.515.09 1.513.401 3.053.417 4.61.365.973-.031 1.96-.021 2.921.086.666.076 1.303.353 1.983.546.374-.617.975-.614 1.6-.413 1.292.416 2.61.453 3.962.376.735-.04 1.467.098 2.084.536.08.051.178.075.271.104.594-.604 1.307-.594 2.051-.46 1.197.208 2.4.393 3.597.601.809.144 1.616.304 2.424.46.802.16 1.572.404 2.437.176 1.072-.285 2.16-.072 3.24.053 1.23.147 2.452.409 3.68.446 2.102.069 4.172.35 6.256.55.997.097 1.998.16 2.986.297 1.006.139 2.007.323 2.995.53 1.053.216 2.101.484 3.145.735.677.158 1.073.668 1.385 1.196.088.15-.132.564-.316.76-.577.622-1.325.94-2.184 1.035-1.93.22-3.856.202-5.776.099-1.724-.091-3.436-.315-5.143-.543a66.397 66.397 0 0 0-5.946-.479c-1.554-.057-3.105-.218-4.657-.304-1.451-.086-2.906-.126-4.363-.206-1.611-.09-3.223-.174-4.836-.304-2.288-.179-4.566-.403-6.853-.588-1.626-.13-3.252-.256-4.902-.1-.936.091-1.9-.05-2.835-.179-1.348-.183-2.7-.17-4.055-.186-1.653-.017-3.307-.029-4.965-.052-.476-.007-.947-.06-1.423-.067-.13-.008-.267.059-.4.085.055.119.077.282.172.351.565.417 1.151.8 1.716 1.218 1.5 1.11 2.999 2.222 4.491 3.344.576.435.915 1.051 1.274 1.651.218.367.042.685-.137.974-.173.278-.284.664-.705.712-.288.034-.577.068-.869.072-1.449.03-2.753-.444-4.039-.993-.918-.393-1.821-.825-2.753-1.196a1.417 1.417 0 0 1-.805-.75c-.12-.25-.219-.562-.621-.24-.18.138-.402.1-.575-.1-.255-.294-.553-.561-.807-.86-.172-.207-.365-.254-.638-.266-1.027-.024-1.844-.485-2.444-1.268-.385-.504-.892-.836-1.462-1.057-.662-.256-1.258-.593-1.734-1.08a69.905 69.905 0 0 1-2.53-2.758c-.352-.404-.277-1.196.103-1.606.683-.737 1.392-1.443 2.058-2.192.356-.405.635-.879.964-1.314.135-.177.274-.41.464-.48.744-.276 1.217-.853 1.766-1.361.227-.211.467-.445.745-.566.904-.4 1.817-.775 2.745-1.11.27-.098.606.004.911-.011.138-.01.343-.042.398-.131.486-.796 1.23-1.205 2.129-1.287 1.374-.128 2.659-.601 3.98-.94 1.52-.39 3.042-.773 4.56-1.186C22.527.86 23.711.715 24.915.7c.513-.009.892.223 1.084.61.415.853.512.83-.093 1.635-.115.155-.246.297-.338.464-.354.66-1.01.803-1.654 1.034-1.105.393-2.186.85-3.262 1.314-1.41.61-2.798 1.257-4.197 1.879-.755.34-1.525.638-2.265 1.001-.74.364-1.448.781-2.254 1.222l-.014.033z"
        })
    });
};
const $c8c5bb56237f8155$export$eec9700d5a261698 = ()=>{
    const intl = (0, $8e22h.default)();
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    // edit these constant values to move the group of arrows all together
    const [shouldLoadVideo, setShouldLoadVideo] = (0, $1oC0p.useState)(false);
    (0, $1oC0p.useEffect)(()=>{
        if (sectionIsVisible) setTimeout(()=>{
            // timeout to wait to play video until animation has finished before playing video.
            setShouldLoadVideo(true);
        }, 1000);
        else setShouldLoadVideo(false);
    }, [
        sectionIsVisible,
        shouldLoadVideo
    ]);
    const useNewScreenshots = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9214HomepageScreenshots);
    const ctaButtonLabel = intl.formatMessage({
        id: "HomePageTemplateV2.AtlassianIntelligence.CtaButtonAriaLabel",
        defaultMessage: "Explore Rovo"
    });
    const videoURL = useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/8j6w234e674531msl34e178mgn42mne7.mp4" : "https://dam-cdn.atl.orangelogic.com/AssetLink/438r2lhmec7014pn861g30w8kx28ty08.mp4";
    const videoLink = shouldLoadVideo ? videoURL : "";
    const videoPreviewImage = useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/kb8y65md2n1k708ab2k8i1jcvm2qgjov.webp" : "https://dam-cdn.atl.orangelogic.com/AssetLink/mo4k25h6c2lnm475w305ja5q6ctq885v.webp";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-atlassianIntelligence",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            id: "atlassian-intelligence",
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_1pfhxncg _85i51wqb _1reo15vq _18m915vq",
                sectionIsVisible ? "is-visible" : ""
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswstnw _152tidpf _1e021ssb _t9eczr6s _1bsbtfvk _p12fauwl _4t3i1osq _bfhk1hlo _1pby1mrw _mkrz1y69",
                                "background"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _2lx21bp4 _kqswh2mm",
                                "content-wrapper"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _2lx21bp4 _zulp4bvh _p12f32xz _1q511k4y _kqswh2mm _y3gn1h6o _81641tcg"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _2lx21bp4 _4cvr1h6o _srwzi2wt"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _zulp1crf _6rthzwfg",
                                                    "branding"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                                                    brand: "rovo",
                                                    type: "logo",
                                                    appearance: "brand",
                                                    width: 126,
                                                    height: 40,
                                                    lightMode: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                                className: (0, $2jatx.default)([
                                                    "_1pby11wp _18s81km1 _1rkb1w8u _f89kcd5j",
                                                    "h2 heading"
                                                ]),
                                                style: {
                                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                                },
                                                children: intl.formatMessage({
                                                    id: "HomePageTemplateV2.AtlassianIntelligence.Header",
                                                    defaultMessage: "Transform teamwork with human-AI collaboration"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                "aria-label": ctaButtonLabel,
                                                text: ctaButtonLabel,
                                                bgColor: "bgBlackBlue",
                                                href: (0, $kooLp.useLocalizedHref)("/software/rovo"),
                                                dataEventProps: {
                                                    "data-event": "clicked",
                                                    "data-event-component": "linkButton",
                                                    "data-event-container": "ctaSection",
                                                    "data-product-key": "home",
                                                    "data-label-english": "Explore Rovo"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _1h1tcq2i _1bsb1osq"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$LeftArrows, {
                                                sectionIsVisible: sectionIsVisible
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$RightArrows, {
                                                sectionIsVisible: sectionIsVisible
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1reo15vq _18m915vq _1qu2nqa1 _12ji1rga _12y31l7b _2rko19bv _vwz4idpf"
                                                ]),
                                                style: {
                                                    "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8EEDU.Video), {
                                                    videoLink: videoLink,
                                                    videoType: "webm",
                                                    videoPreviewImage: videoPreviewImage,
                                                    loop: false,
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                        className: "fallback-img--desktop",
                                                        image: {
                                                            src: videoPreviewImage,
                                                            alt: "",
                                                            width: 1920,
                                                            height: 1080
                                                        }
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $c8c5bb56237f8155$var$LeftArrows = ({ sectionIsVisible: sectionIsVisible })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _152tidpf _lcxvglyw _1pbycs5v",
            "_152tubeo _1e02tidb _1vxpvqxi _mmgkvkhr _jj7e1xgq _zsl9vkhr _17s11xgq _dqt7vkhr"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqu7fg"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$ArrowPencilPointLeft, {
                    color: (0, $kbpa7.wacToken)("color.primary.blue"),
                    rotate: 200
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1j6v"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$ArrowPencilPointLeft, {
                    color: (0, $kbpa7.wacToken)("color.primary.purple"),
                    rotate: 222
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqb8yl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$ArrowPencilPointLeft, {
                    color: (0, $kbpa7.wacToken)("color.neutral.light0"),
                    rotate: 219
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1gop"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$ArrowPencilPointLeft, {
                    color: (0, $kbpa7.wacToken)("color.primary.black"),
                    rotate: 196
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1r2e"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$ArrowPencilPointLeft, {
                    color: (0, $kbpa7.wacToken)("color.extended.lime300"),
                    rotate: 199
                })
            })
        ]
    });
};
const $c8c5bb56237f8155$var$RightArrows = ({ sectionIsVisible: sectionIsVisible })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _152tidpf _lcxvglyw _1pbycs5v",
            "_152t11oi _1e02sisq _1vxp1ebb _mmgk189v _jj7etpnp _zsl9189v _17s1tpnp _dqt7189v"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqwpsi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$ArrowPencilPointRight, {
                    color: (0, $kbpa7.wacToken)("color.primary.blue"),
                    rotate: 139
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq1xrr"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$ArrowPencilPointRight, {
                    color: (0, $kbpa7.wacToken)("color.neutral.light0"),
                    rotate: 127
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hq59wa"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$ArrowPencilPointRight, {
                    color: (0, $kbpa7.wacToken)("color.primary.lime"),
                    rotate: 114
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _5sagk1mu _tip8kb7n _1o51q7pw",
                    "_j7hq1wwu",
                    sectionIsVisible && "",
                    sectionIsVisible && "_j7hqmgyd"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($c8c5bb56237f8155$var$ArrowPencilPointRight, {
                    color: (0, $kbpa7.wacToken)("color.primary.black"),
                    rotate: 138
                })
            })
        ]
    });
};
const $c8c5bb56237f8155$var$sectionStyles = null;
const $c8c5bb56237f8155$var$arrowStyles = null;
const $c8c5bb56237f8155$var$wrapperStyles = null;
const $c8c5bb56237f8155$var$leftAndRightArrowsStyles = null;
const $c8c5bb56237f8155$var$svgStyles = null;
const $c8c5bb56237f8155$var$leftArrowsStyles = null;
const $c8c5bb56237f8155$var$rightArrowsStyles = null;
const $c8c5bb56237f8155$var$headerStyles = null;
const $c8c5bb56237f8155$var$containerStyles = null;
const $c8c5bb56237f8155$var$backgroundStyles = null;
const $c8c5bb56237f8155$var$textWrapperStyles = null;
const $c8c5bb56237f8155$var$brandingStyles = null;
const $c8c5bb56237f8155$var$videoWrapperStyles = null;
const $c8c5bb56237f8155$var$videoInnerWrapperStyles = null;
const $c8c5bb56237f8155$var$fadeIn = null;
const $c8c5bb56237f8155$var$fadeInAnimation = null;
const $c8c5bb56237f8155$var$arrowLeft1 = null;
const $c8c5bb56237f8155$var$arrowLeft1Animation = null;
const $c8c5bb56237f8155$var$arrowLeft2 = null;
const $c8c5bb56237f8155$var$arrowLeft2Animation = null;
const $c8c5bb56237f8155$var$arrowLeft3 = null;
const $c8c5bb56237f8155$var$arrowLeft3Animation = null;
const $c8c5bb56237f8155$var$arrowLeft4 = null;
const $c8c5bb56237f8155$var$arrowLeft4Animation = null;
const $c8c5bb56237f8155$var$arrowLeft5 = null;
const $c8c5bb56237f8155$var$arrowLeft5Animation = null;
const $c8c5bb56237f8155$var$arrowRight1 = null;
const $c8c5bb56237f8155$var$arrowRight1Animation = null;
const $c8c5bb56237f8155$var$arrowRight2 = null;
const $c8c5bb56237f8155$var$arrowRight2Animation = null;
const $c8c5bb56237f8155$var$arrowRight3 = null;
const $c8c5bb56237f8155$var$arrowRight3Animation = null;
const $c8c5bb56237f8155$var$arrowRight4 = null;
const $c8c5bb56237f8155$var$arrowRight4Animation = null;
$c8c5bb56237f8155$export$eec9700d5a261698.displayName = "AtlassianIntelligence";

});

parcelRegister("bDxCN", function(module, exports) {
$parcel$export(module.exports, "HomePageBannerAlert", function () { return $e1aba540b9eb57a0$export$f688b0d8ccc20c10; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $9NH4m = parcelRequire("9NH4m");

var $32ng3 = parcelRequire("32ng3");
const $e1aba540b9eb57a0$export$f688b0d8ccc20c10 = ()=>{
    const intl = (0, $8e22h.default)();
    if ((0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9365TeamOnTourSydneyBanner)) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-banner-for-team-on-tour-sydney",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9NH4m.EnhancedBanner), {
            uniqueIdentifier: "homepage-banner-for-team-on-tour-sydney",
            heading: intl.formatMessage({
                id: "HomePage.banner-alert.team-on-tour-sydney.heading",
                defaultMessage: "Join us 11 March at ICC Sydney."
            }),
            subheading: intl.formatMessage({
                id: "HomePage.banner-alert.team-on-tour-sydney.subheading",
                defaultMessage: "Discover game-changing AI, connect with your peers, and unleash the potential of every team."
            }),
            ctaLinkHref: "https://events.atlassian.com/teamontour-sydney?utm_medium=event-web-referral&utm_source=cross-promo&event_context=701qb00000wjv6ayar&utm_campaign=K:event|H:in-person|N:tt_sydney|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=WAC_Banner&event_id=304560",
            ctaLinkText: "Learn more",
            productKey: "home",
            logoSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/31m8r0ja03yabf6a0f7137tc1l76243f.png",
            logoAlt: "Team on Tour Sydney",
            backgroundColor: "lightBlue"
        })
    });
    if ((0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp10062Awf1Banner)) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-banner-awf1",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9NH4m.EnhancedBanner), {
            uniqueIdentifier: "homepage-banner-awf1",
            heading: "Celebrating 1 year of partnership",
            subheading: "Unleashing our AI-powered System of Work to prepare Williams for the 2026 season.",
            ctaLinkHref: "https://www.atlassian.com/enterprise/atlassian-williams-racing",
            ctaLinkText: "See how with Rovo",
            productKey: "home",
            logoSrc: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EHO4.svg",
            logoAlt: "Atlassian Williams F1 Team Official Title & Technology Partner",
            backgroundColor: "black",
            shapeColor1: "blue700",
            shapeColor2: "neutral-light0",
            shapeColor3: "secondary-navy"
        })
    });
    if ((0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9226Team26Banner)) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-banner-for-team-26",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9NH4m.EnhancedBanner), {
            uniqueIdentifier: "homepage-banner-for-team-26",
            heading: intl.formatMessage({
                id: "HomePage.banner-alert.team-26.heading",
                defaultMessage: "May 5 - 7  \u2022  Anaheim, California"
            }),
            subheading: intl.formatMessage({
                id: "HomePage.banner-alert.team-26.subheading",
                defaultMessage: "Get the most savings on your in-person pass & experience the AI tools fueling better teamwork."
            }),
            subheadingMobile: intl.formatMessage({
                id: "HomePage.banner-alert.team-26.subheading",
                defaultMessage: "Save big on your in-person pass"
            }),
            ctaLinkHref: "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=cross-promo&event_context=701qb00000tzh4byar&utm_campaign=K:event|H:in-person|N:team_26|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=enhanced_banner_hero&event_id=288640",
            ctaLinkText: "Register now",
            productKey: "home",
            logoSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/p8na60e0488c54y2pj2l0oy184f23bg3.png",
            logoAlt: "Team 26",
            backgroundImageDesktop: "https://dam-cdn.atl.orangelogic.com/AssetLink/65yptj77sdkwv3tr84k58eae2i3d2d17.webp",
            backgroundImageTablet: "https://dam-cdn.atl.orangelogic.com/AssetLink/5bio0v54ttg7k5e1s1r380ode2h46xml.webp",
            backgroundImageMobile: "https://dam-cdn.atl.orangelogic.com/AssetLink/27pf0qlj6ilylq2hor6k233caw6706j3.webp",
            backgroundColor: "lightBlue"
        })
    });
};

});

parcelRegister("lE27E", function(module, exports) {
$parcel$export(module.exports, "CustomerStories", function () { return $569f92f14666dc84$export$2ef047a0f639de8f; });
/* customer-stories.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $l1i8p = parcelRequire("l1i8p");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $569f92f14666dc84$export$5972a68b6e54f38f = null;
const $569f92f14666dc84$var$headerStyles = null;
const $569f92f14666dc84$var$h2Styles = null;
const $569f92f14666dc84$var$pStyles = null;
const $569f92f14666dc84$export$2ef047a0f639de8f = ()=>{
    const intl = (0, $8e22h.default)();
    const testimonials = [
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialMercedesBenz.eyebrow",
                defaultMessage: "Large enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialMercedesBenz.name",
                defaultMessage: "Mehmet Sari"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3n048m64vgkhx225c6b2d4y6qi652h4l.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Mercedes Benz logo",
                        id: "HomePageTemplateV2.testimonials.testimonialMercedesBenz.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialMercedesBenz.title",
                defaultMessage: "Modern Collaboration Platform Team, Mercedes Benz"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/0hc44s3cpf85qh12862mrt3xos5nh3b7.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialMercedesBenz.quote",
                defaultMessage: "With Atlassian cloud, everything regarding server maintenance is done for us, and there\u2019s less downtime and better performance."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialMercedesBenz.linkText",
                    defaultMessage: "Read Mercedes-Benz\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/mercedes-benz"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialMercedesBenz.linkDataLabel",
                        defaultMessage: "Read Mercedes-Benz\u2019s case study"
                    }),
                    "data-label-english": "Read Mercedes-Benz\u2019s case study"
                }
            },
            label: "Mercedes Benz"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialRoblox.eyebrow",
                defaultMessage: "Enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialRoblox.name",
                defaultMessage: "Joe Cotant"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/55f2g6em288b4mdhqw337ynev64hlj84.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Roblox logo",
                        id: "HomePageTemplateV2.testimonials.testimonialRoblox.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialRoblox.title",
                defaultMessage: "Senior Technical Program Manager, Roblox"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/v36oo12haju4ie531co431456ji81638.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialRoblox.quote",
                defaultMessage: "For the two teams we've already migrated from Wrike to Jira, each of those will amount to $150,000/year in savings."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialRoblox.linkText",
                    defaultMessage: "Read Roblox\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/roblox"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialRoblox.linkDataLabel",
                        defaultMessage: "Read Roblox\u2019s case study"
                    }),
                    "data-label-english": "Read Roblox\u2019s case study"
                }
            },
            label: "Roblox"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialRoyalCaribbean.eyebrow",
                defaultMessage: "Large enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialRoyalCaribbean.name",
                defaultMessage: "Wais Mojaddidi"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wi135m7n2w6p4587n150uf8b813q6k1e.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Royal Caribbean logo",
                        id: "HomePageTemplateV2.testimonials.testimonialRoyalCaribbean.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialRoyalCaribbean.title",
                defaultMessage: "Director of Agile Delivery, Global E-commerce, Royal Caribbean"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/414e3b7x3552tq3q55wo5ifkdci08g7d.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialRoyalCaribbean.quote",
                defaultMessage: "By leveraging Jira and Confluence for automated reporting, we\u2019re saving over 800 hours and $500k per year in management consulting costs."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialRoyalCaribbean.linkText",
                    defaultMessage: "Read Royal Caribbean\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/royal-caribbean"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialRoyalCaribbean.linkDataLabel",
                        defaultMessage: "Read Royal Caribbean\u2019s case study"
                    }),
                    "data-label-english": "Read Royal Caribbean\u2019s case study"
                }
            },
            label: "Royal Caribbean International"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialLumen.eyebrow",
                defaultMessage: "Enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialLumen.name",
                defaultMessage: "Mai Lian Scarlett"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/xmhh54730jx70s5lm3wkfb8w7887s3ge.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Lumen logo",
                        id: "HomePageTemplateV2.testimonials.testimonialLumen.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialLumen.title",
                defaultMessage: "Former Senior Director, Agile Transformation Office, Lumen"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/5udncf4576n7e58kgtvr8g8n8ggr3hyi.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialLumen.quote",
                defaultMessage: "We\u2019ve been able to increase throughput by 200%, which means we\u2019re delivering capabilities faster and increasing customer satisfaction."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialLumen.linkText",
                    defaultMessage: "Read Lumen\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/lumen"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialLumen.linkDataLabel",
                        defaultMessage: "Read Lumen\u2019s case study"
                    }),
                    "data-label-english": "Read Lumen\u2019s case study"
                }
            },
            label: "Lumen"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDoodle.eyebrow",
                defaultMessage: "Small medium business"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDoodle.name",
                defaultMessage: "Stephanie Leue"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2gk5qdtm2d84640y77grbw0f6qgfipa6.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Doodle logo",
                        id: "HomePageTemplateV2.testimonials.testimonialDoodle.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDoodle.title",
                defaultMessage: "Former Chief Product Officer, Doodle"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/7jvefrx6u85886e360838245x37e2u54.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDoodle.quote",
                defaultMessage: "Jira Product Discovery translated our entire process into a highly transparent workflow. That was a mind-blowing moment."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialDoodle.linkText",
                    defaultMessage: "Read Doodle\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/doodle"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialDoodle.linkDataLabel",
                        defaultMessage: "Read Doodle\u2019s case study"
                    }),
                    "data-label-english": "Read Doodle's case study"
                }
            },
            label: "Doodle"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDropbox.eyebrow",
                defaultMessage: "Enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDropbox.name",
                defaultMessage: "Damien Davis"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4x832j813dg245bkofa582k4wvf8eii5.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Dropbox logo",
                        id: "HomePageTemplateV2.testimonials.testimonialDropbox.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDropbox.title",
                defaultMessage: "Lead Atlassian Administrator, Dropbox"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/r86uly308028mi73tgs4516f5st2u30w.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDropbox.quote",
                defaultMessage: "The big win that we've seen through Confluence Cloud is definitely collaboration. It's a very open way of working."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialDropbox.linkText",
                    defaultMessage: "Read Dropbox\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/dropbox"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialDropbox.linkDataLabel",
                        defaultMessage: "Read Dropbox\u2019s case study"
                    }),
                    "data-label-english": "Read Dropbox\u2019s case study"
                }
            },
            label: "Dropbox"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDHCS.eyebrow",
                defaultMessage: "Enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDHCS.name",
                defaultMessage: "Ryan Mosley"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3340ipwj05l14sno7ixj2n7h7o3231sc.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "DHCS logo",
                        id: "HomePageTemplateV2.testimonials.testimonialDHCS.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDHCS.title",
                defaultMessage: "Chief of Factory & Engineering Modernization, DHCS"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/c064mt742jq6f8wn3b066lu1aw2b8m75.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialDHCS.quote",
                defaultMessage: "By tracking in Jira and our developer tools, we reduced the cost to get the team set up and deliver from $2.8 million to $600,000."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialDHCS.linkText",
                    defaultMessage: "Read DHCS\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/dhcs"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialDHCS.linkDataLabel",
                        defaultMessage: "Read DHCS\u2019s case study"
                    }),
                    "data-label-english": "Read DHCS's case study"
                }
            },
            label: "DHCS California Department of Health Care Services"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialSonyMusicPublishing.eyebrow",
                defaultMessage: "Enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialSonyMusicPublishing.name",
                defaultMessage: "Alison Wood"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/as2614148hxs6mb1k28l03vx4v4e300x.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Sony Music Publishing logo",
                        id: "HomePageTemplateV2.testimonials.testimonialSonyMusicPublishing.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialSonyMusicPublishing.title",
                defaultMessage: "Director, Global Copyright Administration, Sony Music Publishing"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/cha0s1kn32mj355w302k352n063878qm.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialSonyMusicPublishing.quote",
                defaultMessage: "Full visibility and tracking is at the fingertips of all agents and customers alike. That\u2019s the most basic and wonderful gain."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialSonyMusicPublishing.linkText",
                    defaultMessage: "Read Sony Music Publishing\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/sonymusic-publishing"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialSonyMusicPublishing.linkDataLabel",
                        defaultMessage: "Read Sony Music Publishing\u2019s case study"
                    }),
                    "data-label-english": "Read Sony Music Publishing\u2019s case study"
                }
            },
            label: "Sony Music Publishing"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialClearwaterAnalytics.eyebrow",
                defaultMessage: "Enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialClearwaterAnalytics.name",
                defaultMessage: "Erica Larson"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1002aj72lg4073mqmm0u22omt4e3756u.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Clearwater Analytics logo",
                        id: "HomePageTemplateV2.testimonials.testimonialClearwaterAnalytics.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialClearwaterAnalytics.title",
                defaultMessage: "Process Engineer, Clearwater Analytics"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/45b4a6u0sp0qc8ugjg2aheo2vcf71sk8.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialClearwaterAnalytics.quote",
                defaultMessage: "Security and compliance are really critical in the financial industry\u2026 Atlassian cloud met all of the needs that we have."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialClearwaterAnalytics.linkText",
                    defaultMessage: "Read Clearwater Analytics\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/clearwater-analytics"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialClearwaterAnalytics.linkDataLabel",
                        defaultMessage: "Read Clearwater Analytics\u2019s case study"
                    }),
                    "data-label-english": "Read Clearwater Analytics\u2019s case study"
                }
            },
            label: "Clearwater Analytics"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialKiva.eyebrow",
                defaultMessage: "Small medium business"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialKiva.name",
                defaultMessage: "Brit Heiring"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/g8yr6i10xjx887eygmyqaljp730mh08y.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Kiva logo",
                        id: "HomePageTemplateV2.testimonials.testimonialKiva.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialKiva.title",
                defaultMessage: "Director of Communications, Kiva"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/gdsm3812bjodbh14lcaf5u1tm3nx73ok.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialKiva.quote",
                defaultMessage: "We\u2019re a global workforce, and Atlassian helps us stay in sync while doing async work. It\u2019s been a big win for us."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialKiva.linkText",
                    defaultMessage: "Read Kiva\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/kiva"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialKiva.linkDataLabel",
                        defaultMessage: "Read Kiva\u2019s case study"
                    }),
                    "data-label-english": "Read Kiva\u2019s case study"
                }
            },
            label: "Kiva"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialEdenred.eyebrow",
                defaultMessage: "Enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialEdenred.name",
                defaultMessage: "Razvan Nechifor"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/u750k8f2c6678h5omvntute11k03qku4.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "EdenRed logo",
                        id: "HomePageTemplateV2.testimonials.testimonialEdenred.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialEdenred.title",
                defaultMessage: "Jira Global Team Leader, Edenred"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/455d5oke4wx68r0d0h32644o781l6yrv.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialEdenred.quote",
                defaultMessage: "For me, migrating to the cloud has allowed us to leave all the on-premise pains. It\u2019s been a big relief."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialEdenred.linkText",
                    defaultMessage: "Read Edenred\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/edenred"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialEdenred.linkDataLabel",
                        defaultMessage: "Read Edenred\u2019s case study"
                    }),
                    "data-label-english": "Read Edenred\u2019s case study"
                }
            },
            label: "Edenred"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialSoftwareAG.eyebrow",
                defaultMessage: "Small medium business"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialSoftwareAG.name",
                defaultMessage: "Radoslav Danchev"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/80f3e4v7ay2y4p83nx1ro5r5qve74tih.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Software AG logo",
                        id: "HomePageTemplateV2.testimonials.testimonialSoftwareAG.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialSoftwareAG.title",
                defaultMessage: "VP of Collaboration, Workplace, and Support, Software AG"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/qjhm2o8ony1t600a6k57h5hy3f405458.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialSoftwareAG.quote",
                defaultMessage: "We trust Atlassian to take care of security, availability, and scalability, freeing up time for us to focus on more strategic topics."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialSoftwareAG.linkText",
                    defaultMessage: "Read Software AG\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/softwareag"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialSoftwareAG.linkDataLabel",
                        defaultMessage: "Read Software AG\u2019s case study"
                    }),
                    "data-label-english": "Read Software AG\u2019s case study"
                }
            },
            label: "Software AG"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialVeryGroup.eyebrow",
                defaultMessage: "Enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialVeryGroup.name",
                defaultMessage: "Rob Crompton"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5r5olu80k782gf3e6i5o3bcbo02j3nox.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Very Group logo",
                        id: "HomePageTemplateV2.testimonials.testimonialVeryGroup.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialVeryGroup.title",
                defaultMessage: "Head of Service Management, The Very Group"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/1wxsfb3rhdq2se01fwook74702d88bu4.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialVeryGroup.quote",
                defaultMessage: "We\u2019ve been getting a 4.9/5 satisfaction score, which has been fantastic. With the previous solution, we had nothing but complaints."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialVeryGroup.linkText",
                    defaultMessage: "Read The Very Group\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/the-very-group"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialVeryGroup.linkDataLabel",
                        defaultMessage: "Read The Very Group\u2019s case study"
                    }),
                    "data-label-english": "Read The Very Group\u2019s case study"
                }
            },
            label: "The Very Group"
        },
        {
            eyebrow: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialArvato.eyebrow",
                defaultMessage: "Enterprise"
            }),
            name: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialArvato.name",
                defaultMessage: "Johannes Siebzehnr\xfcbl"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/026h5d844h41smpb17y6750so724v8xl.svg",
                    alt: intl.formatMessage({
                        defaultMessage: "Arvato logo",
                        id: "HomePageTemplateV2.testimonials.testimonialArvato.logoAlt"
                    })
                }
            }),
            title: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialArvato.title",
                defaultMessage: "Chief Operating Officer of MultiCloud and Infrastructure, Arvato Systems"
            }),
            image: "https://dam-cdn.atl.orangelogic.com/AssetLink/aw30l5f0r4q7x0k3r3md5bc8num68k5a.webp",
            quote: intl.formatMessage({
                id: "HomePageTemplateV2.testimonials.testimonialArvato.quote",
                defaultMessage: "We really have end-to-end visibility and control over our workflow\u2026so we can see how to improve the business."
            }),
            link: {
                text: intl.formatMessage({
                    id: "HomePageTemplateV2.testimonials.testimonialArvato.linkText",
                    defaultMessage: "Read Arvato\u2019s case study"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/arvato-systems"),
                dataEventProps: {
                    "data-product-key": "home",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "HomePageTemplateV2.testimonials.testimonialArvato.linkDataLabel",
                        defaultMessage: "Read Arvato\u2019s case study"
                    }),
                    "data-label-english": "Read Arvato\u2019s case study"
                }
            },
            label: "Arvato Bertelsmann Arvato Systems"
        }
    ];
    const heading = intl.formatMessage({
        id: "HomePageTemplateV2.customerStories.heading",
        defaultMessage: "For teams of all sizes"
    });
    const cta = intl.formatMessage({
        id: "HomePageTemplateV2.customerStories.ctaText",
        defaultMessage: "Explore all customers stories"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-customerStories",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_6rth1ejb _1izx15vq _1jbp15vq _1opi1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _6rth1ylp"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_1mouqlbw",
                                        ""
                                    ]),
                                    children: heading
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1mou1kvp",
                                        "body-lg"
                                    ]),
                                    children: intl.formatMessage({
                                        id: "HomePageTemplateV2.customerStories.subheading",
                                        defaultMessage: "Everyone from start-ups to large enterprises prefer Atlassian"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    text: cta,
                                    href: (0, $kooLp.useLocalizedHref)("/customers"),
                                    dataEventProps: {
                                        "data-product-key": "home",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "customersSection",
                                        "data-event": "clicked",
                                        "data-label": intl.formatMessage({
                                            id: "HomePageTemplateV2.testimonials.ctaDataLabel",
                                            defaultMessage: "Explore all customers stories"
                                        }),
                                        "data-label-english": "Explore all customers stories"
                                    },
                                    "aria-label": cta,
                                    type: "primary"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l1i8p.CustomerTestimonials), {
                    bgColor: "black",
                    testimonials: testimonials,
                    productKey: "home"
                })
            ]
        })
    });
};
$569f92f14666dc84$export$2ef047a0f639de8f.displayName = "CustomerStories";

});

parcelRegister("965Md", function(module, exports) {
$parcel$export(module.exports, "FutureOfTeamwork", function () { return $c57dd24c5b62c6a5$export$a40f2b95cdffc95c; });
/* future-of-teamwork.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $imIsw = parcelRequire("imIsw");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $c57dd24c5b62c6a5$var$FutureOfTeamworkHeading = (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: "h1",
        children: str
    });
const $c57dd24c5b62c6a5$var$HelpUsShapeHeading = (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        className: (0, $2jatx.default)([
            "_k48pl8b6",
            "h1 reduced-font-weight"
        ]),
        children: str
    });
const $c57dd24c5b62c6a5$export$a40f2b95cdffc95c = ()=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-futureOfTeamwork",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_kqswh2mm _1reo15vq _18m915vq _y3gn1h6o _ca0q53f4 _u5f3idpf _n3td53f4 _19bvidpf _p12f1git _19pk1wqb _2hwx1wug _otyridpf _18u01wug _1kmx11ux _1ggmidpf _1ykz1wqb _1maeidpf"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "8",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx21bp4 _4cvr1h6o _zulpzwfg _p12f1oh5 _kqswh2mm",
                        "content-wrapper"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2878633782yw0cnv532u77430xi7x15x.svg",
                                alt: "",
                                width: 93,
                                height: 91
                            },
                            className: (0, $2jatx.default)([
                                "_kqswstnw _tzy4idpf",
                                "_152t15ko _1e021e0x _1eg64bvh _xaej1wte",
                                sectionIsVisible && "",
                                sectionIsVisible && "_y44vnjbr",
                                "big-star"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/a8r57w04r3t6j6087ewxa4bytiqr43me.svg",
                                alt: "",
                                width: 49,
                                height: 51
                            },
                            className: (0, $2jatx.default)([
                                "_kqswstnw _tzy4idpf",
                                "_152t183y _1e025gyx _1eg611ux _xaej101a",
                                sectionIsVisible && "",
                                sectionIsVisible && "_y44v17tq",
                                "sm-star"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/igdrq2i5082s2p672q63c4o8u055e714.svg",
                                alt: "",
                                width: 74,
                                height: 71
                            },
                            className: (0, $2jatx.default)([
                                "_kqswstnw _tzy4idpf",
                                "_152tckbl _rjxpljo4 _sugaglyw",
                                sectionIsVisible && "",
                                sectionIsVisible && "_y44v2tct",
                                "checkmark"
                            ])
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_p12foza4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "HomePageTemplateV2.futureOfTeamworkHeader",
                                defaultMessage: "<helpUsShape>Help us shape</helpUsShape> <theFutureOfTeamwork>the future of teamwork</theFutureOfTeamwork>",
                                values: {
                                    helpUsShape: $c57dd24c5b62c6a5$var$HelpUsShapeHeading,
                                    theFutureOfTeamwork: $c57dd24c5b62c6a5$var$FutureOfTeamworkHeading
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_p12fr5sb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                ".body-lg"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "HomePageTemplateV2.futureOfTeamworkParagraph",
                                defaultMessage: "At Atlassian, we believe the impossible is possible - together. Join us today to help us inspire teamwork anywhere and everywhere, worldwide."
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                            variant: "secondary",
                            color: "black",
                            href: (0, $kooLp.useLocalizedHref)("/customers/advocacy"),
                            dataEventProps: {
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-product-key": "home",
                                "data-label-english": "Share your story"
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "HomePageTemplateV2.futureOfTeamworkButton",
                                defaultMessage: "Share your story"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $c57dd24c5b62c6a5$var$fadeIn = null;
const $c57dd24c5b62c6a5$var$sectionStyles = null;
const $c57dd24c5b62c6a5$var$h2Styles = null;
const $c57dd24c5b62c6a5$var$pStyles = null;
const $c57dd24c5b62c6a5$var$reducedFontWeightStyle = null;
const $c57dd24c5b62c6a5$var$svgStyles = null;
const $c57dd24c5b62c6a5$var$bigStarAnimation = null;
const $c57dd24c5b62c6a5$var$smStarAnimation = null;
const $c57dd24c5b62c6a5$var$checkmarkAnimation = null;
const $c57dd24c5b62c6a5$var$bigStarStyles = null;
const $c57dd24c5b62c6a5$var$smStarStyles = null;
const $c57dd24c5b62c6a5$var$checkmarkStyles = null;
const $c57dd24c5b62c6a5$var$contentWrapperStyles = null;
$c57dd24c5b62c6a5$export$a40f2b95cdffc95c.displayName = "FutureOfTeamwork";

});

parcelRegister("huInn", function(module, exports) {
$parcel$export(module.exports, "GetStartedCTA", function () { return $ef5e67cba48b9075$export$1acfb8e049b8bbe5; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $l22jm = parcelRequire("l22jm");

var $imIsw = parcelRequire("imIsw");

var $kooLp = parcelRequire("kooLp");

var $4Jdkw = parcelRequire("4Jdkw");
const $ef5e67cba48b9075$export$1acfb8e049b8bbe5 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-getStartedCta",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Jdkw.ADG4CtaWithPolygonBackground), {
            backgroundColor: "#1868DB",
            header: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "HomePageTemplateV2.getStartedCtaHeader",
                defaultMessage: "Unleash the power of <teamwork>teamwork</teamwork>",
                values: {
                    teamwork: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $l22jm.Adg4TextUnderline), {
                            underline: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/816103v2hjv7e5ir82gt8c421jo5knw3.svg",
                                    alt: "",
                                    width: 277,
                                    height: 7
                                }
                            }),
                            children: str
                        })
                }
            }),
            paragraph: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "HomePageTemplateV2.getStartedCtaParagraph",
                defaultMessage: "Join millions teaming up on their best work"
            }),
            ctaText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "HomePageTemplateV2.getStartedCtaButton",
                defaultMessage: "Get started for free"
            }),
            ctaUrl: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software"),
            ctaLabel: "Get started for free",
            productKey: "home"
        })
    });
};
$ef5e67cba48b9075$export$1acfb8e049b8bbe5.displayName = "GetStartedCTA";

});

parcelRegister("hICC7", function(module, exports) {
$parcel$export(module.exports, "HeroJiraCtaTemplate", function () { return $dc801de1ab7d1fa3$export$6a016f09a0883bee; });
/* hero-jira-cta-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bQjAr = parcelRequire("bQjAr");

var $lXmB7 = parcelRequire("lXmB7");
const $dc801de1ab7d1fa3$var$DEFAULT_TEAM_DATA_NEW_SCREENSHOTS = {
    id: "default",
    videoLink: "https://dam-cdn.atl.orangelogic.com/AssetLink/438r2lhmec7014pn861g30w8kx28ty08.mp4",
    heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/qgeohf56651o63ux63s54547n4v512b6/software-hero-image.webp",
    heroImageDimensions: {
        imageWidth: 1984,
        imageHeight: 1042
    }
};
const $dc801de1ab7d1fa3$export$ae5c600fa382dccb = $dc801de1ab7d1fa3$var$DEFAULT_TEAM_DATA_NEW_SCREENSHOTS;
const $dc801de1ab7d1fa3$export$6a016f09a0883bee = ({ children: children, showJiraPlusRovoHomepageChanges: showJiraPlusRovoHomepageChanges = false })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-hero",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            id: "hero-jira-cta",
            className: (0, $2jatx.default)([
                "_1reo15vq _18m915vq"
            ]),
            children: [
                children,
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lXmB7.AiFocusVideo), {
                    showJiraPlusRovoHomepageChanges: showJiraPlusRovoHomepageChanges
                })
            ]
        })
    });
};
const $dc801de1ab7d1fa3$var$jiraHeroStyles = null;
$dc801de1ab7d1fa3$export$6a016f09a0883bee.displayName = "HeroJiraCtaTemplate";

});
parcelRegister("lXmB7", function(module, exports) {
$parcel$export(module.exports, "AiFocusVideo", function () { return $95dd56f96d9c3a4c$export$4602bc16676f672f; });
/* ai-focus-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $95dd56f96d9c3a4c$export$4602bc16676f672f = ({ showJiraPlusRovoHomepageChanges: showJiraPlusRovoHomepageChanges = false })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1bsb7jhw _p12f1osq _19pkidpf _2hwx1wug _otyr12am _18u01wug _1tkep2n4 _z9soidpf _161z1wug _2a8rgktf _ikcg1wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                width: "1165",
                height: "330",
                viewBox: "0 0 1165 330",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "none",
                className: (0, $2jatx.default)([
                    "_kqswstnw _u7coidpf _dk5didpf _1bsb1osq _4t3ip2n4 _1gdluuw1"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M977.378 10.7676L977.217 24.9795L1150.09 15.0615L1164.88 273.931L204.614 329.028L201.528 275.049L0 272.822L3.0791 0L977.378 10.7676Z",
                    fill: "#1868DB"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_vwz4idpf _ca0qidpf _u5f353f4 _n3td53f4 _19bv53f4 _1h1t1hic _1bsb1osq _tl28idpf _axwi12am _1hwcymf6 _sp8t12am _1y2k1osq _z18o1wug _12hynqa1 _be8ucd5j _y8x4150w _l3jiyh40 _1wiko7ao",
                    "video-inner"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Video), {
                    loop: true,
                    playPauseButtonPosition: "bottom-left",
                    poster: showJiraPlusRovoHomepageChanges ? "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MPH2.jpg" : "https://dam-cdn.atl.orangelogic.com/AssetLink/g24hk1v4sy0080a3ooy73w8y305nfgdl.jpg",
                    src: showJiraPlusRovoHomepageChanges ? "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNDY.mp4" : "https://dam-cdn.atl.orangelogic.com/AssetLink/43tnm0uf541k3oxg33641f15m08hl7db.mp4"
                })
            })
        ]
    });
const $95dd56f96d9c3a4c$var$videoContainerStyles = null;
const $95dd56f96d9c3a4c$var$videoInnerStyles = null;
const $95dd56f96d9c3a4c$var$svgStyles = null;

});


parcelRegister("fVzh7", function(module, exports) {
/* homepage-tailored-onboarding.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $a9lfn = parcelRequire("a9lfn");

var $imIsw = parcelRequire("imIsw");

var $8EEDU = parcelRequire("8EEDU");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $dqd4k = parcelRequire("dqd4k");

var $28AH4 = parcelRequire("28AH4");
const $4660d88e1e8c930f$var$Tab = ({ tabData: tabData, tabIndex: tabIndex, setSelectedTeam: setSelectedTeam })=>{
    const { currentTab: currentTab } = (0, $a9lfn.useAdg4TabsContext)();
    const isSelected = currentTab === tabIndex;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $2fk4i.Button), {
        variant: "primary_alt",
        color: "black",
        "data-testid": `team-tab-${tabIndex}`,
        role: "tab",
        onClick: ()=>setSelectedTeam(tabData.team),
        dataEventProps: {
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "homepageTailoredOnboarding",
            "data-product-key": "home",
            "data-label": `${tabData.team || "default"} tab`,
            "data-track-event": "homepageTailoredOnboarding.teamTabClicked"
        },
        className: (0, $2jatx.default)([
            "_19it1vrj _bfhk1ret _1tkeckbl _ect41pz4 _k48pbfng _1wybgktf _6rtht94y _irr31ret _1dbzt7xp",
            isSelected && "_19it8djs _bfhk1oad"
        ]),
        style: {
            "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: tabData.tabIconSrc,
                    alt: "",
                    height: 26
                },
                className: (0, $2jatx.default)([
                    "_12l21y44 _kqswh2mm _152tt94y"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, tabData.tabText))
        ]
    });
};
const $4660d88e1e8c930f$export$1d1662e1e8d45bc8 = ()=>{
    const intl = (0, $8e22h.default)();
    const [selectedTeam, setSelectedTeam] = (0, $1oC0p.useState)("");
    const { setAnchorLocalStorage: setAnchorLocalStorage } = (0, $28AH4.useAnchorLocalStorage)();
    const { addTeamTypeCallback: addTeamTypeCallback } = (0, $dqd4k.useGupsStatus)();
    (0, $1oC0p.useEffect)(()=>{
        setAnchorLocalStorage({
            team: selectedTeam
        });
    }, [
        selectedTeam,
        setAnchorLocalStorage
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "home-page-tailored-onboarding",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1q51gktf _85i5ys9h _1u2qvbgk"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                id: "tailored-onboarding",
                "data-testid": "tailored-onboarding",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $a9lfn.Adg4Tabs), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTabList), {
                                rowGap: "12px",
                                className: (0, $2jatx.default)([
                                    "_bozg1wqb _y4ti1wqb _85i5ckbl _xlt11tcg _v736zwfg _chtuzwfg"
                                ]),
                                children: $4660d88e1e8c930f$export$1c43ad7c406043e5.map((item, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($4660d88e1e8c930f$var$Tab, {
                                            tabData: item,
                                            tabIndex: i,
                                            setSelectedTeam: setSelectedTeam
                                        })
                                    }, i))
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                            layout: "12",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                                children: $4660d88e1e8c930f$export$1c43ad7c406043e5.map((item, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4TabPanel), {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1mjb1ule _y44v3cxf _1e0c1txw _zulpgktf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_16jlkb7n _1o9zkb7n _i0dl1ssb _1e0c1txw _2lx21bp4 _dh1a1h6o"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_kqswh2mm _1e0c1txw _2lx21bp4 _6rthgktf _4cvr1y6m _ag851h6o _srwz19bv"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                                                className: (0, $2jatx.default)([
                                                                    "_1mouidpf _ca0qidpf _u5f3gktf _n3tdrdoj _19bvo7ao _1wyb1yij _zg8l4jg8 _k48p1ske _vwz413tr _1cqs1iqr _1bys1nf8 _11cggktf _xsmr1h6o"
                                                                ]),
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                                    id: "HomePageTemplateV2.tailoredOnboarding.tab.jiraStart",
                                                                    defaultMessage: "{tabText}{newline}starts with Jira",
                                                                    values: {
                                                                        tabText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, item.highlightedPanelHeader)),
                                                                        newline: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
                                                                    },
                                                                    description: "String describing Jira capabilities. The newline is used to put the team type (ex. 'Operations') on its own line in English."
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                            className: (0, $2jatx.default)([
                                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1txs _vwz41vom _6rthzwfg _ahbq19bv _k48pl8b6 _xsmr1h6o"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, item.panelSubText))
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                                            dataEventProps: {
                                                                "data-event": "clicked",
                                                                "data-event-component": "linkButton",
                                                                "data-event-container": "homepageTailoredOnboarding",
                                                                "data-product-key": "home",
                                                                "data-label": `${item.team || "default"} cta button`,
                                                                "data-track-event": "homepageTailoredOnboarding.ctaClicked"
                                                            },
                                                            href: "/try/cloud/signup?bundle=jira-software&edition=free",
                                                            onClick: ()=>item.team && addTeamTypeCallback(item.team.toLowerCase()),
                                                            className: (0, $2jatx.default)([
                                                                "_ahbq19bv _1bsb1ns9 _suga1ule _xsmr1h6o _11cgidpf _1rfm1ns9"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), (0, $6ogO3._)({}, item.panelCtaText))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_16jlkb7n _1o9zkb7n _i0dl1ssb _xc2ickbl"
                                                    ]),
                                                    children: item.panelVideo ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8EEDU.default), {
                                                        videoLink: item.panelVideo.src,
                                                        videoPreviewImage: item.panelVideo.previewImg,
                                                        loop: false,
                                                        className: (0, $2jatx.default)([
                                                            "_p12f1osq _1bsb1osq _4t3i1wug _1e0c1ule _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _mkrz11ys"
                                                        ])
                                                    }) : item.panelImg && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                        image: {
                                                            src: item.panelImg.src,
                                                            alt: intl.formatMessage(item.panelImg.alt),
                                                            height: 662,
                                                            width: 1000
                                                        },
                                                        style: {
                                                            maxWidth: "100%",
                                                            width: "100%",
                                                            height: "auto"
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    }, i))
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $4660d88e1e8c930f$var$sectionStyle = null;
const $4660d88e1e8c930f$var$tabListStyles = null;
const $4660d88e1e8c930f$var$buttonStyle = null;
const $4660d88e1e8c930f$var$selectedButtonStyle = null;
const $4660d88e1e8c930f$var$iconStyle = null;
const $4660d88e1e8c930f$var$videoPhotoStyle = null;
const $4660d88e1e8c930f$var$teamTypeContainerStyle = null;
const $4660d88e1e8c930f$var$fadein = null;
const $4660d88e1e8c930f$var$panelWrapperStyle = null;
const $4660d88e1e8c930f$var$panelContainerLeftStyle = null;
const $4660d88e1e8c930f$var$panelContainerRightStyle = null;
const $4660d88e1e8c930f$var$teamTypeStyle = null;
const $4660d88e1e8c930f$var$subtextStyle = null;
const $4660d88e1e8c930f$var$buttonCTAStyle = null;
const $4660d88e1e8c930f$export$1c43ad7c406043e5 = [
    {
        // blank string is used for default team type value
        team: "",
        tabIconSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/0e62epv43p2037hf1y6mpjn63k4027cx.svg",
        tabText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab1.tabText",
            defaultMessage: "All teams"
        }),
        highlightedPanelHeader: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab1.highlitedPanelHeader",
            defaultMessage: "Team success"
        }),
        panelSubText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab1.panelSubText",
            defaultMessage: "The only tool your team needs to plan and track work."
        }),
        panelCtaText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab1.panelCtaText",
            defaultMessage: "Get started free"
        }),
        panelCtaHref: "/try/cloud/signup?bundle=jira-software&edition=free",
        panelVideo: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/sjjc8k61bt08n608k5hlutfd3xapk48l.mp4",
            previewImg: "https://dam-cdn.atl.orangelogic.com/AssetLink/658m24w7wy4w643oow72d7t7hmat68t5.webp",
            alt: (0, $fnHPc.defineMessage)({
                id: "HomePageTemplateV2.tailoredOnboarding.tab1.panelVdAlt",
                defaultMessage: "This is a video of a to-do ticket on a Jira board being edited and a ticket being dragged from in review to done."
            })
        }
    },
    {
        team: "Marketing",
        tabIconSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/22p021mt32j31e1rb4861r1v521r0g0u.svg",
        tabText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab2.tabText",
            defaultMessage: "Marketing"
        }),
        highlightedPanelHeader: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab2.highlitedPanelHeader",
            defaultMessage: "Marketing"
        }),
        panelSubText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab2.panelSubText",
            defaultMessage: "From simple tasks to complex projects, manage marketing the smart way - with Jira."
        }),
        panelCtaText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab2.panelCtaText",
            defaultMessage: "Get Jira for Marketing free"
        }),
        panelCtaHref: "/try/cloud/signup?bundle=jira-software&edition=free",
        panelImg: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7stxu0as4vhbl8a7y704cx600407x3fc.webp",
            alt: (0, $fnHPc.defineMessage)({
                id: "HomePageTemplateV2.tailoredOnboarding.tab2.panelImgAlt",
                defaultMessage: "This is an image of Marketing team setting a Jira epic to on track."
            })
        }
    },
    {
        team: "Software Engineering",
        tabIconSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/077n3d25i15ei74w8j0orf15jfdsg7r4.svg",
        tabText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab3.tabText",
            defaultMessage: "Engineering"
        }),
        highlightedPanelHeader: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab3.highlitedPanelHeader",
            defaultMessage: "Engineering"
        }),
        panelSubText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab3.panelSubText",
            defaultMessage: "Build great software with simplified planning, tracking, and release management."
        }),
        panelCtaText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab3.panelCtaText",
            defaultMessage: "Get Jira for Engineering free"
        }),
        panelCtaHref: "/try/cloud/signup?bundle=jira-software&edition=free",
        panelImg: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2a50t076ayl168w5gfbbf5o77834b3c7.webp",
            alt: (0, $fnHPc.defineMessage)({
                id: "HomePageTemplateV2.tailoredOnboarding.tab3.panelImgAlt",
                defaultMessage: "This is an image of a Jira ticket being dragged from in progress to done by an Engineer."
            })
        }
    },
    {
        team: "Design",
        tabIconSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/64wphwx7cxsk1tln85ol827hv7d253l6.svg",
        tabText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab4.tabText",
            defaultMessage: "Design"
        }),
        highlightedPanelHeader: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab4.highlitedPanelHeader",
            defaultMessage: "Design"
        }),
        panelSubText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab4.panelSubText",
            defaultMessage: "Align with product, share designs, and meet deadlines - all without sacrificing creativity."
        }),
        panelCtaText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab4.panelCtaText",
            defaultMessage: "Get Jira for Design free"
        }),
        panelCtaHref: "/try/cloud/signup?bundle=jira-software&edition=free",
        panelImg: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/s16vwa08laqgd4045o343155ux8g8m7w.webp",
            alt: (0, $fnHPc.defineMessage)({
                id: "HomePageTemplateV2.tailoredOnboarding.tab4.panelImgAlt",
                defaultMessage: "This is an image of a Jira ticket being marked as ready for dev by a Designer."
            })
        }
    },
    {
        team: "Operations",
        tabIconSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/e1we7gna82f185x4877hy4sk3m0exnjt.svg",
        tabText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab5.tabText",
            defaultMessage: "Operations"
        }),
        highlightedPanelHeader: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab5.panelHeader",
            defaultMessage: "Operations"
        }),
        panelSubText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab5.panelSubText",
            defaultMessage: "From control processes to resource management, conquer complex workflows and quickly deliver results - with Jira."
        }),
        panelCtaText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab5.panelCtaText",
            defaultMessage: "Get Jira for Operations free"
        }),
        panelCtaHref: "/try/cloud/signup?bundle=jira-software&edition=free",
        panelImg: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kkym8cjo15d2745w444q84ii7r4c616c.webp",
            alt: (0, $fnHPc.defineMessage)({
                id: "HomePageTemplateV2.tailoredOnboarding.tab5.panelImgAlt",
                defaultMessage: "This is an image of work being linked to a goal by an Operations Manager."
            })
        }
    },
    {
        team: "Customer Service",
        tabIconSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/xim145006ni54kwkp7i5bn31go457s42.svg",
        tabText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab6.tabText",
            defaultMessage: "IT"
        }),
        highlightedPanelHeader: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab6.panelHeader",
            defaultMessage: "IT"
        }),
        panelSubText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab6.panelSubText",
            defaultMessage: "From issue tracking to change management, streamline IT projects and deliver reliable services to internal teams."
        }),
        panelCtaText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tailoredOnboarding.tab6.panelCtaText",
            defaultMessage: "Get Jira for IT free"
        }),
        panelCtaHref: "/try/cloud/signup?bundle=jira-software&edition=free",
        panelImg: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3m2ramre5k810mu1k7dwg248f0tfa4ha.webp",
            alt: (0, $fnHPc.defineMessage)({
                id: "HomePageTemplateV2.tailoredOnboarding.tab6.panelImgAlt",
                defaultMessage: "This is an image of a Jira ticket being dragged from in progress to done by IT."
            })
        }
    }
];
$4660d88e1e8c930f$export$1d1662e1e8d45bc8.displayName = "HomepageTailoredOnboarding";

});

parcelRegister("jaEEJ", function(module, exports) {
$parcel$export(module.exports, "Integrations", function () { return $e59144436ed43260$export$99d02219d259eb94; });
/* integrations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $hLJF4 = parcelRequire("hLJF4");
var $7za1x = parcelRequire("7za1x");

var $5qUgh = parcelRequire("5qUgh");

var $a9lfn = parcelRequire("a9lfn");

var $1gaTq = parcelRequire("1gaTq");
const $e59144436ed43260$export$99d02219d259eb94 = ()=>{
    const intl = (0, $8e22h.default)();
    const { currentTab: currentTab } = (0, $a9lfn.useAdg4TabsContext)();
    const getLeftContextDrivenLogos = (0, $1oC0p.useCallback)(()=>{
        var _CONTEXTUAL_LOGOS_currentTab;
        return ((_CONTEXTUAL_LOGOS_currentTab = (0, $1gaTq.CONTEXTUAL_LOGOS)[currentTab]) === null || _CONTEXTUAL_LOGOS_currentTab === void 0 ? void 0 : _CONTEXTUAL_LOGOS_currentTab.leftRowTwoLogoData) || (0, $1gaTq.FALLBACK_LOGOS).leftRowTwoLogoData;
    }, [
        currentTab
    ]);
    const getRightContextDrivenLogos = (0, $1oC0p.useCallback)(()=>{
        var _CONTEXTUAL_LOGOS_currentTab;
        return ((_CONTEXTUAL_LOGOS_currentTab = (0, $1gaTq.CONTEXTUAL_LOGOS)[currentTab]) === null || _CONTEXTUAL_LOGOS_currentTab === void 0 ? void 0 : _CONTEXTUAL_LOGOS_currentTab.rightRowTwoLogoData) || (0, $1gaTq.FALLBACK_LOGOS).rightRowTwoLogoData;
    }, [
        currentTab
    ]);
    const [leftRowTwoData, setLeftRowTwoData] = (0, $1oC0p.useState)(getLeftContextDrivenLogos());
    const [rightRowTwoData, setRightRowTwoData] = (0, $1oC0p.useState)(getRightContextDrivenLogos());
    (0, $1oC0p.useEffect)(()=>{
        setLeftRowTwoData(getLeftContextDrivenLogos());
        setRightRowTwoData(getRightContextDrivenLogos());
    }, [
        currentTab,
        getLeftContextDrivenLogos,
        getRightContextDrivenLogos
    ]);
    const renderLogos = (0, $1oC0p.useMemo)(()=>(data, shouldUseTooltip, toolTipPosition)=>{
            return data.map((logoData, i)=>{
                if (shouldUseTooltip) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
                        position: toolTipPosition,
                        delay: 300,
                        // @ts-ignore
                        component: (0, $7za1x.default),
                        content: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _ca0q19bv _u5f37vkz _n3td19bv _19bv7vkz _1e0c116y _1bah1h6o _4cvr1h6o _y3gn1h6o _2rkoi2wt _19it1ymx _bfhku67f _16qs1wkx _p12fp3fh"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1mouidpf",
                                    "body-sm"
                                ]),
                                children: intl.formatMessage(logoData.tooltipText)
                            })
                        }),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1h1t1ekt _16jlidpf _1o9zidpf _i0dl18ly _p12f18ly _c71l18ly _1bsb1osq _4t3i1osq _2rko1tcg _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _16qsidbf _1tvsidpf _1bzwidpf _1a8l8ved _1s4p8ved _1kne8ved _e74x73ad _1l9u1crf",
                                "logo-square"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                src: logoData.src,
                                alt: intl.formatMessage(logoData.alt),
                                className: (0, $2jatx.default)([
                                    "_1bsb18ly _4t3i1wug _1s4p1osq"
                                ])
                            })
                        })
                    })
                }, i);
                else return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1h1t1ekt _16jlidpf _1o9zidpf _i0dl18ly _p12f18ly _c71l18ly _1bsb1osq _4t3i1osq _2rko1tcg _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _16qsidbf _1tvsidpf _1bzwidpf _1a8l8ved _1s4p8ved _1kne8ved _e74x73ad _1l9u1crf",
                            "logo-square"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                            src: logoData.src,
                            alt: intl.formatMessage(logoData.alt),
                            className: (0, $2jatx.default)([
                                "_1bsb18ly _4t3i1wug _1s4p1osq"
                            ])
                        })
                    })
                }, i);
            });
        }, [
        intl
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-integrations",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            id: "integrations",
            className: (0, $2jatx.default)([
                "_1pfh1ylp _6rth1ylp _1q51gktf _85i5gktf"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1q517l9q _85i5d36x _p12f1git _kqswh2mm _bfhk1ret _mkrz1cdq _1reo15vq _18m915vq _1bah1h6o _1e0c1txw _19pkidpf _2hwx1wug _otyridpf _18u01wug _na0i1bp4 _dh1a1h6o _2osn1ylp _xc2i1lit _144t1j4a"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _10m4idpf _1vdkidpf _1wznuxkd"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1osq _1e02idpf _t9eccq4l _1mjbglyw",
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _2lx21bp4 _85i5yh40 _13wnstnw _glte1yu0 _180k1ssb"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulp1ylp _2osnd4y9",
                                            "_1bahesu3",
                                            "_kqswh2mm _rjxpi2wt"
                                        ]),
                                        children: renderLogos((0, $1gaTq.DEFAULT_LOGOS).leftRowOneData, true, "top-start")
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulp1ylp _2osnd4y9",
                                            "_1bahesu3",
                                            "_1q511ylp _kqswh2mm _1e02d439"
                                        ]),
                                        children: renderLogos(leftRowTwoData, true, "bottom-start")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulpv47k _y3gn1h6o _p12f1vif _1ul9nklw _bozggktf _y4tigktf _pdlmxy5q"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_1pfhidpf _6rthidpf"
                                        ]),
                                        children: intl.formatMessage({
                                            id: "HomePageTemplateV2.IntegrationsHeader",
                                            defaultMessage: "Connect your favorite tools with ours"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1pfhidpf _6rthidpf",
                                            "body-lg"
                                        ]),
                                        children: intl.formatMessage({
                                            id: "HomePageTemplateV2.IntegrationsDescription",
                                            defaultMessage: "Explore thousands of apps and integrations on the Marketplace"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                        href: "https://marketplace.atlassian.com/",
                                        variant: "secondary",
                                        color: "black",
                                        dataEventProps: {
                                            "data-product-key": "home",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "ctaSection",
                                            "data-label-english": "See all integrations"
                                        },
                                        children: intl.formatMessage({
                                            id: "HomePageTemplateV2.IntegrationsCtaButton",
                                            defaultMessage: "See all integrations"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1bahesu3 _rjxpidpf _16jlkb7n _1o9zkb7n _i0dl1osq _t9ec1vvq _1mjbglyw",
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _2lx21bp4 _85i5yh40 _13wnstnw _glte1yu0 _180k1ssb"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulp1ylp _2osnd4y9",
                                            "_1bah1y6m",
                                            "_kqswh2mm _rjxpyjp0"
                                        ]),
                                        children: renderLogos((0, $1gaTq.DEFAULT_LOGOS).rightRowOneData, true, "top-end")
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1txw _zulp1ylp _2osnd4y9",
                                            "_1bah1y6m",
                                            "_1q511ylp _kqswh2mm _rjxpd439"
                                        ]),
                                        children: renderLogos(rightRowTwoData, true, "bottom-end")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1bah1h6o _ca0qidpf _u5f31ylp _n3tdidpf _19bv1ylp _1bsb1osq _zulp1ylp _dm25glyw",
                            "_1e0c1txw _4cvr1h6o _1bah1h6o _2lx21bp4 _85i5yh40 _13wnstnw _glte1yu0 _180k1ssb"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _zulp1ylp _2osnd4y9",
                                    "_1bah1h6o"
                                ]),
                                children: renderLogos((0, $1gaTq.DEFAULT_LOGOS).leftRowOneData, false)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _zulp1ylp _2osnd4y9",
                                    "_1bah1h6o"
                                ]),
                                children: renderLogos([
                                    ...leftRowTwoData,
                                    ...rightRowTwoData
                                ], false)
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _zulp1ylp _2osnd4y9",
                                    "_1bah1h6o"
                                ]),
                                children: renderLogos((0, $1gaTq.DEFAULT_LOGOS).rightRowOneData, false)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $e59144436ed43260$var$sectionStyle = null;
const $e59144436ed43260$var$outerWrapperStyles = null;
const $e59144436ed43260$var$mainContentWrapperStyle = null;
const $e59144436ed43260$var$mainContentContainerStyle = null;
const $e59144436ed43260$var$headerStyles = null;
const $e59144436ed43260$var$pStyles = null;
const $e59144436ed43260$var$logosRowStyle = null;
const $e59144436ed43260$var$tooltipStyle = null;
const $e59144436ed43260$var$tooltipTextStyle = null;
const $e59144436ed43260$var$logosWrapperStyle = null;
const $e59144436ed43260$var$logosLeftStyle = null;
const $e59144436ed43260$var$logosLeftRowStyle = null;
const $e59144436ed43260$var$logosLeftRowOneStyle = null;
const $e59144436ed43260$var$logosLeftRowTwoStyle = null;
const $e59144436ed43260$var$logosRightStyles = null;
const $e59144436ed43260$var$logosRightRowStyle = null;
const $e59144436ed43260$var$logosRightRowOneStyle = null;
const $e59144436ed43260$var$logosRightRowTwoStyle = null;
const $e59144436ed43260$var$logosMobileStyle = null;
const $e59144436ed43260$var$logosMobileRowStyle = null;
const $e59144436ed43260$var$logoSquareStyle = null;
const $e59144436ed43260$var$logoImgStyle = null;

});
parcelRegister("1gaTq", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOGOS", function () { return $973229a92079b618$export$d891dc3ddefe3371; });
$parcel$export(module.exports, "FALLBACK_LOGOS", function () { return $973229a92079b618$export$61331b2e03963be3; });
$parcel$export(module.exports, "CONTEXTUAL_LOGOS", function () { return $973229a92079b618$export$6c29979e1b23b596; });

var $6ogO3 = parcelRequire("6ogO3");

var $fnHPc = parcelRequire("fnHPc");
//logo tooltip text and layout as determined in https://hello.atlassian.net/wiki/spaces/~396457966/pages/3547054814/WAC+homepage+-+Integrations+tooltips
const $973229a92079b618$export$6db7d552900abad1 = {
    airtable: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/air-table-3638621307.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsAirtableAltTxt",
            defaultMessage: "Airtable logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsAirtableTooltip",
            defaultMessage: "Embed Airtable bases, views, and forms in Confluence"
        })
    },
    asana: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/asana-363871342.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsAsanaAltTxt",
            defaultMessage: "Asana logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsAsanaTooltip",
            defaultMessage: "Sync Asana and Jira tasks and embed interactive task previews in either tool"
        })
    },
    balsamiq: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/balsamiq-1570513082.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsBalsamiqAltTxt",
            defaultMessage: "Balsamiq logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsBalsamiqTooltip",
            defaultMessage: "Present Balsamiq wireframes and prototypes in beautiful Confluence reports and design docs"
        })
    },
    canva: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/canva-363018985.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsCanvaAltTxt",
            defaultMessage: "Canva logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsCanvaTooltip",
            defaultMessage: "Collaborate on graphics and marketing content for company-wide access to beautiful designs"
        })
    },
    figma: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/figma-363833302.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsFigmaAltTxt",
            defaultMessage: "Figma logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsFigmaTooltip",
            defaultMessage: "Embed and edit files in Confluence pages"
        })
    },
    github: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/github-3505995671.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGitHubAltTxt",
            defaultMessage: "GitHub logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGitHubTooltip",
            defaultMessage: "Track branches, pull request, and commits in Jira"
        })
    },
    gitLab: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/git-lab-204839338.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGitLabAltTxt",
            defaultMessage: "GitLab logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGitLabTooltip",
            defaultMessage: "Update Jira issues, comment, and change task statuses from GitLab"
        })
    },
    googleAnalytics: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-analytics-3286988256.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGoogleAnalyticsAltTxt",
            defaultMessage: "Google Analytics logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGoogleAnalyticsTooltip",
            defaultMessage: "Sync and embed customer analytics alongside notes and reports"
        })
    },
    googleDocs: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-docs-2740153165.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGoogleDocsAltTxt",
            defaultMessage: "Google Docs logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGoogleDocsTooltip",
            defaultMessage: "Sync docs in Confluence keep info in one place"
        })
    },
    googleDrive: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-drive-2276762714.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGoogleDriveAltTxt",
            defaultMessage: "Google Drive logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGoogleDriveTooltip",
            defaultMessage: "Embed and edit files in Confluence pages"
        })
    },
    googleSheets: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/google-sheets-1718541418.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGoogleSheetsAltTxt",
            defaultMessage: "Google Sheets Plan logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsGoogleSheetsTooltip",
            defaultMessage: "Analyze Google Sheets data directly in Confluence pages and Jira issues"
        })
    },
    hotjar: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/hot-jar-1014134517.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsHotjarAltTxt",
            defaultMessage: "Hotjar logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsHotjarTooltip",
            defaultMessage: "Sync and embed customer research recordings and data alongside notes or reports"
        })
    },
    hubSpot: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/hubspot-3684386805.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsHubSpotAltTxt",
            defaultMessage: "HubSpot logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsHubSpotTooltip",
            defaultMessage: "Connect your support and dev teams to resolve customer issues faster"
        })
    },
    jenkins: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jenkins-214038284.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsJenkinsAltTxt",
            defaultMessage: "Jenkins logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsJenkinsTooltip",
            defaultMessage: "View Jenkins builds and deployments in Jira"
        })
    },
    launchDarkly: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/launch-darkly-198811051.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsLaunchDarklyAltTxt",
            defaultMessage: "Launch Darkly logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsLaunchDarklyTooltip",
            defaultMessage: "Create, connect, and link LaunchDarkly feature flags to Jira"
        })
    },
    mailchimp: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/mailchimp-1767865028.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsMailchimpAltTxt",
            defaultMessage: "Mailchimp logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsMailchimpTooltip",
            defaultMessage: "Transform leads to success by surfacing Mailchimp campaigns to all teams"
        })
    },
    microsoft365: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/microsoft-365-3971673211.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsMicrosoft365AltTxt",
            defaultMessage: "Microsoft 365 logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsMicrosoft365Tooltip",
            defaultMessage: "Add Jira issue details to your MS Office tools"
        })
    },
    microsoftTeams: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group%206273011-2525946013.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsMicrosoftTeamsAltTxt",
            defaultMessage: "Microsoft Teams logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsMicrosoftTeamsTooltip",
            defaultMessage: "View and update issues directly from MS Teams"
        })
    },
    miro: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273207-554690744.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsMiroAltTxt",
            defaultMessage: "Miro logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsMiroTooltip",
            defaultMessage: "Embed and edit files in Confluence pages"
        })
    },
    monday: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/monday-3089500834.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsMondayAltTxt",
            defaultMessage: "Monday.com logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsMondayTooltip",
            defaultMessage: "Share boards and tasks across Monday.com and Jira to keep teams in sync"
        })
    },
    pendo: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/pendo-379684898.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsPendoAltTxt",
            defaultMessage: "Pendo logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsPendoTooltip",
            defaultMessage: "Capture Pendo customer feature requests and data in Jira & Confluence"
        })
    },
    productPlan: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273205-1701574714.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsProductPlanAltTxt",
            defaultMessage: "Product Plan logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsProductPlanTooltip",
            defaultMessage: "Quickly embed live roadmaps in Confluence pages to share with your team"
        })
    },
    qMetry: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Group 6273206-2473828409.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsQMetryAltTxt",
            defaultMessage: "QMetry logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsQMetryTooltip",
            defaultMessage: "Embed and edit files in Confluence pages"
        })
    },
    salesforce: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/salesforce-2848088583.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsSalesforceAltTxt",
            defaultMessage: "Salesforce logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsSalesforceTooltip",
            defaultMessage: "Link customer and technical info between Salesforce & Jira to improve customer acquisition"
        })
    },
    scriptrunner: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/script-runner-1229978336.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsScriptrunnerAltTxt",
            defaultMessage: "Scriptrunner logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsScriptrunnerTooltip",
            defaultMessage: "Automate and customize your team\u2019s workflows with simple, powerful scripts in Confluence and Jira"
        })
    },
    serviceNow: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/service-now-3403321428.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsServiceNowAltTxt",
            defaultMessage: "ServiceNow logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsServiceNowTooltip",
            defaultMessage: "Auto-sync incidents, assets, and tasks between ServiceNow and Jira"
        })
    },
    slack: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/slack-375335524.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsSlackAltTxt",
            defaultMessage: "Slack logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsSlackTooltip",
            defaultMessage: "Work on Jira issues without leaving Slack"
        })
    },
    smartsheet: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/smartsheet-2509293444.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsSmartsheetAltTxt",
            defaultMessage: "Smartsheet Plan logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsSmartsheetTooltip",
            defaultMessage: "Embed Smartsheet grids, Gantt charts, cards, and calendars in Confluence"
        })
    },
    statsig: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/statsig-4214018365.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsStatsigAltTxt",
            defaultMessage: "Statsig Plan logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsStatsigTooltip",
            defaultMessage: "Link Statsig feature gates, metric data, and test results directly in Jira"
        })
    },
    wrike: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/wrike-368502576.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsWrikeAltTxt",
            defaultMessage: "Wrike logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsWrikeTooltip",
            defaultMessage: "Sync and migrate Wrike projects to Jira, or customize project workflows with scripts"
        })
    },
    zendesk: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/zendesk-97087002.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsZendeskAltTxt",
            defaultMessage: "Zendesk logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsZendeskTooltip",
            defaultMessage: "Streamline workflows between Zendesk support tickets and Jira issues"
        })
    },
    zoom: {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/zoom-1703389861.webp",
        alt: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsZoomAltTxt",
            defaultMessage: "Zoom logo"
        }),
        tooltipText: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.IntegrationsZoomTooltip",
            defaultMessage: "Stay updated on Jira and Confluence work right in Zoom chat"
        })
    }
};
// "rowOne" logos stay the same for all contexts
const $973229a92079b618$export$d891dc3ddefe3371 = {
    leftRowOneData: [
        (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.googleDrive),
        (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.googleDocs),
        (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.slack)
    ],
    rightRowOneData: [
        (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.microsoftTeams),
        (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.zoom),
        (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.microsoft365)
    ]
};
const $973229a92079b618$export$61331b2e03963be3 = {
    leftRowTwoLogoData: [
        (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.github),
        (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.jenkins)
    ],
    rightRowTwoLogoData: [
        (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.launchDarkly),
        (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.gitLab)
    ]
};
const $973229a92079b618$export$6c29979e1b23b596 = [
    // "Software"
    {
        leftRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.github),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.jenkins)
        ],
        rightRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.launchDarkly),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.gitLab)
        ]
    },
    // "Product management"
    {
        leftRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.productPlan),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.pendo)
        ],
        rightRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.statsig),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.airtable)
        ]
    },
    // "Marketing"
    {
        leftRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.salesforce),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.hubSpot)
        ],
        rightRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.googleAnalytics),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.mailchimp)
        ]
    },
    // "Project management"
    {
        leftRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.asana),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.monday)
        ],
        rightRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.googleSheets),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.smartsheet)
        ]
    },
    // "Design"
    {
        leftRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.figma),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.balsamiq)
        ],
        rightRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.canva),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.hotjar)
        ]
    },
    // "IT"
    {
        leftRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.scriptrunner),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.zendesk)
        ],
        rightRowTwoLogoData: [
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.wrike),
            (0, $6ogO3._)({}, $973229a92079b618$export$6db7d552900abad1.serviceNow)
        ]
    }
];

});


parcelRegister("ZhzbO", function(module, exports) {
$parcel$export(module.exports, "JiraLoggedInHeader", function () { return $d0cdc09a16d1ff5c$export$e58bafc09137765e; });
/* jira-logged-in-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $5qUgh = parcelRequire("5qUgh");

var $l22jm = parcelRequire("l22jm");

var $kooLp = parcelRequire("kooLp");

var $cSmPq = parcelRequire("cSmPq");
const $d0cdc09a16d1ff5c$var$jiraWordBoldStyles = null;
/** Hides the line break on small viewports so the description flows without a forced break. */ const $d0cdc09a16d1ff5c$var$subtitleLineBreakDesktopOnlyStyles = null;
const $d0cdc09a16d1ff5c$var$TeamsFormatter = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $l22jm.Adg4TextUnderline), {
        underline: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
            width: "100%",
            height: "30",
            viewBox: "0 0 306 42",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z",
                fill: "#FFA900"
            })
        }),
        children: children
    });
const $d0cdc09a16d1ff5c$export$e58bafc09137765e = ({ gwp10965XflowRecommendation: gwp10965XflowRecommendation = false, showJiraPlusRovoHomepageChanges: showJiraPlusRovoHomepageChanges = false } = {})=>{
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free");
    const crossflowEventContainer = gwp10965XflowRecommendation ? "crossflowHeroSectionV2Variant" : "heroSection";
    const teamsFormatter = (0, $1oC0p.useCallback)((str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($d0cdc09a16d1ff5c$var$TeamsFormatter, {
            children: str
        }), []);
    const jiraWordBoldFormatter = (0, $1oC0p.useCallback)((str)=>/*#__PURE__*/ (0, $7VQPk.jsx)("span", {
            className: (0, $2jatx.default)([
                "_k48p1fw0"
            ]),
            children: str
        }), []);
    const formattedValues = (0, $1oC0p.useMemo)(()=>({
            teams: teamsFormatter,
            br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
            jiraWord: jiraWordBoldFormatter,
            subtitleBr: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {
                className: (0, $2jatx.default)([
                    "_sugaglyw"
                ])
            })
        }), [
        teamsFormatter,
        jiraWordBoldFormatter
    ]);
    const renderHeroTitle = ()=>{
        if (showJiraPlusRovoHomepageChanges) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "HomePageTemplateV2.jiraHeroGwp10906",
            defaultMessage: "Unleash your{br}<teams>human+AI</teams> superteam",
            values: formattedValues
        });
        if (gwp10965XflowRecommendation) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "HomePageTemplateV2.jiraHeroVariant",
            defaultMessage: "<jiraWord>Jira</jiraWord> projects that practically{br}<teams>manage</teams> themselves",
            values: formattedValues
        });
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "HomePageTemplateV2.jiraHeroGwp9758",
            defaultMessage: "Projects that practically{br}<teams>manage</teams> themselves",
            values: formattedValues
        });
    };
    const renderSubtitle = ()=>{
        if (showJiraPlusRovoHomepageChanges) return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            className: (0, $2jatx.default)([
                "_15o31k92 _nsiz19ii _1ym71h6o _ovrmo7ao _t1qc1wug _jghz19bv _h8ac1wug",
                "hero-description"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "HomePageTemplateV2.jiraHeroGwp10906Description",
                defaultMessage: "Everyone. Working on the right things, including your AI agents.{br}Jira is where teams and agents come together to plan, execute, and deliver outcomes.",
                values: formattedValues
            })
        });
        return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
            className: (0, $2jatx.default)([
                "_15o31k92 _nsiz19ii _1ym71h6o _ovrmo7ao _t1qc1wug _jghz19bv _h8ac1wug",
                "hero-description"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                id: "HomePageTemplateV2.jiraHeroGwp9758Description",
                defaultMessage: "Introducing project management skills in Jira.{subtitleBr} Dream bigger and move faster with AI.",
                values: formattedValues
            })
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _6a6z1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                className: (0, $2jatx.default)([
                    "_1mou8jkm _y3gn1h6o",
                    "superhero-contrast"
                ]),
                children: renderHeroTitle()
            }),
            renderSubtitle(),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _zulp1tcg _1pfh1tcg _6rth1ylp _476dgktf _srwz66rk"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                        variant: "primary",
                        color: "blue",
                        href: signupLink,
                        dataEventProps: {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": crossflowEventContainer,
                            "data-product-key": "home",
                            "data-label-english": "Get started"
                        },
                        className: (0, $2jatx.default)([
                            "_1mouidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "HomePageTemplateV2.jiraHero.getStartedCtaButton",
                            defaultMessage: "Get started"
                        })
                    }),
                    gwp10965XflowRecommendation && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cSmPq.ContactSalesLink), {})
                ]
            })
        ]
    });
};
const $d0cdc09a16d1ff5c$var$containerStyles = null;
const $d0cdc09a16d1ff5c$var$heroTitleStyles = null;
const $d0cdc09a16d1ff5c$var$ctaContainerStyles = null;
const $d0cdc09a16d1ff5c$var$heroGetStartedStyles = null;
const $d0cdc09a16d1ff5c$var$descriptionStyles = null;

});
parcelRegister("cSmPq", function(module, exports) {
$parcel$export(module.exports, "ContactSalesLink", function () { return $f0786d67cef3119e$export$e5ff252a92823321; });
$parcel$export(module.exports, "ReusableCrossflowHeroComponent", function () { return $f0786d67cef3119e$export$aefd856850d8c2bf; });
$parcel$export(module.exports, "default", function () { return $f0786d67cef3119e$export$2e2bcd8739ae039; });
/* reusable-xflow-hero-templates.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $2lwXu = parcelRequire("2lwXu");

var $je135 = parcelRequire("je135");
const $f0786d67cef3119e$var$contactSalesMessage = (0, $fnHPc.defineMessage)({
    id: "HomePageTemplateV2.crossflowHero.contactSales",
    defaultMessage: "Contact Sales"
});
const $f0786d67cef3119e$export$e5ff252a92823321 = ({ onAction: onAction } = {})=>{
    const intl = (0, $8e22h.default)();
    const label = intl.formatMessage($f0786d67cef3119e$var$contactSalesMessage);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
        href: (0, $kooLp.useLocalizedHref)("/enterprise/contact"),
        "aria-label": label,
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": "crossflowHeroSectionV2Variant",
        "data-product-key": "home",
        "data-label-english": "Contact sales",
        "data-label": label,
        onClick: onAction,
        className: (0, $2jatx.default)([
            "_1e0c116y _4cvr1h6o _zulp1y44 _1wyb7vkz _k48pbfng _syazjk2v _4bfu1r31 _1hmsglyw _ajmmnqa1 _nkm1ftgi"
        ]),
        style: {
            "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
        },
        children: [
            label,
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_1e0c116y _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2lwXu.ArrowRightNoCircle), {})
            })
        ]
    });
};
const $f0786d67cef3119e$export$aefd856850d8c2bf = ({ heroTitle: heroTitle, heroSubtitle: heroSubtitle, ctaButton: ctaButton, contentComponent: ContentComponent, segmentName: segmentName = "reusable-crossflow-hero", sectionId: sectionId = "reusable-crossflow-hero", scrollTrackingSection: scrollTrackingSection = "reusable-crossflow-hero", gwp10965XflowRecommendation: gwp10965XflowRecommendation = false })=>{
    var _ctaButton_eventProps, _ctaButton_eventProps1, _ctaButton_eventProps2, _ctaButton_eventProps3;
    const crossflowEventContainer = gwp10965XflowRecommendation ? "crossflowHeroSectionV2Variant" : "crossflowHeroSectionV2Control";
    var _ctaButton_buttonText, _ctaButton_buttonText1;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: segmentName,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
            section: scrollTrackingSection,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
                id: sectionId,
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _1reo15vq _18m915vq _6rthxncg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _6a6z1h6o _1pfhzwfg _6rthckbl _476d7vkz _srwzzwfg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_1mou8jkm _y3gn1h6o _11cg7vkz _11787vkz",
                                    "superhero-contrast"
                                ]),
                                children: heroTitle
                            }),
                            heroSubtitle,
                            ctaButton && (gwp10965XflowRecommendation ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _zulpzwfg _1pfhzwfg"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                        variant: ctaButton.buttonVariant || "primary",
                                        href: ctaButton.buttonHref,
                                        color: ctaButton.buttonColor || "blue",
                                        "aria-label": (_ctaButton_buttonText = ctaButton.buttonText) !== null && _ctaButton_buttonText !== void 0 ? _ctaButton_buttonText : "Get started",
                                        "aria-describedby": "cta-button",
                                        dataEventProps: {
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": crossflowEventContainer,
                                            "data-product-key": "home",
                                            "data-label-english": (_ctaButton_eventProps = ctaButton.eventProps) === null || _ctaButton_eventProps === void 0 ? void 0 : _ctaButton_eventProps.labelEnglish,
                                            "data-label": (_ctaButton_eventProps1 = ctaButton.eventProps) === null || _ctaButton_eventProps1 === void 0 ? void 0 : _ctaButton_eventProps1.label
                                        },
                                        className: (0, $2jatx.default)([
                                            "_1mouidpf"
                                        ]),
                                        children: ctaButton.buttonText
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($f0786d67cef3119e$export$e5ff252a92823321, {})
                                ]
                            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                variant: ctaButton.buttonVariant || "primary",
                                href: ctaButton.buttonHref,
                                color: ctaButton.buttonColor || "blue",
                                "aria-label": (_ctaButton_buttonText1 = ctaButton.buttonText) !== null && _ctaButton_buttonText1 !== void 0 ? _ctaButton_buttonText1 : "Get started",
                                "aria-describedby": "cta-button",
                                dataEventProps: {
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": crossflowEventContainer,
                                    "data-product-key": "home",
                                    "data-label-english": (_ctaButton_eventProps2 = ctaButton.eventProps) === null || _ctaButton_eventProps2 === void 0 ? void 0 : _ctaButton_eventProps2.labelEnglish,
                                    "data-label": (_ctaButton_eventProps3 = ctaButton.eventProps) === null || _ctaButton_eventProps3 === void 0 ? void 0 : _ctaButton_eventProps3.label
                                },
                                className: (0, $2jatx.default)([
                                    "_1pfh1tcg"
                                ]),
                                children: ctaButton.buttonText
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1pfhftgi _y3gn1e5h"
                        ]),
                        children: ContentComponent && /*#__PURE__*/ (0, $7VQPk.jsx)(ContentComponent, {})
                    })
                ]
            })
        })
    });
};
const $f0786d67cef3119e$var$heroTitleContainerStyles = null;
const $f0786d67cef3119e$var$heroTitleStyles = null;
const $f0786d67cef3119e$var$heroGetStartedStyles = null;
const $f0786d67cef3119e$var$ctaContainerStyles = null;
const $f0786d67cef3119e$var$heroGetStartedStylesVariant = null;
const $f0786d67cef3119e$var$contactSalesLinkStyles = null;
const $f0786d67cef3119e$var$contactSalesArrowStyles = null;
const $f0786d67cef3119e$var$crossflowCTAStyles = null;
const $f0786d67cef3119e$var$contentTypesSectionStyles = null;
var $f0786d67cef3119e$export$2e2bcd8739ae039 = $f0786d67cef3119e$export$aefd856850d8c2bf;

});


parcelRegister("chr3l", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", function () { return $6a7ab2404250a038$export$dece24112a937f92; });
$parcel$export(module.exports, "ScrollPinnedSections", function () { return $6a7ab2404250a038$export$9c89353bd7d2d29; });
/* scroll-pinned-sections.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $imIsw = parcelRequire("imIsw");

var $8EEDU = parcelRequire("8EEDU");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");

var $32ng3 = parcelRequire("32ng3");

var $j6FQw = parcelRequire("j6FQw");

var $7aqu5 = parcelRequire("7aqu5");

var $Oss1q = parcelRequire("Oss1q");
const $6a7ab2404250a038$var$ScrollContextState = {
    activeAccentImg: null,
    activeBrand: null,
    activeColor: null,
    activeProductCTAText: null,
    activeProductCTAUrl: null,
    activeCustomerCTAUrl: null,
    activeFeatureVideo: null,
    activePosterImage: null,
    activeStaticImage: null,
    activeIndex: 0,
    activeShape: null,
    setActiveAccentImg: ()=>undefined,
    setActiveBrand: ()=>undefined,
    setActiveColor: ()=>undefined,
    setActiveProductCTAText: ()=>undefined,
    setActiveProductCTAUrl: ()=>undefined,
    setActiveCustomerCTAUrl: ()=>undefined,
    setActiveFeatureVideo: ()=>undefined,
    setActivePosterImage: ()=>undefined,
    setActiveStaticImage: ()=>undefined,
    setActiveIndex: ()=>0,
    setActiveShape: ()=>undefined
};
const $6a7ab2404250a038$export$dece24112a937f92 = /*#__PURE__*/ (0, $1oC0p.createContext)($6a7ab2404250a038$var$ScrollContextState);
const $6a7ab2404250a038$export$9c89353bd7d2d29 = ()=>{
    var _Teams_, _Teams_1, _Teams_2, _Teams_3, _Teams_4, _Teams_5, _Teams_6, _Teams_7, _Teams_8, _Teams_9, _Teams_10, _Teams_11, _Teams_12, _Teams_13;
    const intl = (0, $8e22h.default)();
    const useNewScreenshots = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9214HomepageScreenshots);
    const Teams = [
        {
            productName: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Jira.ProductName",
                defaultMessage: "Jira"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.ProductMarkJira), {}),
            productLogoName: "jira",
            productCTA: {
                text: intl.formatMessage({
                    id: "HomePage.ScrollPinnedSection.Jira.Cta",
                    defaultMessage: "Explore Jira"
                }),
                url: (0, $kooLp.useLocalizedHref)("/software/jira"),
                tryCloudUrl: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-software&edition=free"),
                tryLabel: intl.formatMessage({
                    id: "HomePage.ScrollPinnedSection.Jira.TryLabel",
                    defaultMessage: "Get Jira free"
                })
            },
            header: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Jira.Header",
                defaultMessage: "Dream it, plan it, launch it"
            }),
            description: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Jira.Description-ai",
                defaultMessage: "AI-powered project management to plan, track, and deliver your biggest ideas together."
            }),
            quote: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Jira.Quote",
                defaultMessage: "We've been able to reduce our cycle time and increase throughput by 200%, which means we're delivering capabilities to customers faster and increasing customer satisfaction."
            }),
            customerCTAUrl: (0, $kooLp.useLocalizedHref)("/customers/lumen"),
            name: "Mai Lian Scarlett",
            title: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Jira.JobTitle",
                defaultMessage: "Former Senior Director, Agile Transformation Office, Lumen"
            }),
            summary: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Jira.Summary",
                defaultMessage: "Lumen used Jira to reduce cycle time and increase throughput by 200%."
            }),
            customerCTA: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Jira.ReadMore",
                defaultMessage: "Read their story."
            }),
            customerCTALabel: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Jira.ReadMoreLabel",
                defaultMessage: "Read the Lumen story"
            }),
            brand: "https://dam-cdn.atl.orangelogic.com/AssetLink/x8om4p1bytdc7bytrdo15b0q1p8nh7dg.svg",
            portrait: "https://dam-cdn.atl.orangelogic.com/AssetLink/a040dn2p4evj6k3041y21an1u5qk4owa.webp",
            featureVideo: "https://dam-cdn.atl.orangelogic.com/AssetLink/80qt36g22p4m41p66lxp06m0q3f87abd.mp4",
            posterImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/4j6046mx34c02pmwgtsqa7m5x7bkx16x.webp",
            staticImage: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/7g6j15a0o21u8b45773ws38rg15ioc73/jira-board-software.webp" : undefined,
            accentImg: (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.SquiggleLineAccent1), {}), []),
            bgColor: (0, $kbpa7.wacToken)("color.extended.lime500"),
            bgShape: "0% 32%, 2% 97%, 56% 100%, 56% 96%, 100% 96%, 100% 0%, 55.5% 2%, 56.5% 18%, 56.5% 18%, 56.5% 18%"
        },
        {
            productName: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Confluence.ProductName",
                defaultMessage: "Confluence"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.ProductMarkConfluence), {}),
            productLogoName: "confluence",
            productCTA: {
                text: intl.formatMessage({
                    id: "HomePage.ScrollPinnedSection.Confluence.Cta",
                    defaultMessage: "Explore Confluence"
                }),
                url: `${(0, $kooLp.useLocalizedHref)("/software/confluence")}`,
                tryCloudUrl: `${(0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=confluence&edition=free")}`,
                tryLabel: intl.formatMessage({
                    id: "HomePage.ScrollPinnedSection.Confluence.TryLabel",
                    defaultMessage: "Get Confluence free"
                })
            },
            header: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Confluence.Header",
                defaultMessage: "Create and organize with AI"
            }),
            description: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Confluence.Description-ai",
                defaultMessage: "Build and connect plans, documents and ideas with context-aware AI."
            }),
            quote: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Confluence.Quote",
                defaultMessage: "The big win that we've seen through the implementation of Confluence Cloud is definitely collaboration. It's a very open way of working."
            }),
            customerCTAUrl: (0, $kooLp.useLocalizedHref)("/customers/dropbox"),
            name: "Damian Davis",
            title: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Confluence.JobTitle",
                defaultMessage: "Lead Atlassian Administrator, Dropbox"
            }),
            summary: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Confluence.Summary",
                defaultMessage: "Dropbox uses Confluence Cloud to create a more open, collaborative way of working."
            }),
            customerCTA: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Confluence.ReadMore",
                defaultMessage: "Read their story."
            }),
            customerCTALabel: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Confluence.ReadMoreLabel",
                defaultMessage: "Read the Dropbox story"
            }),
            brand: "https://dam-cdn.atl.orangelogic.com/AssetLink/rjf5v331x88ie27f5200d1n0e8g84md5.svg",
            portrait: "https://dam-cdn.atl.orangelogic.com/AssetLink/q4q14b417k564801vk1p02gbv83r71b1.webp",
            featureVideo: "https://dam-cdn.atl.orangelogic.com/AssetLink/nt635rjo7hdklio5nmull65kk44i2wrp.mp4",
            posterImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/b5t3823srnc158mx637784k0271kp4i6.webp",
            staticImage: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/2wv2e42i053ob2pk68h8524vbi64f634/confluence-scroll.webp" : undefined,
            accentImg: (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.ArrowGroupAccent), {}), []),
            bgColor: (0, $kbpa7.wacToken)("color.extended.purple500"),
            bgShape: "0% 1%, 100% 0%, 100% 33%, 55% 33%, 55% 100%, 3% 96%, 2% 32%, 0% 32%, 0% 32%, 0% 32%"
        },
        {
            productName: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JSM.ProductName",
                defaultMessage: "Jira Service Management"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.ProductMarkJSM), {}),
            productLogoName: "jiraservicemanagement",
            productCTA: {
                text: intl.formatMessage({
                    id: "HomePage.ScrollPinnedSection.JSM.Cta",
                    defaultMessage: "Explore Jira Service Management"
                }),
                url: `${(0, $kooLp.useLocalizedHref)("/software/jira/service-management")}`,
                tryCloudUrl: `${(0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-service-management&edition=free")}`,
                tryLabel: intl.formatMessage({
                    id: "HomePage.ScrollPinnedSection.JSM.TryLabel",
                    defaultMessage: "Get Jira Service Management free"
                })
            },
            header: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JSM.Header",
                defaultMessage: "Deliver service faster"
            }),
            description: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JSM.Description",
                defaultMessage: "Connect Dev and Ops teams on a single platform with customizable features and AI-powered agents."
            }),
            quote: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JSM.Quote",
                defaultMessage: "Atlassian Intelligence acts as a virtual teammate summarizing 5-page PIR reports into 5-sentence recaps for me. It\u2019s already proven its worth by improving productivity across our product teams."
            }),
            customerCTAUrl: "https://www.atlassian.com/blog/it-service-management/reimagining-service-management-with-dominos-and-nrma",
            name: "Matthias Hansen",
            title: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JSM.JobTitle",
                defaultMessage: "Group CTO, Domino's Pizza Enterprises"
            }),
            summary: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JSM.Summary",
                defaultMessage: "Teams at Domino\u2019s Pizza Enterprises Ltd use AI to boost individual and team productivity."
            }),
            customerCTA: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JSM.ReadMore",
                defaultMessage: "See their story."
            }),
            customerCTALabel: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JSM.ReadMoreLabel",
                defaultMessage: "See the Domino's story"
            }),
            brand: "https://dam-cdn.atl.orangelogic.com/AssetLink/2naan5oor44502o5522ph50clc3ejk8b.svg",
            portrait: "https://dam-cdn.atl.orangelogic.com/AssetLink/82ag34s8438g48a538rq5yxrsf2s80o5.webp",
            featureVideo: "https://dam-cdn.atl.orangelogic.com/AssetLink/n0q7e6b6ddfs0858muf851j75fvc8643.mp4",
            posterImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/g80pjdq621fklf17b80ikd8gs36rp8g5.webp",
            staticImage: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/jxc7fgbk61xf52b4h8jvq865i2x1o0h3/jsm-scroll.webp" : undefined,
            accentImg: (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.LightningAccent1), {}), []),
            bgColor: (0, $kbpa7.wacToken)("color.extended.saffron400"),
            bgShape: "0% 41%, 8% 41%, 10% 21%, 65% 13%, 67% 3%, 100% 0%, 98% 27%, 100% 27%, 100% 100%, 0% 98%"
        },
        {
            productName: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Loom.ProductName",
                defaultMessage: "Loom"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.ProductMarkLoom), {}),
            productLogoName: "loom",
            productCTA: {
                text: intl.formatMessage({
                    id: "HomePage.ScrollPinnedSection.Loom.Cta",
                    defaultMessage: "Explore Loom"
                }),
                url: (0, $kooLp.useLocalizedHref)("/software/loom"),
                tryCloudUrl: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=loom&edition=premium&sourceComponent=loom-direct"),
                tryLabel: intl.formatMessage({
                    id: "HomePage.ScrollPinnedSection.Loom.TryLabel",
                    defaultMessage: "Get Loom free"
                })
            },
            header: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Loom.Header",
                defaultMessage: "Record, share, collaborate"
            }),
            description: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Loom.Description",
                defaultMessage: "Easily record and share AI-powered video messages to reach a broader audience for better async collaboration."
            }),
            quote: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Loom.Quote",
                defaultMessage: "Loom has been the light of my life since you showed me it. I never tire of hearing this from folks."
            }),
            customerCTAUrl: (0, $kooLp.useLocalizedHref)("/customers"),
            name: "Alexis Ohanian",
            title: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Loom.JobTitle",
                defaultMessage: "Founder, Seven Seven Six"
            }),
            summary: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Loom.Summary",
                defaultMessage: "Loom has been the light of my life since you showed me it. I never tire of hearing this from folks."
            }),
            customerCTA: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Loom.ReadMore",
                defaultMessage: "Read their story."
            }),
            customerCTALabel: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.Loom.ReadMoreLabel",
                defaultMessage: "Read the Seven Seven Six story"
            }),
            brand: "https://dam-cdn.atl.orangelogic.com/AssetLink/215050ci4w203s0mrd76eb2kf0o73rd6.svg",
            portrait: "https://dam-cdn.atl.orangelogic.com/AssetLink/si3h814nhij7mqksea3r3bq22kspnqmg.webp",
            featureVideo: "https://dam-cdn.atl.orangelogic.com/AssetLink/27ujcvoyd73u73c33d00a5q4gyqd40n0.mp4",
            posterImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/ok3kd81lm1e452l8rc5gqagc0g72353m.webp",
            staticImage: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/kvro7aryebr3501e4sw2n4kj2536vw4a/loop-scroll.webp" : undefined,
            accentImg: (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.SquiggleLineAccent2), {}), []),
            bgColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            bgShape: "0% 1%, 30% 0%, 30% 3%, 100% 0%, 99% 99%, 1% 100%, 1% 100%, 1% 100%, 1% 100%, 1% 100%"
        },
        {
            productName: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JPD.ProductName",
                defaultMessage: "Jira Product Discovery"
            }),
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.ProductMarkJPD), {}),
            productLogoName: "jiraproductdiscovery",
            productCTA: {
                text: intl.formatMessage({
                    id: "HomePage.ScrollPinnedSection.JPD.Cta",
                    defaultMessage: "Explore Jira Product Discovery"
                }),
                url: `${(0, $kooLp.useLocalizedHref)("/software/jira/product-discovery")}`,
                tryCloudUrl: `${(0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery")}`,
                tryLabel: intl.formatMessage({
                    id: "HomePage.ScrollPinnedSection.JPD.TryLabel",
                    defaultMessage: "Get Jira Product Discovery free"
                })
            },
            header: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JPD.Header",
                defaultMessage: "Ideate faster than ever"
            }),
            description: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JPD.Description",
                defaultMessage: "Capture and prioritize ideas and align everyone with product roadmaps - all in one single Jira platform."
            }),
            quote: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JPD.Quote",
                defaultMessage: "Jira Product Discovery translated our entire process into a highly transparent workflow, connected to the work we were already doing in Jira. That was a mind-blowing moment."
            }),
            customerCTAUrl: (0, $kooLp.useLocalizedHref)("/customers/doodle"),
            name: "Stephanie Leue",
            title: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JPD.JobTitle",
                defaultMessage: "Former Chief Product Officer, Doodle"
            }),
            summary: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JPD.Summary",
                defaultMessage: "Doodle uses Jira Product Discovery to translate their entire process into a highly transparent workflow, connected to the work they were already doing in Jira."
            }),
            customerCTA: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JPD.ReadMore",
                defaultMessage: "Read their story."
            }),
            customerCTALabel: intl.formatMessage({
                id: "HomePage.ScrollPinnedSection.JPD.ReadMoreLabel",
                defaultMessage: "Read the Doodle story"
            }),
            brand: "https://dam-cdn.atl.orangelogic.com/AssetLink/30ur058vt123kkh4mp68ivv6qopl0bd3.svg",
            portrait: "https://dam-cdn.atl.orangelogic.com/AssetLink/5ojgmwt84ty0yr7426611y50t3spsyt8.webp",
            featureVideo: "https://dam-cdn.atl.orangelogic.com/AssetLink/mk2h13861hj08rhewrfn05bpn87s2730.mp4",
            posterImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/83tq3402yb1w28fv8wt70804613ev0is.webp",
            staticImage: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/03c6d0erv445pgc061s8l422v5b36457/jpd-scroll.webp" : undefined,
            accentImg: (0, $1oC0p.useMemo)(()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.StarGroupAccent), {}), []),
            bgColor: (0, $kbpa7.wacToken)("color.extended.lime500"),
            bgShape: "0% 20%, 48% 10%, 48% 2%, 100% 0%, 100% 97%, 55% 100%, 55% 96%, 2% 95%, 2% 95%, 2% 95%"
        }
    ];
    const imgSectionRef = (0, $1oC0p.useRef)(null);
    const defaultFeatureVideo = ((_Teams_ = Teams[0]) === null || _Teams_ === void 0 ? void 0 : _Teams_.featureVideo) ? (_Teams_1 = Teams[0]) === null || _Teams_1 === void 0 ? void 0 : _Teams_1.featureVideo : "";
    const defaultFeaturePosterImage = ((_Teams_2 = Teams[0]) === null || _Teams_2 === void 0 ? void 0 : _Teams_2.posterImage) ? (_Teams_3 = Teams[0]) === null || _Teams_3 === void 0 ? void 0 : _Teams_3.posterImage : "";
    const defaultStaticImage = ((_Teams_4 = Teams[0]) === null || _Teams_4 === void 0 ? void 0 : _Teams_4.staticImage) ? (_Teams_5 = Teams[0]) === null || _Teams_5 === void 0 ? void 0 : _Teams_5.staticImage : "";
    const defaultProductCTAText = ((_Teams_6 = Teams[0]) === null || _Teams_6 === void 0 ? void 0 : _Teams_6.productCTA.text) ? (_Teams_7 = Teams[0]) === null || _Teams_7 === void 0 ? void 0 : _Teams_7.productCTA.text : "";
    const defaultProductCTAUrl = ((_Teams_8 = Teams[0]) === null || _Teams_8 === void 0 ? void 0 : _Teams_8.productCTA.url) ? (_Teams_9 = Teams[0]) === null || _Teams_9 === void 0 ? void 0 : _Teams_9.productCTA.url : "";
    const defaultBgShape = ((_Teams_10 = Teams[0]) === null || _Teams_10 === void 0 ? void 0 : _Teams_10.bgShape) ? (_Teams_11 = Teams[0]) === null || _Teams_11 === void 0 ? void 0 : _Teams_11.bgShape : "";
    const defaultBgColor = ((_Teams_12 = Teams[0]) === null || _Teams_12 === void 0 ? void 0 : _Teams_12.bgColor) ? (_Teams_13 = Teams[0]) === null || _Teams_13 === void 0 ? void 0 : _Teams_13.bgColor : "";
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)({
        threshold: 0.15
    });
    const { ref: headerScrollRef, inView: headerIsVisible } = (0, $jKShK.useInView)({
        threshold: 1
    });
    const [activeAccentImg, setActiveAccentImg] = (0, $1oC0p.useState)();
    const [activeBrand, setActiveBrand] = (0, $1oC0p.useState)("");
    const [activeColor, setActiveColor] = (0, $1oC0p.useState)(defaultBgColor);
    const [activeProductCTAText, setActiveProductCTAText] = (0, $1oC0p.useState)(defaultProductCTAText);
    const [activeProductCTAUrl, setActiveProductCTAUrl] = (0, $1oC0p.useState)(defaultProductCTAUrl);
    const [activeCustomerCTAUrl, setActiveCustomerCTAUrl] = (0, $1oC0p.useState)("");
    const [activeFeatureVideo, setActiveFeatureVideo] = (0, $1oC0p.useState)(defaultFeatureVideo);
    const [activePosterImage, setActivePosterImage] = (0, $1oC0p.useState)(defaultFeaturePosterImage);
    const [activeStaticImage, setActiveStaticImage] = (0, $1oC0p.useState)(defaultStaticImage);
    const [activeIndex, setActiveIndex] = (0, $1oC0p.useState)(0);
    const [activeShape, setActiveShape] = (0, $1oC0p.useState)(defaultBgShape);
    const { ref: scrollTrackingRef } = (0, $j6FQw.useScrollTracking)("ScrollPinnedSections");
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($6a7ab2404250a038$export$dece24112a937f92.Provider, {
            value: {
                activeAccentImg: activeAccentImg,
                activeBrand: activeBrand,
                activeColor: activeColor,
                activeProductCTAText: activeProductCTAText,
                activeProductCTAUrl: activeProductCTAUrl,
                activeCustomerCTAUrl: activeCustomerCTAUrl,
                activeFeatureVideo: activeFeatureVideo,
                activePosterImage: activePosterImage,
                activeStaticImage: activeStaticImage,
                activeIndex: activeIndex,
                activeShape: activeShape,
                setActiveAccentImg: setActiveAccentImg,
                setActiveBrand: setActiveBrand,
                setActiveColor: setActiveColor,
                setActiveFeatureVideo: setActiveFeatureVideo,
                setActivePosterImage: setActivePosterImage,
                setActiveStaticImage: setActiveStaticImage,
                setActiveIndex: setActiveIndex,
                setActiveShape: setActiveShape,
                setActiveProductCTAText: setActiveProductCTAText,
                setActiveProductCTAUrl: setActiveProductCTAUrl,
                setActiveCustomerCTAUrl: setActiveCustomerCTAUrl
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
                name: "homepage-v2-scrollPinnedSection",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    ref: scrollRef,
                    className: (0, $2jatx.default)([
                        "_1b8rcd5j _v5641s1n _kqswh2mm _19pkgktf _2hwxidpf _otyrfp70 _18u0idpf _bfhk1jwv _1itk4xsi _3wvkgktf _1fbnidpf _1uby12am _1t0ridpf _waka1j12 _xof91j12",
                        sectionIsVisible ? "is-visible" : "hidden"
                    ]),
                    style: {
                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _na0i1bp4 _1egl10j7",
                                "row-width"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_13wn1if8 _180kidpf _hyzqcs5v _1cfrgrii",
                                        "header-wrapper"
                                    ]),
                                    ref: scrollTrackingRef,
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_152tidpf _1e0c1txw _2lx21bp4"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_11q7iyt3 _1q511uws _85i5gktf",
                                                    "accent-heading"
                                                ]),
                                                style: {
                                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("h2", {
                                                    ref: headerScrollRef,
                                                    className: (0, $2jatx.default)([
                                                        "_kqswh2mm _y3gn1e5h _gu181h6o",
                                                        headerIsVisible ? "is-visible" : "hidden"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                                    image: {
                                                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/017a6562kool0414o36wc5ll0ijk3787.svg",
                                                                        alt: "",
                                                                        width: 19,
                                                                        height: 19
                                                                    },
                                                                    className: (0, $2jatx.default)([
                                                                        "_kqswstnw _tzy4idpf",
                                                                        "_1e02asv7 _152t9ys2",
                                                                        headerIsVisible && "",
                                                                        headerIsVisible && "_y44v1kph"
                                                                    ])
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                                    image: {
                                                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1wj34u7l84d64u01g38tn8ta0j4788mf.svg",
                                                                        alt: "",
                                                                        width: 20,
                                                                        height: 20
                                                                    },
                                                                    className: (0, $2jatx.default)([
                                                                        "_kqswstnw _tzy4idpf",
                                                                        "_1e021nrf _152t16r0",
                                                                        headerIsVisible && "",
                                                                        headerIsVisible && "_y44v1b7n"
                                                                    ])
                                                                }),
                                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                                                    image: {
                                                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/y88c71e0n8m74s1hby47odn7b765b46q.svg",
                                                                        alt: "",
                                                                        width: 37,
                                                                        height: 36
                                                                    },
                                                                    className: (0, $2jatx.default)([
                                                                        "_kqswstnw _tzy4idpf",
                                                                        "_1e021baf _152t1ts5",
                                                                        headerIsVisible && "",
                                                                        headerIsVisible && "_y44v1hfc"
                                                                    ])
                                                                })
                                                            ]
                                                        }),
                                                        intl.formatMessage({
                                                            id: "HomePage.ScrollPinnedSectionHeader",
                                                            defaultMessage: "Teamwork solutions for high-performing teams"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                ref: imgSectionRef,
                                                className: (0, $2jatx.default)([
                                                    "_4cvresu3 _1e0c1txw _2lx21bp4 _1bah1h6o _i0dl1nrf _kqsw1if8 _152tidpf _1q51gktf _1bsb16h4 _1wpzesu3 _1tkeidpf _1mjbglyw",
                                                    "half img-section"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_kqswh2mm _6rth1ylp _1h1t15ju _ca0qldb6 _u5f3ldb6 _n3tdldb6 _19bvldb6 _1bsb1osq",
                                                        "img-region"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_1bsb1osq _4t3i1osq _v564t24z _kqswstnw _1e02idpf _152tidpf",
                                                                activeIndex % 2 === 0 && "",
                                                                activeIndex % 2 === 0 && "_y44v1f3a",
                                                                activeIndex % 2 !== 0 && "",
                                                                activeIndex % 2 !== 0 && "_y44vc1ar",
                                                                "bg-shape"
                                                            ]),
                                                            style: {
                                                                clipPath: `polygon(${activeShape})`,
                                                                backgroundColor: activeColor
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_1bsbx19p _kqswstnw _1e023ll0 _u7co15qf",
                                                                "img-accent"
                                                            ]),
                                                            children: activeAccentImg
                                                        }),
                                                        activeStaticImage ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                                            className: (0, $2jatx.default)([
                                                                "_kqswh2mm _1e0c1ule _4t3i1wug _1bsb1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _y44v19s7 _2rko14y2 _19it1ia1",
                                                                "img-screenshot"
                                                            ]),
                                                            src: activeStaticImage,
                                                            alt: "",
                                                            width: 1536,
                                                            height: 800,
                                                            style: {
                                                                width: "100%",
                                                                height: "auto",
                                                                aspectRatio: 1.92,
                                                                position: "relative",
                                                                "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                                                            }
                                                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8EEDU.Video), {
                                                            videoLink: activeFeatureVideo,
                                                            videoType: "mp4",
                                                            className: (0, $2jatx.default)([
                                                                "_kqswh2mm _1e0c1ule _4t3i1wug _1bsb1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _y44v19s7 _2rko14y2 _19it1ia1",
                                                                "img-screenshot"
                                                            ]),
                                                            videoPreviewImage: activePosterImage,
                                                            aspectRatio: "16/9",
                                                            loop: false,
                                                            style: {
                                                                "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                                                            }
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_glte2lqr _13wnh2mm _180k1phg _1mt1rlc3 _1tnt1v2j",
                                        "half text-section"
                                    ]),
                                    children: Teams.map((team, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $Oss1q.HomepageSectionScrollItem), {
                                            index: index,
                                            brand: team.brand,
                                            quote: team.quote,
                                            productLogoName: team.productLogoName,
                                            productCTA: team.productCTA,
                                            header: team.header,
                                            description: team.description,
                                            name: team.name,
                                            title: team.title,
                                            portrait: team.portrait,
                                            summary: team.summary,
                                            customerCTA: team.customerCTA,
                                            customerCTALabel: team.customerCTALabel,
                                            customerCTAUrl: team.customerCTAUrl,
                                            featureVideo: team.featureVideo,
                                            posterImage: team.posterImage,
                                            staticImage: team.staticImage,
                                            bgColor: team.bgColor,
                                            bgShape: team.bgShape,
                                            accentImg: team.accentImg
                                        }, index))
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
const $6a7ab2404250a038$var$fadeIn = null;
const $6a7ab2404250a038$var$bgShapePulseOdd = null;
const $6a7ab2404250a038$var$bgShapePulseEven = null;
const $6a7ab2404250a038$var$rowWidthStyles = null;
const $6a7ab2404250a038$var$imgSectionStyles = null;
const $6a7ab2404250a038$var$textSectionStyles = null;
const $6a7ab2404250a038$var$headerWrapperStyles = null;
const $6a7ab2404250a038$var$accentHeadingStyles = null;
const $6a7ab2404250a038$var$h2Styles = null;
const $6a7ab2404250a038$var$sparklesImgStyles = null;
const $6a7ab2404250a038$var$sparklesImg1Styles = null;
const $6a7ab2404250a038$var$sparklesImg2Styles = null;
const $6a7ab2404250a038$var$sparklesImg3Styles = null;
const $6a7ab2404250a038$var$sparklesImg1AnimationStyles = null;
const $6a7ab2404250a038$var$sparklesImg2AnimationStyles = null;
const $6a7ab2404250a038$var$sparklesImg3AnimationStyles = null;
const $6a7ab2404250a038$var$imgRegionStyles = null;
const $6a7ab2404250a038$var$bgShapeStyles = null;
// dynamic bg styles
const $6a7ab2404250a038$var$oddBgShapeAnimation = null;
const $6a7ab2404250a038$var$evenBgShapeAnimation = null;
const $6a7ab2404250a038$var$imgAccentWrapperStyles = null;
const $6a7ab2404250a038$var$imgScreenshotStyles = null;
const $6a7ab2404250a038$var$scrollerStyles = null;

});
parcelRegister("7aqu5", function(module, exports) {
$parcel$export(module.exports, "ProductMarkJira", function () { return $34b167bb54f433bf$export$7699a0b23df18dcc; });
$parcel$export(module.exports, "ProductMarkConfluence", function () { return $34b167bb54f433bf$export$f0a246d48a2b50f0; });
$parcel$export(module.exports, "ProductMarkJSM", function () { return $34b167bb54f433bf$export$7005a7261e8d8b75; });
$parcel$export(module.exports, "ProductMarkLoom", function () { return $34b167bb54f433bf$export$67920ca0652212dc; });
$parcel$export(module.exports, "ProductMarkJPD", function () { return $34b167bb54f433bf$export$5b3ac21e85b5ef6; });
$parcel$export(module.exports, "SquiggleLineAccent1", function () { return $34b167bb54f433bf$export$5fe0ea3ff268e5e; });
$parcel$export(module.exports, "SquiggleLineAccent2", function () { return $34b167bb54f433bf$export$11eb8f2a8b319cf6; });
$parcel$export(module.exports, "ArrowGroupAccent", function () { return $34b167bb54f433bf$export$2ab91b89d33945ba; });
$parcel$export(module.exports, "StarGroupAccent", function () { return $34b167bb54f433bf$export$4bd4a2082c1349e0; });
$parcel$export(module.exports, "LightningAccent1", function () { return $34b167bb54f433bf$export$be657ca51492c568; });
$parcel$export(module.exports, "CalendarIcon", function () { return $34b167bb54f433bf$export$5fda1783bb83f57b; });
$parcel$export(module.exports, "MapDropIcon", function () { return $34b167bb54f433bf$export$74e11963d795a54e; });
$parcel$export(module.exports, "Team25LogoEU", function () { return $34b167bb54f433bf$export$60fb25c80a5c7130; });
$parcel$export(module.exports, "Team26Logo", function () { return $34b167bb54f433bf$export$652c71226985a987; });
$parcel$export(module.exports, "TeamworkCollectionsLockup", function () { return $34b167bb54f433bf$export$bc8c600da991a044; });
/* illustrations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $imIsw = parcelRequire("imIsw");
const $34b167bb54f433bf$export$7699a0b23df18dcc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/m6fn2a71367wu8014y3f2ts326u3kqx6.svg",
            alt: "Jira",
            width: 32,
            height: 32
        }
    });
};
const $34b167bb54f433bf$export$f0a246d48a2b50f0 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6yseodqkcs66tyk0nk2007kpo81tvbm4.svg",
            alt: "Confluence",
            width: 32,
            height: 32
        }
    });
};
const $34b167bb54f433bf$export$7005a7261e8d8b75 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/65r02355r08er3o7io008svimj6osus2.svg",
            alt: "Jira Service Management",
            width: 32,
            height: 32
        }
    });
};
const $34b167bb54f433bf$export$67920ca0652212dc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4o2u5s554348i6h5645mq8ar7ntw5450.svg",
            alt: "Loom",
            width: 32,
            height: 32
        }
    });
};
const $34b167bb54f433bf$export$5b3ac21e85b5ef6 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/hk7466y56264c0p11ux6107txk5rw46r.svg",
            alt: "Jira Product Discovery",
            width: 32,
            height: 32
        }
    });
};
const $34b167bb54f433bf$export$6c04ed9ab55c2a9e = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6275784r4dh6fotxepe3g26uboht83t4.svg",
            alt: "Atlassian Intelligence",
            width: 32,
            height: 32
        }
    });
const $34b167bb54f433bf$export$5fe0ea3ff268e5e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        className: (0, $2jatx.default)([
            "_y44vlrv9 _kqswh2mm",
            "_1e02183y _152t12et",
            "squiggle-line-accent-1"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2dai185boireipv62t4j7awwh6cv8322.svg",
            alt: "",
            width: 150,
            height: 92
        }
    });
};
const $34b167bb54f433bf$export$11eb8f2a8b319cf6 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        className: (0, $2jatx.default)([
            "_y44vlrv9 _kqswh2mm",
            "_1e0214no",
            "squiggle-line-accent-2"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pi37ocm4254a4lhvb68oy16byyud6n75.svg",
            alt: "",
            width: 99,
            height: 103
        }
    });
};
const $34b167bb54f433bf$export$2ab91b89d33945ba = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        className: (0, $2jatx.default)([
            "_y44vlrv9 _kqswh2mm",
            "_1e027vkz _152t16fl",
            "arrow-group-accent"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/n26mjl5555b41hxr1rr06q7sqt32b8mp.svg",
            alt: "",
            width: 130,
            height: 138
        }
    });
};
const $34b167bb54f433bf$export$4bd4a2082c1349e0 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        className: (0, $2jatx.default)([
            "_y44vlrv9 _kqswh2mm",
            "_152tkgzx",
            "star-group-accent"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/jcnwbj7ap8y8bc21dgtv4bao607iy5a4.svg",
            alt: "",
            width: 64,
            height: 79
        }
    });
};
const $34b167bb54f433bf$export$be657ca51492c568 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        className: (0, $2jatx.default)([
            "_y44vlrv9 _kqswh2mm",
            "_1e021h22 _152t14id",
            "lightning-accent-1"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/be2d0r17t5l13284c857pgjwx661fm40.svg",
            alt: "",
            width: 90,
            height: 94
        }
    });
};
const $34b167bb54f433bf$export$5fda1783bb83f57b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "18",
        height: "20",
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.125 1.875H10.875V0H13.375V1.875H17.75V19.375H0.25V1.875H4.625V0H7.125V1.875ZM7.125 4.375V6.25H4.625V4.375H2.75V8.75H15.25V4.375H13.375V6.25H10.875V4.375H7.125Z",
            fill: "white"
        })
    });
};
const $34b167bb54f433bf$export$74e11963d795a54e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.00001 19.0625L1.59668 11.2277C-1.40626 6.87341 1.71068 0.9375 7.00001 0.9375C12.2894 0.9375 15.4063 6.87341 12.4034 11.2277L7.00001 19.0625ZM7 10.625C8.72589 10.625 10.125 9.22589 10.125 7.5C10.125 5.77411 8.72589 4.375 7 4.375C5.27411 4.375 3.875 5.77411 3.875 7.5C3.875 9.22589 5.27411 10.625 7 10.625Z",
            fill: "white"
        })
    });
};
const $34b167bb54f433bf$export$180c2c3a09738c6b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "18",
        height: "20",
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.125 1.875H10.875V0H13.375V1.875H17.75V19.375H0.25V1.875H4.625V0H7.125V1.875ZM7.125 4.375V6.25H4.625V4.375H2.75V8.75H15.25V4.375H13.375V6.25H10.875V4.375H7.125Z",
            fill: "currentColor"
        })
    });
};
const $34b167bb54f433bf$export$2eeb99350426036b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.00001 19.0625L1.59668 11.2277C-1.40626 6.87341 1.71068 0.9375 7.00001 0.9375C12.2894 0.9375 15.4063 6.87341 12.4034 11.2277L7.00001 19.0625ZM7 10.625C8.72589 10.625 10.125 9.22589 10.125 7.5C10.125 5.77411 8.72589 4.375 7 4.375C5.27411 4.375 3.875 5.77411 3.875 7.5C3.875 9.22589 5.27411 10.625 7 10.625Z",
            fill: "currentColor"
        })
    });
};
const $34b167bb54f433bf$export$60fb25c80a5c7130 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "221",
        height: "82",
        viewBox: "0 0 221 82",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M143.226 9.45884C143.226 6.17106 145.378 4.13861 148.786 4.13861C152.193 4.13861 154.704 6.23084 154.704 11.5511C154.704 18.2462 150.34 22.6698 142.449 23.0882V17.6484C145.498 17.4691 147.829 16.5126 148.547 14.6595H148.487C145.02 14.6595 143.226 12.8064 143.226 9.45884Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M14.7052 29.5977C14.7052 31.5106 15.6617 32.467 17.5148 32.467C18.4115 32.467 19.2484 32.2877 19.9059 32.1681V41.7924C18.3517 42.151 16.6181 42.4499 13.9281 42.4499C6.157 42.4499 3.467 37.847 3.467 31.1519V20.1528H0.597656V11.0068H3.467V4.73007H14.7052V11.0068H19.9059V20.1528H14.7052V29.5977Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M37.9243 18.1801C35.1147 18.1801 33.68 20.2125 33.3214 24.2177H42.3478C42.049 20.0332 40.6143 18.1801 37.9243 18.1801ZM51.3145 40.7164C48.3854 41.7924 44.3803 42.5695 40.3752 42.5695C28.0012 42.5695 22.4418 37.1297 22.4418 26.9674C22.4418 17.2237 27.8218 10.2894 38.1036 10.2894C48.2659 10.2894 52.4503 17.1639 52.4503 26.9674V29.2988H33.5605C34.2778 32.3475 36.3701 33.3039 40.6143 33.3039C44.201 33.3039 48.1463 32.7659 51.3145 31.8692V40.7164Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M65.8429 26.4892C65.8429 30.853 67.2776 33.005 69.9676 33.005C72.1793 33.005 74.0922 31.391 74.0922 27.6848V25.2339C74.0922 21.4679 72.4782 19.8539 70.2067 19.8539C67.3373 19.8539 65.8429 22.245 65.8429 26.4892ZM74.0922 41.9717V36.4721C72.2989 40.5968 69.0709 42.5695 65.1853 42.5695C58.012 42.5695 54.7242 35.8146 54.7242 26.4892C54.7242 17.7019 58.012 10.409 65.6636 10.409C69.7285 10.409 72.538 12.8001 74.0922 16.327V11.0068H85.3903V41.9717H74.0922Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M119.424 24.7557V41.9717H108.126V23.5003C108.126 20.9299 107.229 19.7343 105.017 19.7343C102.746 19.7343 101.192 21.2885 101.192 24.7557V41.9717H89.8937V11.0068H101.192V16.5661C102.865 12.561 105.795 10.3492 110.158 10.3492C114.821 10.3492 117.511 12.6805 118.707 16.9845C120.44 12.7403 123.668 10.3492 128.51 10.3492C135.026 10.3492 137.656 14.9521 137.656 23.1417V41.9717H126.358V23.9188C126.358 21.1092 125.462 19.7343 123.25 19.7343C120.978 19.7343 119.424 21.2885 119.424 24.7557Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M186.464 42H159.127V32.0387L172.371 22.5302C174.408 21.0021 175.427 19.6437 175.427 17.8326C175.427 15.7384 173.899 14.7197 171.295 14.7197C167.617 14.7197 163.428 16.1912 159.749 18.2287V7.81468C162.41 6.06013 166.428 4.19239 172.993 4.19239C182.672 4.19239 186.747 9.28623 186.747 16.5874C186.747 21.2851 184.313 24.7375 180.068 27.7938L173.729 32.3783C175.88 32.1519 178.314 32.0387 180.295 32.0387H186.464V42ZM203.282 42.6226C198.132 42.6226 193.151 41.6604 189.812 39.4531V29.4352C194.283 32.0953 198.868 32.9443 202.207 32.9443C205.716 32.9443 207.414 31.8123 207.414 29.322C207.414 26.7185 205.603 25.7563 202.886 25.7563C201.301 25.7563 199.773 26.0959 198.302 26.6619L190.944 24.115V4.81497H216.583V14.3801H200.509V21.0587C202.094 20.4361 204.075 20.0399 206.508 20.0399C214.319 20.0399 218.111 24.2282 218.111 30.9067C218.111 38.2079 213.47 42.6226 203.282 42.6226Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M132.866 81.7482V66.707H144.199V70.5761H137.582V72.7281H143.764V75.979H137.582V78.0623H144.336V81.7482H132.866Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M153.084 82C148.482 82 146.559 79.5275 146.559 75.8874V66.707H151.275V75.6356C151.275 77.0092 151.756 77.9936 153.084 77.9936C154.411 77.9936 154.892 77.0092 154.892 75.6356V66.707H159.608V75.8874C159.608 79.5275 157.685 82 153.084 82Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M168.769 70.5074H166.938V73.9414H168.769C170.257 73.9414 170.784 73.2775 170.784 72.1786C170.784 71.1713 170.257 70.5074 168.769 70.5074ZM175.477 72.1328C175.477 74.2162 174.768 75.7042 173.302 76.5742L176.278 81.7482H170.784L168.746 77.3984H166.938V81.7482H162.245V66.707H169.616C173.554 66.707 175.477 68.7904 175.477 72.1328Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M184.822 82C179.877 82 177.107 78.7949 177.107 74.1933C177.107 69.6374 179.877 66.4552 184.822 66.4552C189.744 66.4552 192.514 69.6374 192.514 74.1933C192.514 78.7949 189.744 82 184.822 82ZM184.799 70.5303C182.578 70.5303 181.686 72.2244 181.686 74.2162C181.686 76.2537 182.578 77.9249 184.799 77.9249C187.02 77.9249 187.935 76.2537 187.935 74.2162C187.935 72.2244 187.02 70.5303 184.799 70.5303Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M207.37 72.4762C207.37 76.0705 205.424 78.0852 201.44 78.0852H199.265V81.7482H194.572V66.707H201.44C205.424 66.707 207.37 68.9277 207.37 72.4762ZM201.074 74.468C202.539 74.4909 203.089 73.7125 203.089 72.522C203.089 71.4231 202.539 70.6676 201.074 70.6676H199.265V74.468H201.074Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M209.292 81.7482V66.707H220.624V70.5761H214.008V72.7281H220.189V75.979H214.008V78.0623H220.761V81.7482H209.292Z",
                fill: "white"
            })
        ]
    });
};
const $34b167bb54f433bf$export$5993a58f737301b = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "268",
        height: "52",
        viewBox: "0 0 268 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M173.874 11.4827C173.874 7.49141 176.487 5.02405 180.623 5.02405C184.76 5.02405 187.808 7.56397 187.808 14.0226C187.808 22.1504 182.51 27.5205 172.931 28.0285V21.4247C176.632 21.207 179.462 20.0459 180.333 17.7962H180.26C176.051 17.7962 173.874 15.5466 173.874 11.4827Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.852 35.931C17.852 38.2532 19.0131 39.4143 21.2627 39.4143C22.3513 39.4143 23.3673 39.1966 24.1655 39.0515V50.7351C22.2787 51.1705 20.1742 51.5334 16.9086 51.5334C7.47459 51.5334 4.20897 45.9455 4.20897 37.8178V24.4651H0.725647V13.362H4.20897V5.74219H17.852V13.362H24.1655V24.4651H17.852V35.931Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M46.0395 22.0703C42.6287 22.0703 40.8871 24.5376 40.4516 29.3998H51.4096C51.0468 24.3199 49.3051 22.0703 46.0395 22.0703ZM62.295 49.4289C58.7391 50.7351 53.877 51.6785 49.0148 51.6785C33.993 51.6785 27.244 45.0747 27.244 32.7379C27.244 20.9092 33.7753 12.4911 46.2572 12.4911C58.594 12.4911 63.6738 20.8366 63.6738 32.7379V35.5681H40.7419C41.6127 39.2692 44.1527 40.4303 49.3051 40.4303C53.6592 40.4303 58.4488 39.7772 62.295 38.6886V49.4289Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M79.9321 32.1574C79.9321 37.455 81.6738 40.0674 84.9394 40.0674C87.6245 40.0674 89.9467 38.1081 89.9467 33.6088V30.6334C89.9467 26.0616 87.9873 24.1022 85.2297 24.1022C81.7464 24.1022 79.9321 27.005 79.9321 32.1574ZM89.9467 50.9528V44.2765C87.7696 49.2837 83.8509 51.6785 79.1339 51.6785C70.4256 51.6785 66.4343 43.4782 66.4343 32.1574C66.4343 21.4897 70.4256 12.6363 79.7144 12.6363C84.6491 12.6363 88.0599 15.539 89.9467 19.8206V13.362H103.662V50.9528H89.9467Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M144.979 30.0529V50.9528H131.263V28.5289C131.263 25.4085 130.174 23.9571 127.489 23.9571C124.732 23.9571 122.845 25.8439 122.845 30.0529V50.9528H109.129V13.362H122.845V20.1109C124.877 15.2488 128.433 12.5637 133.73 12.5637C139.391 12.5637 142.656 15.3939 144.108 20.6189C146.212 15.4665 150.131 12.5637 156.009 12.5637C163.919 12.5637 167.112 18.1515 167.112 28.0935V50.9528H153.397V29.0369C153.397 25.6262 152.308 23.9571 149.623 23.9571C146.865 23.9571 144.979 25.8439 144.979 30.0529Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M226.364 51H193.177V38.9072L209.255 27.364C211.728 25.5089 212.965 23.8599 212.965 21.6612C212.965 19.1189 211.11 17.8822 207.949 17.8822C203.483 17.8822 198.399 19.6686 193.933 22.1421V9.49965C197.162 7.36967 202.041 5.10226 210.011 5.10226C221.76 5.10226 226.707 11.2861 226.707 20.1496C226.707 25.8524 223.753 30.0437 218.599 33.754L210.904 39.3194C213.515 39.0446 216.469 38.9072 218.874 38.9072H226.364V51ZM246.781 51.7558C240.528 51.7558 234.482 50.5877 230.428 47.9081V35.7466C235.856 38.9759 241.422 40.0065 245.475 40.0065C249.735 40.0065 251.797 38.6323 251.797 35.6091C251.797 32.4485 249.598 31.2805 246.3 31.2805C244.376 31.2805 242.521 31.6927 240.735 32.3798L231.802 29.2879V5.85807H262.928V17.4699H243.414V25.5776C245.338 24.8218 247.743 24.3408 250.697 24.3408C260.179 24.3408 264.783 29.4253 264.783 37.533C264.783 46.3965 259.149 51.7558 246.781 51.7558Z",
                fill: "white"
            })
        ]
    });
};
const $34b167bb54f433bf$export$652c71226985a987 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1q9y _zulp1b66"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/a8yv1fqb07trq8864u04w2i47cgwd1n0.svg",
                alt: "Team 26 Logo"
            }
        })
    });
};
const $34b167bb54f433bf$export$bc8c600da991a044 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "789",
        height: "192",
        viewBox: "0 0 789 192",
        fill: "none",
        style: {
            maxWidth: "100%",
            aspectRatio: "789/192"
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                children: "Teamwork Collection"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: "0.742188",
                y: "40.0486",
                width: "430.593",
                height: "149.89",
                transform: "rotate(-5 0.742188 40.0486)",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M378.903 119.108L364.48 119.108L364.48 65.0063L378.903 65.0063L378.903 97.2844L387.983 79.5811L403.626 79.5811L392.333 98.8869L403.931 119.108L388.059 119.108L378.903 101.405L378.903 119.108Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M350.811 99.9553L350.811 119.108L336.313 119.108L336.313 79.5812L350.811 79.5812L350.811 87.0593C352.871 81.7178 356.076 78.7418 361.265 79.047L361.265 93.8507C353.558 93.3165 350.811 94.8427 350.811 99.9553Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M312.235 120.1C299.492 120.1 292.09 111.706 292.09 99.2683C292.09 86.9065 299.492 78.6653 312.235 78.6653C324.826 78.6653 332.075 86.9065 332.075 99.2683C332.075 111.706 324.826 120.1 312.235 120.1ZM312.235 91.0271C308.038 91.0271 306.207 94.3083 306.207 99.2683C306.207 104.305 308.038 107.815 312.235 107.815C316.203 107.815 318.034 104.305 318.034 99.2683C318.034 94.3083 316.203 91.0271 312.235 91.0271Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M283.18 119.108L264.256 119.108L260.898 105.526L258.685 92.3245L256.396 105.526L252.962 119.108L235.03 119.108L225.949 79.5812L240.066 79.5812L245.179 109.799L252.428 79.5812L266.545 79.5812L273.87 109.952L278.907 79.5812L292.26 79.5812L283.18 119.108Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M200.528 97.1319L200.528 119.109L186.106 119.109L186.106 95.5295C186.106 92.2483 184.961 90.7221 182.138 90.7221C179.238 90.7221 177.254 92.7061 177.254 97.1319L177.254 119.109L162.832 119.109L162.832 79.5812L177.254 79.5812L177.254 86.6778C179.391 81.5652 183.13 78.7418 188.7 78.7418C194.652 78.7418 198.086 81.7178 199.612 87.212C201.825 81.7941 205.946 78.7418 212.127 78.7418C220.444 78.7418 223.802 84.6175 223.802 95.0716L223.802 119.109L209.38 119.109L209.38 96.0636C209.38 92.4772 208.235 90.7221 205.412 90.7221C202.512 90.7221 200.528 92.7061 200.528 97.1319Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M132.133 99.3447C132.133 104.915 133.964 107.662 137.398 107.662C140.221 107.662 142.663 105.602 142.663 100.871L142.663 97.7423C142.663 92.9349 140.603 90.8746 137.703 90.8746C134.04 90.8746 132.133 93.9269 132.133 99.3447ZM142.663 119.108L142.663 112.088C140.374 117.353 136.253 119.871 131.293 119.871C122.136 119.871 117.939 111.249 117.939 99.3447C117.939 88.1275 122.136 78.818 131.904 78.818C137.093 78.818 140.679 81.8703 142.663 86.3724L142.663 79.5811L157.085 79.5811L157.085 119.108L142.663 119.108Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M96.4941 88.7379C92.9077 88.7379 91.0763 91.3323 90.6184 96.4449L102.141 96.4449C101.759 91.1034 99.928 88.7379 96.4941 88.7379ZM113.587 117.506C109.848 118.879 104.735 119.871 99.6227 119.871C83.8271 119.871 76.7305 112.927 76.7305 99.9551C76.7305 87.517 83.5981 78.6653 96.723 78.6653C109.695 78.6653 115.037 87.4406 115.037 99.9551L115.037 102.931L90.9237 102.931C91.8394 106.823 94.5101 108.044 99.928 108.044C104.506 108.044 109.543 107.357 113.587 106.212L113.587 117.506Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.5723 68.9745L78.1156 68.9745L78.1156 81.8705L67.2036 81.8705L67.2036 119.109L51.4842 119.109L51.4842 81.8705L40.5723 81.8705L40.5723 68.9745Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M783.629 95.744V118.637H776.909V95.0408C776.909 88.0088 774.096 84.8835 767.689 84.8835C761.439 84.8835 757.141 89.0246 757.141 96.916V118.637H750.422V79.5704H757.141V85.9773C759.642 81.3675 764.252 78.7891 769.486 78.7891C778.472 78.7891 783.629 84.9616 783.629 95.744Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M724.174 119.418C712.454 119.418 705.578 110.746 705.578 99.0256C705.578 87.3056 712.454 78.7891 724.174 78.7891C735.816 78.7891 742.613 87.3056 742.613 99.0256C742.613 110.746 735.816 119.418 724.174 119.418ZM724.174 85.0397C715.814 85.0397 712.141 91.603 712.141 99.0256C712.141 106.448 715.814 113.168 724.174 113.168C732.456 113.168 736.05 106.448 736.05 99.0256C736.05 91.603 732.456 85.0397 724.174 85.0397Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M689.811 69.2569C689.811 66.2878 691.764 64.5688 694.499 64.5688C697.233 64.5688 699.187 66.2878 699.187 69.2569C699.187 72.2259 697.233 73.9449 694.499 73.9449C691.764 73.9449 689.811 72.2259 689.811 69.2569ZM691.061 118.637V79.5705H697.78V118.637H691.061Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M672.05 106.526C672.05 109.964 674.082 112.308 678.223 112.308C679.785 112.308 681.27 111.996 682.442 111.761V118.246C681.27 118.559 679.942 118.871 677.91 118.871C669.55 118.871 665.487 113.949 665.487 106.683V85.821H659.158V79.5704H665.487V71.2882H672.05V79.5704H682.442V85.821H672.05V106.526Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M655.081 111.605V117.621C652.737 118.872 649.143 119.418 645.549 119.418C631.641 119.418 625.156 110.98 625.156 99.0256C625.156 87.2275 631.641 78.7891 645.549 78.7891C649.065 78.7891 651.8 79.2579 654.847 80.6643V86.9149C652.347 85.7429 649.69 85.0397 646.018 85.0397C635.861 85.0397 631.719 91.4467 631.719 99.0256C631.719 106.605 635.939 113.012 646.174 113.012C650.159 113.012 652.659 112.465 655.081 111.605Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M602.307 84.8835C595.197 84.8835 591.602 89.4933 590.899 96.291H612.698C612.308 89.0245 609.026 84.8835 602.307 84.8835ZM617.308 117.074C614.105 118.793 609.182 119.418 605.198 119.418C590.587 119.418 584.18 110.98 584.18 99.0256C584.18 87.2275 590.743 78.7891 602.619 78.7891C614.652 78.7891 619.496 87.1493 619.496 99.0256V102.073H590.977C591.915 108.714 596.212 113.012 605.432 113.012C609.964 113.012 613.792 112.152 617.308 110.902V117.074Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M580.443 118.559C579.896 118.715 578.724 118.872 577.005 118.872C570.598 118.872 566.535 115.824 566.535 108.636V63.2405H573.255V107.855C573.255 111.371 575.599 112.621 578.49 112.621C579.193 112.621 579.662 112.621 580.443 112.543V118.559Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M560.074 118.559C559.527 118.715 558.355 118.872 556.636 118.872C550.229 118.872 546.166 115.824 546.166 108.636V63.2405H552.885V107.855C552.885 111.371 555.23 112.621 558.12 112.621C558.824 112.621 559.292 112.621 560.074 112.543V118.559Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M519.916 119.418C508.196 119.418 501.32 110.746 501.32 99.0256C501.32 87.3056 508.196 78.7891 519.916 78.7891C531.558 78.7891 538.356 87.3056 538.356 99.0256C538.356 110.746 531.558 119.418 519.916 119.418ZM519.916 85.0397C511.556 85.0397 507.884 91.603 507.884 99.0256C507.884 106.448 511.556 113.168 519.916 113.168C528.198 113.168 531.792 106.448 531.792 99.0256C531.792 91.603 528.198 85.0397 519.916 85.0397Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M496.389 109.574V116.371C493.186 118.481 488.107 119.418 482.794 119.418C465.917 119.418 456.385 109.261 456.385 93.0874C456.385 77.4607 465.917 66.522 482.638 66.522C487.638 66.522 492.639 67.4596 496.311 70.1161V76.9137C492.639 74.5697 488.576 73.3196 482.638 73.3196C470.605 73.3196 463.417 81.2892 463.417 93.0874C463.417 104.886 470.839 112.699 483.028 112.699C488.419 112.699 492.639 111.449 496.389 109.574Z",
                fill: "#101214"
            })
        ]
    });
};
const $34b167bb54f433bf$var$strokeRight = null;
const $34b167bb54f433bf$var$accentImgStyles = null;

});

parcelRegister("Oss1q", function(module, exports) {
$parcel$export(module.exports, "HomepageSectionScrollItem", function () { return $f8da8aca82d44f4c$export$6a1cd3650e2b4806; });
/* scroll-item.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $j6FQw = parcelRequire("j6FQw");

var $chr3l = parcelRequire("chr3l");
const $f8da8aca82d44f4c$export$6a1cd3650e2b4806 = (props)=>{
    var _props_productCTA, _props_productCTA1;
    const intl = (0, $8e22h.default)();
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)({
        threshold: 0.1,
        rootMargin: "-40% 0px -40% 0px"
    });
    const getItFreeText = intl.formatMessage({
        id: "HomePage.ScrollPinnedSection.getItFreeText",
        defaultMessage: "Get it free"
    });
    const { setActiveAccentImg: setActiveAccentImg, setActiveColor: setActiveColor, setActiveProductCTAText: setActiveProductCTAText, setActiveProductCTAUrl: setActiveProductCTAUrl, setActiveShape: setActiveShape, setActiveFeatureVideo: setActiveFeatureVideo, setActivePosterImage: setActivePosterImage, setActiveStaticImage: setActiveStaticImage, setActiveIndex: setActiveIndex } = (0, $1oC0p.useContext)((0, $chr3l.ScrollContext));
    (0, $1oC0p.useEffect)(()=>{
        if (sectionIsVisible) {
            setActiveAccentImg(props.accentImg);
            setActiveColor(props.bgColor);
            setActiveProductCTAText(props.productCTA.text);
            setActiveProductCTAUrl(props.productCTA.url);
            setActiveIndex(props.index || 0);
            setActiveShape(props.bgShape);
            setActiveFeatureVideo(props.featureVideo);
            setActivePosterImage(props.posterImage);
            setActiveStaticImage(props.staticImage || "");
        }
    });
    const brandDimensions = {
        width: 68,
        height: 68
    };
    const posterImageDimensions = {
        width: 1920,
        height: 1080
    };
    const shouldRenderCustomerCTA = props.customerCTAUrl && !props.productCTA.text.includes("Loom");
    const renderSummary = (summary)=>{
        if (props.customerCTAUrl && props.productCTA.text.includes("Loom")) return /*#__PURE__*/ (0, $7VQPk.jsxs)("blockquote", {
            className: (0, $2jatx.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
            ]),
            children: [
                '"',
                summary,
                '" ',
                /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                    className: "name",
                    children: [
                        "- ",
                        props.name
                    ]
                }),
                ".",
                " ",
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: "title",
                    children: props.title
                })
            ]
        });
        const firstWord = summary.split(" ")[0] || "";
        const restOfSummary = summary.substring(firstWord.length);
        return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: "first-word",
                    children: firstWord
                }),
                restOfSummary
            ]
        });
    };
    const { ref: ref } = (0, $j6FQw.useScrollTracking)("ScrollPinnedSections_" + props.productLogoName);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-section-scroll-item",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _6rthuuw1 _1egl1ylp _na0i1bp4 _dh1a1h6o",
                "team-type"
            ]),
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_101fkb7n _dh1a1h6o",
                        `team-card ${sectionIsVisible ? "active" : "inactive"}`
                    ]),
                    ref: scrollRef,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3i1tcg _19pkidpf _2hwxidpf _otyr19bv _18u0idpf _1bsb1ns9 _3wvkidpf _1fbn1wug _1ubyidpf _1t0r1wug"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.LogoV3), {
                                height: "24",
                                brand: props.productLogoName,
                                type: "logo",
                                appearance: "brand"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                            className: (0, $2jatx.default)([
                                "_1wybviql _19pkidpf _2hwxidpf _otyridpf _18u0idpf _gu181h6o"
                            ]),
                            children: props.header
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_12l21ul9 _1pfh1crf _p12fkbql _qwozidpf _gu181h6o",
                                "body-lg"
                            ]),
                            children: props.description
                        }),
                        props.productCTA && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx2vrvc _zulpgktf _4cvr1h6o _14q21bp4 _1wm07vkz _o5kc1h6o"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                    "aria-label": props.productCTA.tryLabel,
                                    className: "cta-button",
                                    variant: "primary",
                                    size: "small",
                                    href: props.productCTA.tryCloudUrl,
                                    dataEventProps: {
                                        "data-product-key": "home",
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "scrollPinnedSection",
                                        "data-label": getItFreeText,
                                        "data-label-english": getItFreeText /* FIXME: This is currently translated, can it be updated to be English as intended? */ 
                                    },
                                    children: getItFreeText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    "aria-label": props.productCTA.text,
                                    text: props.productCTA.text,
                                    href: props.productCTA.url,
                                    dataEventProps: {
                                        "data-product-key": "home",
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "scrollPinnedSection",
                                        "data-label": (_props_productCTA = props.productCTA) === null || _props_productCTA === void 0 ? void 0 : _props_productCTA.text,
                                        "data-label-english": (_props_productCTA1 = props.productCTA) === null || _props_productCTA1 === void 0 ? void 0 : _props_productCTA1.text /* FIXME: This is currently translated, can it be updated to be English as intended? */ 
                                    },
                                    type: "primary"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _1pfhzwfg _bfhkcd5j _ca0q1ul9 _u5f3gktf _n3td1ul9 _19bvgktf _kqswh2mm _2rkogktf _16qsdtw3 _zulp7vkz _p12fkbql"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_mezj9klo _bna79klo _zavh88uy _1jpx1f51"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                        image: {
                                            src: props.brand,
                                            alt: props.title,
                                            width: brandDimensions.width,
                                            height: brandDimensions.height
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _zg8l4jg8 _syaz1hlo _1wyb1gpt _vwz4a982 _1e0c1nu9 _k48p1fw0 _z3358n31 _14dk8n31 _1axo8n31",
                                        "body-sm"
                                    ]),
                                    style: {
                                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                    },
                                    children: [
                                        renderSummary(props.summary),
                                        " ",
                                        shouldRenderCustomerCTA && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                            ariaLabel: props.customerCTALabel,
                                            "aria-label": props.customerCTALabel,
                                            text: props.customerCTA,
                                            href: props.customerCTAUrl,
                                            dataEventProps: {
                                                "data-product-key": "home",
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                "data-event-container": "scrollPinnedSection",
                                                "data-label": props.customerCTA,
                                                "data-label-english": props.productCTA.text
                                            },
                                            type: "inline",
                                            className: (0, $2jatx.default)([
                                                "_1wyb7vkz _syaz17la _30l31a21 _1e0c1nu9"
                                            ]),
                                            style: {
                                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0cglyw _kqswh2mm _1h1t15ju _1bsb1osq _ca0qo7ao _u5f3o7ao _n3tdo7ao _19bvo7ao _19pk1ul9 _2hwx1wug _otyr1ylp _18u01wug _1mjb1ule _dh1a1h6o",
                        "img-region"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _4t3i1osq _v564t24z _kqswstnw _1e02idpf _152tidpf",
                                "bg-shape"
                            ]),
                            style: {
                                clipPath: `polygon(${props.bgShape})`,
                                backgroundColor: `#${props.bgColor}`
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsbx19p _kqswstnw _1e023ll0 _u7co15qf",
                                "img-accent"
                            ]),
                            children: props.accentImg
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_f45rh2mm _v4pn1ule _bna71wug _mezj1osq _1cr61wug _1hlx1wug _18741wug _10ew1wug _m3691ur6 _1biu14y2 _nj221ia1"
                            ]),
                            style: {
                                "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: props.staticImage || props.posterImage,
                                    alt: "",
                                    className: "img-screenshot",
                                    width: posterImageDimensions.width,
                                    height: posterImageDimensions.height
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $f8da8aca82d44f4c$var$teamTypeStyles = null;
const $f8da8aca82d44f4c$var$teamCardStyles = null;
const $f8da8aca82d44f4c$var$imgRegionStyles = null;
const $f8da8aca82d44f4c$var$bgShapeStyles = null;
const $f8da8aca82d44f4c$var$imgAccentStyles = null;
const $f8da8aca82d44f4c$var$logoStyles = null;
const $f8da8aca82d44f4c$var$h3Styles = null;
const $f8da8aca82d44f4c$var$descriptionStyles = null;
const $f8da8aca82d44f4c$var$imgScreenshotStyles = null;
const $f8da8aca82d44f4c$var$exploreProductWrapper = null;
const $f8da8aca82d44f4c$var$quoteStyles = null;
const $f8da8aca82d44f4c$var$brandStyles = null;
const $f8da8aca82d44f4c$var$quotePStyles = null;
const $f8da8aca82d44f4c$var$customerCTALinkStyles = null;
const $f8da8aca82d44f4c$var$blockquoteStyles = null;

});


parcelRegister("9EccP", function(module, exports) {
$parcel$export(module.exports, "TabsAndIntegrationsSections", function () { return $138685bbcf8c9435$export$842eb57c18f649c7; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $6hzTZ = parcelRequire("6hzTZ");

var $jaEEJ = parcelRequire("jaEEJ");

var $lacF7 = parcelRequire("lacF7");
const $138685bbcf8c9435$export$842eb57c18f649c7 = ()=>{
    const intl = (0, $8e22h.default)();
    const h2Text = intl.formatMessage({
        id: "HomePageTemplateV2.tabsSection.header",
        defaultMessage: "Empower everyone, on every team"
    });
    const tabsData = (0, $lacF7.TEAM_DATA).map((team)=>{
        return {
            id: team.id,
            title: intl.formatMessage(team.title),
            englishLabel: team.englishLabel,
            tabComponent: team.tabComponent
        };
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-tabs",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6hzTZ.TabsWithCards), {
            h2Text: h2Text,
            tabsData: tabsData,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jaEEJ.Integrations), {})
        })
    });
};
$138685bbcf8c9435$export$842eb57c18f649c7.displayName = "TabsAndIntegrationsSections";

});
parcelRegister("lacF7", function(module, exports) {
$parcel$export(module.exports, "TEAM_DATA", function () { return $445869e5c73ef800$export$860b41270ca4de2e; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
parcelRequire("aCRZP");
var $18nSp = parcelRequire("18nSp");
var $j9bZ4 = parcelRequire("j9bZ4");
var $8przL = parcelRequire("8przL");
var $icFXt = parcelRequire("icFXt");
var $iSJdh = parcelRequire("iSJdh");
var $fB0qg = parcelRequire("fB0qg");
const $445869e5c73ef800$export$860b41270ca4de2e = [
    {
        id: "software",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/y78pxiri4im6b485s60361vjjgttjq60.svg",
        iconHover: "https://dam-cdn.atl.orangelogic.com/AssetLink/o8h5chftg22x85ps525w8768s2eky18x.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/k70j5y22805lb5y6pyq7q63ihodb2omd.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1116
        },
        title: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tabsSection.label.tab1",
            defaultMessage: "Software"
        }),
        englishLabel: "Software",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fB0qg.SoftwareTabContent), {})
    },
    {
        id: "product-management",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/0mvyg5jf3k403i8ty72n084i545pde2m.svg",
        iconHover: "https://dam-cdn.atl.orangelogic.com/AssetLink/n674f3ny04d687nl4m3b5vwa2677770v.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/v0085b7i05x27m3tdm1w0yti22sk7qp5.webp",
        heroImageDimensions: {
            imageWidth: 1920,
            imageHeight: 1080
        },
        title: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tabsSection.label.tab2",
            defaultMessage: "Product management"
        }),
        englishLabel: "Product management",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $icFXt.ProductManagementTabContent), {})
    },
    {
        id: "marketing",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/35m6e03565pb2fm07elldn1xb857lt43.svg",
        iconHover: "https://dam-cdn.atl.orangelogic.com/AssetLink/6rw076257b8r6vxfm21ehv234yfy7112.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/7uegfcjc0ol7tn782otgrdmv35240y58.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1116
        },
        title: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tabsSection.label.tab3",
            defaultMessage: "Marketing"
        }),
        englishLabel: "Marketing",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8przL.MarketingTabContent), {})
    },
    {
        id: "project-management",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/s1j8j242m6jjo3578e431100p32am24a.svg",
        iconHover: "https://dam-cdn.atl.orangelogic.com/AssetLink/r7o21ms42c827k3n16yb33u35n7o3m1b.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/27w6oy8027xwq54376g5xw1t3213xx14.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1116
        },
        title: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tabsSection.label.tab4",
            defaultMessage: "Project management"
        }),
        englishLabel: "Project management",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iSJdh.ProjectManagementTabContent), {})
    },
    {
        id: "design",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/8jy3dr538kece81qw223jiv4q1u33hfi.svg",
        iconHover: "https://dam-cdn.atl.orangelogic.com/AssetLink/v70w3b02mw3gi8338otv12n61b050h8c.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/581224jlndm01qq300iw735ip0s542m6.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1116
        },
        title: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tabsSection.label.tab5",
            defaultMessage: "Design"
        }),
        englishLabel: "Design",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $18nSp.DesignTabContent), {})
    },
    {
        id: "it",
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/05b0n5p23i0uy545bl2hnt2x03l8t8l8.svg",
        iconHover: "https://dam-cdn.atl.orangelogic.com/AssetLink/o3s7vy83q8t61ac8bmtkby74a2874842.svg",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/4j4t5t2k248nyo05bp781l44ejmv4c8q.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1116
        },
        title: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplateV2.tabsSection.label.tab6",
            defaultMessage: "IT"
        }),
        englishLabel: "IT",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j9bZ4.ITTabContent), {})
    }
];
const $445869e5c73ef800$var$NEW_SCREENSHOT_DATA = {
    "default": {
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/qgeohf56651o63ux63s54547n4v512b6/software-hero-image.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1042
        }
    },
    "software": {
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/qgeohf56651o63ux63s54547n4v512b6/software-hero-image.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1042
        }
    },
    "product-management": {
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/kc04egnvyt51q188pu5an5l2uwy44joo/product-management-hero-image.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1042
        }
    },
    "marketing": {
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/0ua8683t5q40s3s4n20v6et1w2a6k0rl/marketing-hero-image.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1042
        }
    },
    "project-management": {
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/j8x7lkoo45f2g8030g518wi037i4h66e/project-management-hero-image.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1042
        }
    },
    "design": {
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/1yq782y1pl0v22tr304mk24ydiipi8n7/design-hero-image.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1042
        }
    },
    "it": {
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/r58kkxw02ur240tp0yp8233301okxsi2/it-hero-image.webp",
        heroImageDimensions: {
            imageWidth: 1984,
            imageHeight: 1042
        }
    }
};
// Create new screenshots variant by overriding heroImage and optionally heroImageDimensions
const $445869e5c73ef800$export$1bcebc6df1714de1 = $445869e5c73ef800$export$860b41270ca4de2e.map((team)=>{
    const newData = $445869e5c73ef800$var$NEW_SCREENSHOT_DATA[team.id];
    return (0, $6ogO3._)((0, $dPABA._)((0, $6ogO3._)({}, team), {
        heroImage: newData.heroImage
    }), newData.heroImageDimensions && {
        heroImageDimensions: newData.heroImageDimensions
    });
});

});
parcelRegister("aCRZP", function(module, exports) {
$parcel$export(module.exports, "ProductManagementTabContent", function () { return (parcelRequire("icFXt")).ProductManagementTabContent; });
$parcel$export(module.exports, "SoftwareTabContent", function () { return (parcelRequire("fB0qg")).SoftwareTabContent; });
$parcel$export(module.exports, "MarketingTabContent", function () { return (parcelRequire("8przL")).MarketingTabContent; });
$parcel$export(module.exports, "ProjectManagementTabContent", function () { return (parcelRequire("iSJdh")).ProjectManagementTabContent; });
$parcel$export(module.exports, "ITTabContent", function () { return (parcelRequire("j9bZ4")).ITTabContent; });
$parcel$export(module.exports, "DesignTabContent", function () { return (parcelRequire("18nSp")).DesignTabContent; });

var $icFXt = parcelRequire("icFXt");

var $fB0qg = parcelRequire("fB0qg");

var $8przL = parcelRequire("8przL");

var $iSJdh = parcelRequire("iSJdh");

var $j9bZ4 = parcelRequire("j9bZ4");

var $18nSp = parcelRequire("18nSp");

});
parcelRegister("icFXt", function(module, exports) {
$parcel$export(module.exports, "ProductManagementTabContent", function () { return $a07f0dc54e4ba470$export$665f34a3be401a32; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $a07f0dc54e4ba470$export$665f34a3be401a32 = ()=>{
    const intl = (0, $8e22h.default)();
    const useNewScreenshots = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9214HomepageScreenshots);
    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.prodManagement.card.linkText",
        defaultMessage: "Try it out"
    });
    const cardDataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };
    const cardOneCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/product-discovery");
    const cardTwoCtaUrl = (0, $kooLp.useLocalizedHref)("/software/confluence/templates/strategic-plan");
    const cardThreeCtaUrl = (0, $kooLp.useLocalizedHref)("/software/confluence/templates/product-requirements");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        className: "homepage-tabs-content",
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.prodManagement.header",
                    defaultMessage: "Build products like the best of them"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.prodManagement.bodytext",
                    defaultMessage: "Prioritize your most impactful ideas, build roadmaps to engage stakeholders, and plan and track your work with end-to-end visibility"
                })
            }
        ],
        pictureProps: {
            image: {
                src: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/pb6f6f1vl440b03knflxg25et82lxa4m/product-management-teams.webp" : "https://dam-cdn.atl.orangelogic.com/AssetLink/2c667j153e7n6a2nc64mnl106sk2lyj8.webp",
                alt: "",
                height: 800,
                width: 1536
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "HomePageTemplateV2.tab.prodManagement.resources",
            defaultMessage: "Get started with a template"
        }),
        cardsContent: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.prodManagement.card1.headerText",
                    defaultMessage: "Product discovery"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.prodManagement.card1.bodyText",
                    defaultMessage: "Prioritize ideas and create custom shareable product roadmaps"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardOneCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/pm-card-1.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.prodManagement.card2.headerText",
                    defaultMessage: "Strategic planning"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.prodManagement.card2.bodyText",
                    defaultMessage: "Present your business vision and help your team understand your strategic plan"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardTwoCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/pm-card-2.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.prodManagement.card3.headerText",
                    defaultMessage: "Product requirements"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.prodManagement.card3.bodyText",
                    defaultMessage: "Keep track of your pre-launch prep and post-launch progress"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardThreeCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/pm-card-3.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            }
        ]
    });
};

});

parcelRegister("fB0qg", function(module, exports) {
$parcel$export(module.exports, "SoftwareTabContent", function () { return $78b6b33309fed867$export$d06aa53b34b41c2e; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $78b6b33309fed867$export$d06aa53b34b41c2e = ()=>{
    const intl = (0, $8e22h.default)();
    const useNewScreenshots = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9214HomepageScreenshots);
    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.software.card.linkText",
        defaultMessage: "Try it out"
    });
    const cardDataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };
    const cardOneCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/scrum");
    const cardTwoCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/bug-tracking");
    const cardThreeCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/devops");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        className: "homepage-tabs-content",
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.software.header",
                    defaultMessage: "Supercharge dev productivity"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.software.bodytext",
                    defaultMessage: "Plan, track, and release world-class software with the number one software development tool for agile teams"
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "HomePageTemplateV2.tab.software.learnMore",
                defaultMessage: "Learn more about Software"
            }),
            link: (0, $kooLp.useLocalizedHref)("/teams/software-development"),
            linkLabel: "Learn more about Software",
            productKey: "home"
        },
        pictureProps: {
            image: {
                src: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/8t57sjpe86510t2o653k03ly4i64t6m1/software-tab-content-image.webp" : "https://dam-cdn.atl.orangelogic.com/AssetLink/6ec6l1er431c3675ljyq10n08xjpc4h1.webp",
                alt: "",
                height: 800,
                width: 1536
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "HomePageTemplateV2.tab.software.tabContentEyebrowText",
            defaultMessage: "Get started with a template"
        }),
        cardsContent: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.software.card1.headerText",
                    defaultMessage: "Scrum"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.software.card1.bodyText",
                    defaultMessage: "Easily plan, track, and manage work across sprints"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardOneCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/80h73kh13eu8gdp17cu328nd42wgdfc0.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.software.card2.headerText",
                    defaultMessage: "Bug Tracking"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.software.card2.bodyText",
                    defaultMessage: "Seamlessly report, track, and prioritize bugs to address development issues"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardTwoCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/d714385iejcny2r050x60440qn8axp88.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.software.card3.headerText",
                    defaultMessage: "DevOps"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.software.card3.bodyText",
                    defaultMessage: "Develop, deploy, and manage applications with an open tools approach"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardThreeCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r4dy6nvsu13563346v0610o3de6vfmc2.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            }
        ]
    });
};

});

parcelRegister("8przL", function(module, exports) {
$parcel$export(module.exports, "MarketingTabContent", function () { return $c36943db38dcdaed$export$ba08d9549fcf64c3; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $c36943db38dcdaed$export$ba08d9549fcf64c3 = ()=>{
    const intl = (0, $8e22h.default)();
    const useNewScreenshots = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9214HomepageScreenshots);
    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.marketing.card.linkText",
        defaultMessage: "Try it out"
    });
    const cardDataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };
    const cardOneCtaUrl = (0, $kooLp.useLocalizedHref)("/software/confluence/templates/customer-journey-mapping");
    const cardTwoCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/content-management");
    const cardThreeCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/campaign-management");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        className: "homepage-tabs-content",
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.marketing.header",
                    defaultMessage: "Bring marketing closer to product"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.marketing.bodytext",
                    defaultMessage: "Track your work easily, run cross-functional marketing projects, and remove silos so you deliver real impact."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "HomePageTemplateV2.tab.marketing.learnMore",
                defaultMessage: "Learn more about Marketing"
            }),
            link: (0, $kooLp.useLocalizedHref)("/teams/marketing"),
            linkLabel: "Learn more about Marketing",
            productKey: "home"
        },
        pictureProps: {
            image: {
                src: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/03ab1y5of6ggemomv5hgge1h6y2n32yy/marketing-teams.webp" : "https://dam-cdn.atl.orangelogic.com/AssetLink/7s5rkhku1iv78na0b7w80720ycm373xi.webp",
                alt: "",
                height: 800,
                width: 1536
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "HomePageTemplateV2.tab.marketing.resources",
            defaultMessage: "Get started with a template"
        }),
        cardsContent: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.marketing.card1.headerText",
                    defaultMessage: "Customer journey mapping"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.marketing.card1.bodyText",
                    defaultMessage: "Visualize how customers experience your product or service"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardOneCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-1.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.marketing.card2.headerText",
                    defaultMessage: "Content management"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.marketing.card2.bodyText",
                    defaultMessage: "Oversee your marketing content lifecycle from draft to delivery"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardTwoCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-2.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.marketing.card3.headerText",
                    defaultMessage: "Campaign management"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.marketing.card3.bodyText",
                    defaultMessage: "Track tasks and deadlines while managing end-to-end campaigns"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardThreeCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/marketing-card-3.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            }
        ]
    });
};

});

parcelRegister("iSJdh", function(module, exports) {
$parcel$export(module.exports, "ProjectManagementTabContent", function () { return $2e84b607b14496ed$export$246baec0621b4bed; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $2e84b607b14496ed$export$246baec0621b4bed = ()=>{
    const intl = (0, $8e22h.default)();
    const useNewScreenshots = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9214HomepageScreenshots);
    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.projManagement.card.linkText",
        defaultMessage: "Try it out"
    });
    const cardDataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };
    const cardOneCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/scrum");
    const cardTwoCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/kanban");
    const cardThreeCtaUrl = (0, $kooLp.useLocalizedHref)("/agile/project-management/gantt-chart");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        className: "homepage-tabs-content",
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.projManagement.header",
                    defaultMessage: "Perfect your project management"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.projManagement.bodytext",
                    defaultMessage: "Plan, track, and measure any project - from simple to complex - to ensure a smooth delivery."
                })
            }
        ],
        pictureProps: {
            image: {
                src: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/p75wc0x52sjd6s72ad14u5d3753f84cq/project-management-teams.webp" : "https://dam-cdn.atl.orangelogic.com/AssetLink/ny0k1426i6ykja1nc43x3y2wiu234c3f.webp",
                alt: "",
                height: 800,
                width: 1536
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "HomePageTemplateV2.tab.projManagement.resources",
            defaultMessage: "Get started with a template"
        }),
        cardsContent: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.projManagement.card1.headerText",
                    defaultMessage: "Scrum"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.projManagement.card1.bodyText",
                    defaultMessage: "Easily plan, track, and manage work across sprints"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardOneCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/projm-card-1.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.projManagement.card2.headerText",
                    defaultMessage: "Kanban"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.projManagement.card2.bodyText",
                    defaultMessage: "Manage a continuous delivery of work on a collaborative board"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardTwoCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/projm-card-2.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.projManagement.card3.headerText",
                    defaultMessage: "Gantt chart"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.projManagement.card3.bodyText",
                    defaultMessage: "Visualize timelines, progress, tracking, and dependencies"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardThreeCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/projm-card-3.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            }
        ]
    });
};

});

parcelRegister("j9bZ4", function(module, exports) {
$parcel$export(module.exports, "ITTabContent", function () { return $00b6e06499225aaf$export$ea5f5ddaeaf0c46; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $00b6e06499225aaf$export$ea5f5ddaeaf0c46 = ()=>{
    const intl = (0, $8e22h.default)();
    const useNewScreenshots = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9214HomepageScreenshots);
    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.it.card.linkText",
        defaultMessage: "Try it out"
    });
    const cardDataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };
    const cardOneCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/facilities-service-management");
    const cardTwoCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/it-service-management");
    const cardThreeCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/hr-service-management");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        className: "homepage-tabs-content",
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.it.header",
                    defaultMessage: "Unlock high-velocity service for all"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.it.bodytext",
                    defaultMessage: "Connect Dev, IT, and business teams to quickly respond to change and deliver exceptional service experiences"
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "HomePageTemplateV2.tab.it.learnMore",
                defaultMessage: "Learn more about IT"
            }),
            link: (0, $kooLp.useLocalizedHref)("/teams/it"),
            linkLabel: "Learn more about IT",
            productKey: "home"
        },
        pictureProps: {
            image: {
                src: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/egqo3065k6f02e4016gxti5872h2s515/it-teams.webp" : "https://dam-cdn.atl.orangelogic.com/AssetLink/erpfrtir1d4jla3a6al3c0txh4624gbt.webp",
                alt: "",
                height: 800,
                width: 1536
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "HomePageTemplateV2.tab.it.resources",
            defaultMessage: "Get started with a template"
        }),
        cardsContent: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.it.card1.headerText",
                    defaultMessage: "Facilities"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.it.card1.bodyText",
                    defaultMessage: "Manage requests for maintenance, moving, and event planning."
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardOneCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-1.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.it.card2.headerText",
                    defaultMessage: "IT Service Management"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.it.card2.bodyText",
                    defaultMessage: "Respond to requests, resolve incidents, and deploy changes fast."
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardTwoCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-2.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.it.card3.headerText",
                    defaultMessage: "HR Service Management"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.it.card3.bodyText",
                    defaultMessage: "Simplify onboarding, off-boarding, and any HR request."
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardThreeCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-3.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            }
        ]
    });
};

});

parcelRegister("18nSp", function(module, exports) {
$parcel$export(module.exports, "DesignTabContent", function () { return $aafc7e35db0f18d1$export$586a69ae3f9930e9; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $aafc7e35db0f18d1$export$586a69ae3f9930e9 = ()=>{
    const intl = (0, $8e22h.default)();
    const useNewScreenshots = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9214HomepageScreenshots);
    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.design.card.linkText",
        defaultMessage: "Try it out"
    });
    const cardDataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };
    const cardOneCtaUrl = (0, $kooLp.useLocalizedHref)("/software/jira/templates/web-design-process");
    const cardTwoCtaUrl = (0, $kooLp.useLocalizedHref)("/software/confluence/templates/design-system");
    const cardThreeCtaUrl = (0, $kooLp.useLocalizedHref)("/software/confluence/templates/design-decision");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        className: "homepage-tabs-content",
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.design.header",
                    defaultMessage: "Design with all the right context"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.design.bodytext",
                    defaultMessage: "Organize work, synchronize teams, and meet deadlines \u2013 all without sacrificing creativity"
                })
            }
        ],
        pictureProps: {
            image: {
                src: useNewScreenshots ? "https://dam-cdn.atl.orangelogic.com/AssetLink/f51x8o4l87gk84c6v48gtqp3e3313en7/design-teams.webp" : "https://dam-cdn.atl.orangelogic.com/AssetLink/g2gu10rc2261mhhjc68i1h68g750tx6p.webp",
                alt: "",
                height: 800,
                width: 1536
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "HomePageTemplateV2.tab.design.resources",
            defaultMessage: "Get started with a template"
        }),
        cardsContent: [
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.design.card1.headerText",
                    defaultMessage: "Web design process"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.design.card1.bodyText",
                    defaultMessage: "Keep designers and developers on the same page"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardOneCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-1.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.design.card2.headerText",
                    defaultMessage: "Design system"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.design.card2.bodyText",
                    defaultMessage: "Scale your design team by developing a unified design system"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardTwoCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-2.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            },
            {
                headerText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.design.card3.headerText",
                    defaultMessage: "Design decisions"
                }),
                bodyText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.design.card3.bodyText",
                    defaultMessage: "Present design solutions and exchange creative feedback with your team"
                }),
                ctaProps: {
                    text: cardCtaText,
                    href: cardThreeCtaUrl,
                    dataEventProps: cardDataEventProps
                },
                pictureProps: {
                    image: {
                        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-3.webp",
                        alt: "",
                        height: 215,
                        width: 368
                    }
                }
            }
        ]
    });
};

});




parcelRegister("6zyuZ", function(module, exports) {
$parcel$export(module.exports, "TeamStats", function () { return $e193a1e13d602412$export$627ec3b18fd69bf7; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $4Fnxt = parcelRequire("4Fnxt");
const $e193a1e13d602412$export$627ec3b18fd69bf7 = ()=>{
    const intl = (0, $8e22h.default)();
    const statsProps = {
        headerText: intl.formatMessage({
            id: "HomePageTemplateV2.teamStatsHeader",
            defaultMessage: "Teams across the globe run on Atlassian"
        }),
        bigStat: {
            stat: "300000",
            statText: intl.formatMessage({
                id: "HomePageTemplateV2.teamStatsCompaniesTxt",
                defaultMessage: "companies power team collaboration with Atlassian"
            }),
            statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: "200",
                statText: intl.formatMessage({
                    id: "HomePageTemplateV2.teamStatsPeopleTxt",
                    defaultMessage: "countries and territories have companies that use Atlassian"
                }),
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "+",
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            },
            {
                stat: "80",
                statText: intl.formatMessage({
                    id: "HomePageTemplateV2.teamStatsFortune500Txt",
                    defaultMessage: "of Fortune 500 companies use Atlassian products"
                }),
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-stats",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Fnxt.Stats), (0, $6ogO3._)({}, statsProps))
        })
    });
};
$e193a1e13d602412$export$627ec3b18fd69bf7.displayName = "TeamStats";

});

parcelRegister("7HeQU", function(module, exports) {

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $6nuoQ = parcelRequire("6nuoQ");
const $044da41cee076e4b$export$8b702a7c38c32e2e = (props)=>{
    const bannerMessages = {
        identifier: "TeamTourJapanBanner",
        text: "Atlassian TEAM TOUR Tokyo 2024 \u306E\u30BB\u30C3\u30B7\u30E7\u30F3\u52D5\u753B\u3092\u671F\u9593\u9650\u5B9A\u3067\u516C\u958B\u3057\u307E\u3059",
        mobileHeaderText: "TEAM TOUR: TOKYO",
        linkText: "\u8A73\u7D30\u30FB\u304A\u7533\u3057\u8FBC\u307F\u306F\u3053\u3061\u3089",
        linkUrl: "https://events.atlassian.com/teamtour_tokyo?ref=self-referral_butter-banner&utm_medium=self-referral&utm_source=butter-banner&utm_campaign=V:butter-banner*O:japan*H:fy25q1*I:ttt24",
        dataEventProps: {
            "data-product-key": props.dataProductKey,
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "\u8A73\u7D30\u30FB\u304A\u7533\u3057\u8FBC\u307F\u306F\u3053\u3061\u3089"
        },
        lockupImageSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-11737 TeamTour_Tokyo_lockup.svg"
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nuoQ.TeamTourBannerAlert), (0, $6ogO3._)({}, bannerMessages));
};

});
parcelRegister("6nuoQ", function(module, exports) {
$parcel$export(module.exports, "TeamTourBannerAlert", function () { return $25c1e39a47f8dacd$export$c02e8513fa5c7e81; });
/* team-tour-banner.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $2gCne = parcelRequire("2gCne");
const $25c1e39a47f8dacd$export$c02e8513fa5c7e81 = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, lockupImageSrc: lockupImageSrc, mobileHeaderText: mobileHeaderText })=>{
    const intl = (0, $8e22h.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const lockupImage = `url("${lockupImageSrc}") no-repeat 100% 100% / contain`;
    const containerWrapperStyles = null;
    const containerStyles = null;
    const contentWrapperStyles = null;
    const contentStyles = null;
    const backgroundShapeStyles = null;
    const lockupStyles = null;
    const dividerStyles = null;
    const textStyles = null;
    const linkStyles = null;
    const fillStyles = null;
    const closeIconStyles = null;
    const svgStyles = null;
    const mobileHeaderStyles = null;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        const dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem, true);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-dismissed": isHidden,
        className: (0, $2jatx.default)([
            "_bfhk1ybm _kqswh2mm _1e0c1txw _4cvr1h6o _4t3i1osq _1bsb1osq _179r42li _nzmgglyw _lnvuqkoa"
        ]),
        style: {
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100")),
            "--_1eeiexs": (0, $6ZVlx.default)("2px solid " + (0, $kbpa7.wacToken)("color.primary.blue"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1ii7kb7n _1pbykb7n _1bsb2pqz _4t3in6wy _11q7yij6 _1lrw1dfr _1wpzh9n0 _1e0cglyw _1gyk1ule"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bsb1osq _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _1bah1h6o _6a6z1h6o _ae4v1h6o _4cvr1h6o _zulpzwfg _1bsb1osq _qpwiv2br _1qoq1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1ii7kb7n _1bsb1lit _4t3ickbl _11q7mwcv _sugaglyw _181n1ule _1gyk1ule"
                                ]),
                                style: {
                                    "--_1ub8bb2": (0, $6ZVlx.default)(lockupImage)
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_bfhk1hap _1e0cglyw _4t3i1osq _1bsbt94y _1ii7kb7n _1jopmgvx _181n1ule _lnvu16xz"
                                ]),
                                style: {
                                    "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1ii7kb7n _1e0c116y _2lx21bp4 _1bahv2br _6a6z1h6o _ae4vv2br _4cvrv2br _zulpftgi _1bsb1osq _1gyk11p5 _qpwiv2br _1r0d1h6o _e55g1h6o _14yg1h6o _1g2tzwfg _t78c11p5 _1qoq1h6o _l3cq1h6o _1h7e1h6o _13u51h6o _1mkezwfg"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c1ule _1p1dangw _11c8bzd7 _1wybdlk8 _vwz4f6fq _4t3ildb6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _179r1eyj _181nglyw"
                                        ]),
                                        style: {
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                            "--_e5vmzr": (0, $6ZVlx.default)("1px solid " + (0, $kbpa7.wacToken)("color.neutral.light700"))
                                        },
                                        children: mobileHeaderText
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1ii7kb7n _syazvejh _11c8bzd7 _1wyb7vkz _vwz41tcg _k48p1nn1 _1pfhidpf _1bsb1osq _p12f1osq _1d3v19ly _lnvu16xz"
                                        ]),
                                        style: {
                                            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000")),
                                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                        },
                                        children: text
                                    }),
                                    linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                        text: linkText,
                                        "aria-label": linkText,
                                        href: linkUrl,
                                        type: "inline",
                                        dataEventProps: dataEventProps,
                                        className: (0, $2jatx.default)([
                                            "_1ii7kb7n _4t3i1l8w _ect4lnmy _1wyb7vkz _vwz4gktf _y3gn1e5h _syaz12e3 _4bfu1snc _1hmsagmp _ajmmvv82 _59381snc _yha2agmp _1nmzvv82 _1a9ox7w3 _30l318xs _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                                        ]),
                                        style: {
                                            "--_1fmios5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue") + " !important")
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _1gyk1ule _1ll3kb7n _1lb11tcg _1647ckbl"
                        ])
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                        "aria-label": translatedLabel,
                        onClick: ()=>{
                            setIsHidden(true);
                            (0, $2gCne.setLocalStorage)(bannerStorageItem, "1");
                        },
                        className: (0, $2jatx.default)([
                            "_1ii7kb7n _r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wpz1q9y _1bsb7vkz _ahbq1h22 _1ywmidpf _296z1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Cross), {
                            size: "24",
                            className: (0, $2jatx.default)([
                                "_syaz1yg0"
                            ]),
                            style: {
                                "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                            }
                        })
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("8nDIL", function(module, exports) {
$parcel$export(module.exports, "HeroCTASkeleton", function () { return $f72d078b4cda3c91$export$27e5e2b588f979e1; });
/* hero-cta-skeleton.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eUwCn = parcelRequire("eUwCn");
const $f72d078b4cda3c91$var$headingSectionGap = null;
const $f72d078b4cda3c91$var$sectionGap = null;
const $f72d078b4cda3c91$var$containerStyles = null;
const $f72d078b4cda3c91$var$mobileDisplay = null;
const $f72d078b4cda3c91$var$desktopDisplay = null;
const $f72d078b4cda3c91$export$27e5e2b588f979e1 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "hero-cta-skeleton",
        className: (0, $2jatx.default)([
            "_1pfhoahv"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1ule _1mjbglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "566px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthoahv _1eglxy5q"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "770px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthoahv _1eglxy5q"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "168px",
                                height: "40px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthoahv _1eglxy5q"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "1140px",
                                height: "509px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _1mjb1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "147px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthoahv _1eglxy5q"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "311px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthoahv _1eglxy5q"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "141px",
                                height: "40px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthoahv _1eglxy5q"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "311px",
                                height: "509px"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("ichml", function(module, exports) {
/* hero-takeover-team-25.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");

var $7aqu5 = parcelRequire("7aqu5");
const $0a8762fbed1a7ff7$export$74664545b7e558af = ()=>{
    const intl = (0, $8e22h.default)();
    const heroTakeoverTeam25Body = intl.formatMessage({
        id: "HomePage.hero-takeover-team-25-eu.body",
        defaultMessage: "Our flagship event is back! Explore cutting-edge ideas and tech, feature launches, and AI innovations that will change the game for your team."
    });
    const heroTakeoverTeam25DateInfo = intl.formatMessage({
        id: "HomePage.hero-takeover-team-25-eu.date-info",
        defaultMessage: "7-9 October"
    });
    const heroTakeoverTeam25LocationInfo = intl.formatMessage({
        id: "HomePage.hero-takeover-team-25-eu.location-info",
        defaultMessage: "Barcelona and online"
    });
    // @ts-ignore
    const heroTakeoverTeam25CTASecondaryText = intl.formatMessage({
        id: "HomePage.hero-takeover-team-25-eu.cta-secondary-text",
        defaultMessage: "See agenda"
    });
    if ((0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp5421CollectionsHero)) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-hero-collections",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_11q71ybm _6rth1ejb"
            ]),
            style: {
                "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c1txw _4cvr1h6o _zulp8vuz _1bsb1fra _p12f1osq _1bah1yb4 _1yt4119w _19pk1wug _2hwx1wug _otyr1wug _18u01wug _tl28idpf _axwi1wqb _1hwcidpf _sp8t1wqb _1gde1bp4 _xsmr1h6o _ag851h6o _8164pxbi _nssp1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bsbdgin _p12f1osq _4cvr1y6m _1bah1y6m _1yt450w7 _xsmr1h6o _15tx2b33 _1btr1wug _1w2t1wug _16a31wug _1bn51wug _5fdi1kdj _zbji1wug _1gvu1jfg _q7gq1k92 _1vd31cby",
                            "left-block-text"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_11q76kkz _syaz18q9 _1p1dangw _1wyb1675 _vwz4kb7n _1dyzrnlf _k48pbfng _1yt418iy _2rko17td"
                                ]),
                                style: {
                                    "--_1qa6cp7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue200")),
                                    "--_nmjf06": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.secondary.navy")),
                                    "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill"))
                                },
                                children: intl.formatMessage({
                                    id: "HomePage.hero-takeover-collections.lozenge",
                                    defaultMessage: "Announcement"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.TeamworkCollectionsLockup), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                children: intl.formatMessage({
                                    id: "HomePage.hero-takeover-collections.bodytext",
                                    defaultMessage: "Atlassian\u2019s most powerful apps: Jira, Confluence, Loom and AI Agents, packaged together to drive your team to success."
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                text: intl.formatMessage({
                                    id: "HomePage.hero-takeover-collections.cta",
                                    defaultMessage: "Learn about Teamwork Collection"
                                }),
                                href: "/collections/teamwork",
                                type: "primary",
                                dataEventProps: {
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    // @ts-ignore
                                    "data-event-container": "heroTakeoverCollections",
                                    "data-product-key": "home",
                                    "data-label-english": "Learn about Teamwork Collection"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "right-block-img",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            style: {
                                aspectRatio: "500/373",
                                maxWidth: "100%",
                                height: "auto"
                            },
                            image: {
                                width: 500,
                                alt: "",
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/31g1oaixkl0abw4ci07c0e467s6o0wy7.webp"
                            },
                            forceEagerLoad: true
                        })
                    })
                ]
            })
        })
    });
    if ((0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7711Team25BannerPhase3)) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-hero-team-25-eu",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1reo15vq _18m915vq _11q76kkz _18s8zucw _1n4scd5j _17p312pl"
            ]),
            style: {
                "--_1qa6cp7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue200")),
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c1txw _4cvr1h6o _zulptudo _1bsb1fra _p12f1osq _1yt415v9 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _na0i1bp4 _gu181h6o _dh1a1h6o _2osnpxbi _o5kc1h6o _6ssjnl7l"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1kne1osq",
                            "_kqswstnw _8hrz1o02 _t9ec1sr2 _1bsbnbuu _4t3igq47 _152tymf6 _rjxpr8pp _zzrm482k _3xctglyw _16mq14id _w0gefp3b"
                        ]),
                        style: {
                            "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_t9ecsi92 _1kneuuw1 _nqop6o8t _3xct13hc _g57yidpf _16mq1wug _1ojq14zx",
                                "_11q79f4l",
                                "_kqswstnw _1bsb12id _4t3ic3sr _1e026u4h _152tr8pp _t9ec4yfw _8hrz1nty"
                            ]),
                            style: {
                                "--_k62i9u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple400"))
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1reo15vq _18m915vq _11q7jk2v _1bxvewfl _1rr4ewfl _1kne10be",
                            "_kqswstnw _8hrz1o02 _t9ec1sr2 _1bsbnbuu _4t3igq47 _152tymf6 _rjxpr8pp _zzrm482k _3xctglyw _16mq14id _w0gefp3b"
                        ]),
                        style: {
                            "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_11q71tj6 _t9ecif9y _1mjb1ule _16mq1wug _g57yobt3 _1kne12am _nqop1s2d _1a5h1wug _1s4p5o3v _3xct1mo7",
                                "_kqswstnw _1bsb12id _4t3ic3sr _1e026u4h _152tr8pp _t9ec4yfw _8hrz1nty",
                                "_1e0c1ule _1mjbglyw"
                            ]),
                            style: {
                                "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900"))
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e0c1txw _zulp1ejb _2lx21bp4 _4cvr1y6m _1bsb9tyk _acte1nn1 _qpk8yn4p _dd34idpf _l0uhidpf _ldjiidpf _g49yidpf _mihdcjiy _m78dcd5j _1bwb1ule _1qf11ule _x18dni7l _1hzvviql _125xcd5j _q7gqoxwj _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _1s4p1wug _8fz6dgin _6ssj1e2i _gu181h6o _dh1a1h6o _o5kc1h6o"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_11q71tj6 _t9ecif9y _1mjb1ule _16mq1wug _g57yobt3 _1kne12am _nqop1s2d _1a5h1wug _1s4p5o3v _3xct1mo7",
                                    "_kqswstnw _1bsb12id _4t3ic3sr _1e026u4h _152tr8pp _t9ec4yfw _8hrz1nty",
                                    "_1e0cglyw _152tyjcn _1mjb1ule"
                                ]),
                                style: {
                                    "--_1tgiy09": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue900"))
                                }
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.Team25LogoEU), {}),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _zulp1ejb _1wyb1j6v _so7d1d98 _65g0cd5j _dvzt1h6o _tkqh1txw _jh2tu2gc"
                                ]),
                                style: {
                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.CalendarIcon), {}),
                                            heroTakeoverTeam25DateInfo
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.MapDropIcon), {}),
                                            heroTakeoverTeam25LocationInfo
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: "hero hero-25",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "HomePage.hero-takeover-team-25-eu.heading",
                                    defaultMessage: "The conference for <span>AI-powered teamwork</span>",
                                    values: (0, $kooLp.DEFAULT_VALUES)
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                children: heroTakeoverTeam25Body
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _zulp1ejb _4cvr1h6o _1bah1h6o _hvo2cd5j _yzwbcd5j _1g136kkz _y1wy6kkz"
                                ]),
                                style: {
                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                    "--_1qa6cp7": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue200"))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                    variant: "primary",
                                    color: "yellow",
                                    href: "https://events.atlassian.com/teameurope?utm_medium=event-web-referral&utm_source=cross-promo&event_context=701qb00000pbqkqyar&utm_campaign=K:event|H:in-person|N:team_europe_25|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=takeover_screen_9.1&event_id=243301",
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        // @ts-ignore
                                        "data-event-container": "heroTakeoverteam25EU",
                                        "data-product-key": "home",
                                        "data-label-english": "Register now"
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "HomePage.hero-takeover-team-25-eu.cta-primary-text",
                                        defaultMessage: "Register now"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1yt41jx0 _1bsb16tw _mezj1osq _bna71wug _18zx1kb5 _1s4p1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("video", {
                            playsInline: true,
                            muted: true,
                            preload: "auto",
                            loop: true,
                            poster: "https://dam-cdn.atl.orangelogic.com/AssetLink/03aa4b48x1751y87o646838152ssggwi.webp",
                            autoPlay: true,
                            className: (0, $2jatx.default)([
                                "_19itidpf _p12f1osq _1bsb1deq _4t3ibqjm _1h1t4ji3"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/b7i5j7lls175m5n4h7mx7rl2w12g8t40.mp4",
                                type: "video/mp4"
                            })
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
};
const $0a8762fbed1a7ff7$var$heroCollectionsCSS = null;
const $0a8762fbed1a7ff7$var$containingWidthCollections = null;
const $0a8762fbed1a7ff7$var$collectionsLeftBlock = null;
const $0a8762fbed1a7ff7$var$lozengeStyle = null;
const $0a8762fbed1a7ff7$var$heroTeamCSS = null;
const $0a8762fbed1a7ff7$var$containingWidth = null;
const $0a8762fbed1a7ff7$var$leftHero = null;
const $0a8762fbed1a7ff7$var$rightHero = null;
const $0a8762fbed1a7ff7$var$leftPolygon = null;
const $0a8762fbed1a7ff7$var$rightPolygon = null;
const $0a8762fbed1a7ff7$var$shapeTransparent = null;
const $0a8762fbed1a7ff7$var$shapeBlue = null;
const $0a8762fbed1a7ff7$var$shapeRightPolygonInner = null;
const $0a8762fbed1a7ff7$var$shapeYellow = null;
const $0a8762fbed1a7ff7$var$shapeNavy = null;
const $0a8762fbed1a7ff7$var$navyDesktop = null;
const $0a8762fbed1a7ff7$var$navyMobile = null;
const $0a8762fbed1a7ff7$var$timePlaceDetails = null;
const $0a8762fbed1a7ff7$var$buttonArea = null;
$0a8762fbed1a7ff7$export$74664545b7e558af.displayName = "HeroTakeoverTeam25";

});

parcelRegister("bD2wb", function(module, exports) {
$parcel$export(module.exports, "ConfluenceCrossflowCTA", function () { return $e8a750dc13de3b5e$export$647570ff689e796e; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $l22jm = parcelRequire("l22jm");

var $kooLp = parcelRequire("kooLp");

var $cSmPq = parcelRequire("cSmPq");
const $e8a750dc13de3b5e$var$CONFLUENCE_UNDERLINE_SVG = /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
    width: "100%",
    height: "30",
    viewBox: "0 0 306 42",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
        d: "M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z",
        fill: "#FFA900"
    })
});
const $e8a750dc13de3b5e$var$ConfluenceTextFormatter = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $l22jm.Adg4TextUnderline), {
        underline: $e8a750dc13de3b5e$var$CONFLUENCE_UNDERLINE_SVG,
        children: children
    });
const $e8a750dc13de3b5e$var$ConfluenceHeroVariantTitle = ()=>{
    const confluenceFormatter = (0, $1oC0p.useCallback)((str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($e8a750dc13de3b5e$var$ConfluenceTextFormatter, {
            children: str
        }), []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "HomePageTemplateV2.confluenceCrossflowHeroVariant",
        defaultMessage: "Unleash knowledge with{br}<confluence>Confluence</confluence>",
        values: {
            br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
            confluence: confluenceFormatter
        }
    });
};
const $e8a750dc13de3b5e$export$647570ff689e796e = ({ contentComponent: contentComponent, gwp10965XflowRecommendation: gwp10965XflowRecommendation })=>{
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=confluence");
    const intl = (0, $8e22h.default)();
    const confluenceFormatter = (0, $1oC0p.useCallback)((str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($e8a750dc13de3b5e$var$ConfluenceTextFormatter, {
            children: str
        }), []);
    const heroTitle = gwp10965XflowRecommendation ? /*#__PURE__*/ (0, $7VQPk.jsx)($e8a750dc13de3b5e$var$ConfluenceHeroVariantTitle, {}) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "HomePageTemplateV2.confluenceCrossflowHero",
        defaultMessage: "Unleash knowledge{br}with Jira + <confluence>Confluence</confluence>",
        values: {
            confluence: confluenceFormatter,
            br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
        }
    });
    const getItFreeText = (0, $fnHPc.defineMessage)({
        id: "HomePageTemplateV2.confluenceCrossflowHero.getStartedCtaButton",
        defaultMessage: "Get started"
    });
    const formattedGetItFreeText = intl.formatMessage(getItFreeText);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cSmPq.default), {
        heroTitle: heroTitle,
        contentComponent: contentComponent,
        ctaButton: {
            buttonText: formattedGetItFreeText,
            buttonHref: signupLink,
            buttonColor: "blue",
            buttonVariant: "primary",
            eventProps: {
                label: formattedGetItFreeText,
                labelEnglish: getItFreeText.defaultMessage
            }
        },
        segmentName: "confluence-crossflow-hero",
        sectionId: "confluence-crossflow-hero",
        scrollTrackingSection: "confluence-crossflow-hero",
        gwp10965XflowRecommendation: gwp10965XflowRecommendation
    });
};

});

parcelRegister("9MOqA", function(module, exports) {
$parcel$export(module.exports, "LoggedInHeroContainer", function () { return $9376fa990f0fea15$export$c91dc4c235bd2e79; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $doAVE = parcelRequire("doAVE");

var $dqd4k = parcelRequire("dqd4k");

var $8nDIL = parcelRequire("8nDIL");
const $9376fa990f0fea15$export$c91dc4c235bd2e79 = ({ children: children })=>{
    const { profile: { requestInProgress: profileRequestInProgress }, user: { requestInProgress: userRequestInProgress } } = (0, $doAVE.useUserContext)();
    const [userProfileInProgress, setUserProfileInProgress] = (0, $1oC0p.useState)(true);
    const { getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback } = (0, $dqd4k.useGupsStatus)();
    (0, $1oC0p.useEffect)(()=>{
        getUserProfileJobFunctionCallback("homepage-xflow-job-function").then((response)=>{
            setUserProfileInProgress(response === null || response === void 0 ? void 0 : response.requestInProgress);
        });
    }, [
        getUserProfileJobFunctionCallback
    ]);
    const isBrowser = typeof window !== "undefined";
    if (!isBrowser) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nDIL.HeroCTASkeleton), {});
    // Checking for both user and profile request in progress,
    // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
    if (userRequestInProgress || profileRequestInProgress || userProfileInProgress) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nDIL.HeroCTASkeleton), {});
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nDIL.HeroCTASkeleton), {}),
        children: children
    });
};
$9376fa990f0fea15$export$c91dc4c235bd2e79.displayName = "LoggedInHeroContainer";

});

parcelRegister("jmcAZ", function(module, exports) {
$parcel$export(module.exports, "BelowNavBannerAlert", function () { return $57d2f3e8352f805e$export$ffcb5b8e5399295d; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $53RJr = parcelRequire("53RJr");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $57d2f3e8352f805e$export$ffcb5b8e5399295d = ()=>{
    const intl = (0, $8e22h.default)();
    const linkUrl = (0, $kooLp.useLocalizedHref)("https://webinars.atlassian.com/s/the-inside-track-on-strategic-planning/home?utm_medium=event-web-referral&utm_source=cross-promo&event_context=atlassian_anywhere&utm_campaign=K:event|H:digital|N:|P:agnostic|O:event-marketing|F:pre-event|C:event-home&utm_content=homepage_butterbar&event_id=");
    if ((0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp6825WebinarBanner)) {
        const linkText = intl.formatMessage({
            id: "Webinar.link-text.webinar-banner",
            defaultMessage: "Register for free"
        });
        const bannerMessages = {
            identifier: "Webinar",
            text: intl.formatMessage({
                id: "Webinar.banner-alert.webinar-banner",
                defaultMessage: "Join an exclusive digital event with Atlassian\u2019s CEO & CTO to get the inside track on how Atlassian drives strategic planning, teamwork, and execution."
            }),
            linkText: linkText,
            linkUrl: linkUrl,
            dataEventProps: {
                "data-product-key": "home",
                "data-event-component": "linkButton",
                "data-event-container": "announcementBanner",
                "data-event": "clicked",
                "data-label": linkText,
                "data-label-english": "Register for free"
            }
        };
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $53RJr.default), (0, $6ogO3._)({}, bannerMessages));
    }
    return null;
};

});

parcelRegister("aGCKc", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionHero", function () { return $4150c790892ed8c5$export$8f17f76747d41647; });
/* teamwork-collection-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $kooLp = parcelRequire("kooLp");

var $bxEPl = parcelRequire("bxEPl");
const $4150c790892ed8c5$export$8f17f76747d41647 = ()=>{
    const intl = (0, $8e22h.default)();
    const getItFreeLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=teamwork-collection&edition=premium");
    const learnMoreLink = (0, $kooLp.useLocalizedHref)("/collections/teamwork");
    const secondaryLinkText = intl.formatMessage({
        id: "HomePageTemplateV2.TeamworkCollectionHero.learnMoreButton",
        defaultMessage: "Learn more"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-teamworkCollectionHero",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_bfhkcd5j _1e0c1txw _1bah1h6o _4cvr1h6o _1yt416gv"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1to9 _p12f1osq _bfhk1hlo"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _yv0ewxkt _zulpxncg _4cvr1h6o _1ph4hkll _2osn1jfw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulp1ejb _1yt41oqc _6ssjxy5q"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bxEPl.TWCLightLogo), {
                                    "aria-label": intl.formatMessage({
                                        id: "HomePageTemplateV2.TeamworkCollectionHero.logoAriaLabel",
                                        defaultMessage: "Teamwork Collection logo"
                                    }),
                                    className: (0, $2jatx.default)([
                                        "_p12f1osq _1bsb1l7m _4t3i88uy _1h1tciin"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1fw0 _1p1dangw _6qt0cd5j _twgs1wto _gves1gnr _16028pqr _1tyeviql _1oxj151t _19891kdv _7ccl1j28 _15rw1kdv _1ugp14ct _1uzg4pt2",
                                        "twc-headline"
                                    ]),
                                    style: {
                                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                        "--_e0fbx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple500")),
                                        "--_jxcf9d": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.saffron")),
                                        "--_o8nmkh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue500"))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                        id: "HomePageTemplateV2.TeamworkCollectionHero.headline",
                                        defaultMessage: "The <span>Teamwork</span> platform built for the AI-era",
                                        values: (0, $kooLp.DEFAULT_VALUES)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1wyb1cby _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4q80t _15e8cd5j _so7d1j6v",
                                        "twc-description"
                                    ]),
                                    style: {
                                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                    },
                                    children: intl.formatMessage({
                                        id: "HomePageTemplateV2.TeamworkCollectionHero.description",
                                        defaultMessage: "Get Rovo, Jira, Confluence, and Loom in one collection. Bring AI-powered insights to your projects, knowledge, and video communication."
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _zulppxbi _1n261g80 _4cvr1h6o"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                            variant: "primary",
                                            href: getItFreeLink,
                                            size: "large",
                                            className: "twc-get-it-free-button",
                                            dataEventProps: {
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                "data-event-container": "heroSection",
                                                "data-product-key": "teamworkCollection",
                                                "data-label-english": "Get it free"
                                            },
                                            children: intl.formatMessage({
                                                id: "HomePageTemplateV2.TeamworkCollectionHero.getItFreeButton",
                                                defaultMessage: "Get it free"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                            type: "primary",
                                            bgColor: "bgBlackBlue",
                                            className: "twc-learn-more-button",
                                            "aria-label": secondaryLinkText,
                                            text: secondaryLinkText,
                                            href: learnMoreLink,
                                            dataEventProps: {
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                "data-event-container": "heroSection",
                                                "data-product-key": "teamworkCollection",
                                                "data-label-english": "Learn more"
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5140xb7orvf7timubceisv3470t0305a.webp",
                                alt: intl.formatMessage({
                                    id: "HomePageTemplateV2.TeamworkCollectionHero.imageAlt",
                                    defaultMessage: "Teamwork Collection products visualization"
                                }),
                                width: "544",
                                height: "544",
                                style: {
                                    height: "auto",
                                    aspectRatio: "1/1"
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $4150c790892ed8c5$var$sectionStyles = null;
const $4150c790892ed8c5$var$containerStyles = null;
const $4150c790892ed8c5$var$contentWrapperStyles = null;
const $4150c790892ed8c5$var$leftColumnStyles = null;
const $4150c790892ed8c5$var$logoStyles = null;
const $4150c790892ed8c5$var$headlineStyles = null;
const $4150c790892ed8c5$var$descriptionStyles = null;
const $4150c790892ed8c5$var$ctaWrapperStyles = null;
const $4150c790892ed8c5$var$rightColumnStyles = null;
$4150c790892ed8c5$export$8f17f76747d41647.displayName = "TeamworkCollectionHero";

});
parcelRegister("bxEPl", function(module, exports) {
$parcel$export(module.exports, "TWCLightLogo", function () { return $78522180aedbf02e$export$5d78c8f1db916132; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
const $78522180aedbf02e$export$5d78c8f1db916132 = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", (0, $dPABA._)((0, $6ogO3._)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "471",
        height: "113",
        viewBox: "0 0 471 113",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M470.519 57.6749V71.1529H466.563V57.2609C466.563 53.1209 464.907 51.2809 461.135 51.2809C457.455 51.2809 454.925 53.7189 454.925 58.3649V71.1529H450.969V48.1529H454.925V51.9249C456.397 49.2109 459.111 47.6929 462.193 47.6929C467.483 47.6929 470.519 51.3269 470.519 57.6749Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M435.516 71.6129C428.616 71.6129 424.568 66.5069 424.568 59.6069C424.568 52.7069 428.616 47.6929 435.516 47.6929C442.37 47.6929 446.372 52.7069 446.372 59.6069C446.372 66.5069 442.37 71.6129 435.516 71.6129ZM435.516 51.3729C430.594 51.3729 428.432 55.2369 428.432 59.6069C428.432 63.9769 430.594 67.9329 435.516 67.9329C440.392 67.9329 442.508 63.9769 442.508 59.6069C442.508 55.2369 440.392 51.3729 435.516 51.3729Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M415.284 42.0808C415.284 40.3328 416.434 39.3208 418.044 39.3208C419.654 39.3208 420.804 40.3328 420.804 42.0808C420.804 43.8288 419.654 44.8408 418.044 44.8408C416.434 44.8408 415.284 43.8288 415.284 42.0808ZM416.02 71.1528V48.1528H419.976V71.1528H416.02Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M404.828 64.0229C404.828 66.0469 406.024 67.4269 408.462 67.4269C409.382 67.4269 410.256 67.2429 410.946 67.1049V70.9229C410.256 71.1069 409.474 71.2909 408.278 71.2909C403.356 71.2909 400.964 68.3929 400.964 64.1149V51.8329H397.238V48.1529H400.964V43.2769H404.828V48.1529H410.946V51.8329H404.828V64.0229Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M394.838 67.0129V70.5549C393.458 71.2909 391.342 71.6129 389.226 71.6129C381.038 71.6129 377.22 66.6449 377.22 59.6069C377.22 52.6609 381.038 47.6929 389.226 47.6929C391.296 47.6929 392.906 47.9689 394.7 48.7969V52.4769C393.228 51.7869 391.664 51.3729 389.502 51.3729C383.522 51.3729 381.084 55.1449 381.084 59.6069C381.084 64.0689 383.568 67.8409 389.594 67.8409C391.94 67.8409 393.412 67.5189 394.838 67.0129Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M363.769 51.2809C359.583 51.2809 357.467 53.9949 357.053 57.9969H369.887C369.657 53.7189 367.725 51.2809 363.769 51.2809ZM372.601 70.2329C370.715 71.2449 367.817 71.6129 365.471 71.6129C356.869 71.6129 353.097 66.6449 353.097 59.6069C353.097 52.6609 356.961 47.6929 363.953 47.6929C371.037 47.6929 373.889 52.6149 373.889 59.6069V61.4009H357.099C357.651 65.3109 360.181 67.8409 365.609 67.8409C368.277 67.8409 370.531 67.3349 372.601 66.5989V70.2329Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M350.896 71.1071C350.574 71.1991 349.884 71.2911 348.872 71.2911C345.1 71.2911 342.708 69.4971 342.708 65.2651V38.5391H346.664V64.8051C346.664 66.8751 348.044 67.6111 349.746 67.6111C350.16 67.6111 350.436 67.6111 350.896 67.5651V71.1071Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M338.901 71.1071C338.579 71.1991 337.889 71.2911 336.877 71.2911C333.105 71.2911 330.713 69.4971 330.713 65.2651V38.5391H334.669V64.8051C334.669 66.8751 336.049 67.6111 337.751 67.6111C338.165 67.6111 338.441 67.6111 338.901 67.5651V71.1071Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M315.26 71.6129C308.36 71.6129 304.312 66.5069 304.312 59.6069C304.312 52.7069 308.36 47.6929 315.26 47.6929C322.114 47.6929 326.116 52.7069 326.116 59.6069C326.116 66.5069 322.114 71.6129 315.26 71.6129ZM315.26 51.3729C310.338 51.3729 308.176 55.2369 308.176 59.6069C308.176 63.9769 310.338 67.9329 315.26 67.9329C320.136 67.9329 322.252 63.9769 322.252 59.6069C322.252 55.2369 320.136 51.3729 315.26 51.3729Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M301.41 65.8167V69.8187C299.524 71.0607 296.534 71.6127 293.406 71.6127C283.47 71.6127 277.858 65.6327 277.858 56.1107C277.858 46.9107 283.47 40.4707 293.314 40.4707C296.258 40.4707 299.202 41.0227 301.364 42.5867V46.5887C299.202 45.2087 296.81 44.4727 293.314 44.4727C286.23 44.4727 281.998 49.1647 281.998 56.1107C281.998 63.0567 286.368 67.6567 293.544 67.6567C296.718 67.6567 299.202 66.9207 301.41 65.8167Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                y: "22.5742",
                width: "259",
                height: "90",
                transform: "rotate(-5 0 22.5742)",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M227.384 71.1296H218.69V38.5156H227.384V57.9736L232.858 47.3016H242.288L235.48 58.9396L242.472 71.1296H232.904L227.384 60.4576V71.1296Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M210.45 59.5836V71.1296H201.71V47.3016H210.45V51.8096C211.692 48.5896 213.624 46.7956 216.752 46.9796V55.9036C212.106 55.5816 210.45 56.5016 210.45 59.5836Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M187.195 71.7276C179.513 71.7276 175.051 66.6676 175.051 59.1696C175.051 51.7176 179.513 46.7496 187.195 46.7496C194.785 46.7496 199.155 51.7176 199.155 59.1696C199.155 66.6676 194.785 71.7276 187.195 71.7276ZM187.195 54.2016C184.665 54.2016 183.561 56.1796 183.561 59.1696C183.561 62.2056 184.665 64.3216 187.195 64.3216C189.587 64.3216 190.691 62.2056 190.691 59.1696C190.691 56.1796 189.587 54.2016 187.195 54.2016Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M169.68 71.1296H158.272L156.248 62.9416L154.914 54.9836L153.534 62.9416L151.464 71.1296H140.654L135.18 47.3016H143.69L146.772 65.5176L151.142 47.3016H159.652L164.068 65.6096L167.104 47.3016H175.154L169.68 71.1296Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M119.856 57.8817V71.1297H111.162V56.9157C111.162 54.9377 110.472 54.0177 108.77 54.0177C107.022 54.0177 105.826 55.2137 105.826 57.8817V71.1297H97.1318V47.3017H105.826V51.5797C107.114 48.4977 109.368 46.7957 112.726 46.7957C116.314 46.7957 118.384 48.5897 119.304 51.9017C120.638 48.6357 123.122 46.7957 126.848 46.7957C131.862 46.7957 133.886 50.3377 133.886 56.6397V71.1297H125.192V57.2377C125.192 55.0757 124.502 54.0177 122.8 54.0177C121.052 54.0177 119.856 55.2137 119.856 57.8817Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M78.6244 59.2156C78.6244 62.5736 79.7284 64.2296 81.7984 64.2296C83.5004 64.2296 84.9724 62.9876 84.9724 60.1356V58.2496C84.9724 55.3516 83.7304 54.1096 81.9824 54.1096C79.7744 54.1096 78.6244 55.9496 78.6244 59.2156ZM84.9724 71.1296V66.8976C83.5924 70.0716 81.1084 71.5896 78.1184 71.5896C72.5984 71.5896 70.0684 66.3916 70.0684 59.2156C70.0684 52.4536 72.5984 46.8416 78.4864 46.8416C81.6144 46.8416 83.7764 48.6816 84.9724 51.3956V47.3016H93.6664V71.1296H84.9724Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M57.1406 52.8216C54.9786 52.8216 53.8746 54.3856 53.5986 57.4676H60.5446C60.3146 54.2476 59.2106 52.8216 57.1406 52.8216ZM67.4446 70.1636C65.1906 70.9916 62.1086 71.5896 59.0266 71.5896C49.5046 71.5896 45.2266 67.4036 45.2266 59.5836C45.2266 52.0856 49.3666 46.7496 57.2786 46.7496C65.0986 46.7496 68.3186 52.0396 68.3186 59.5836V61.3776H53.7826C54.3346 63.7236 55.9446 64.4596 59.2106 64.4596C61.9706 64.4596 65.0066 64.0456 67.4446 63.3556V70.1636Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M23.4297 40.9077H46.0617V48.6817H39.4837V71.1297H30.0077V48.6817H23.4297V40.9077Z",
                fill: "white"
            })
        ]
    }));
};

});


parcelRegister("bOK36", function(module, exports) {
$parcel$export(module.exports, "RovoInnovationsVideo", function () { return $6e23f60153b0c73c$export$dbfef9312e394110; });
/* rovo-innovations-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $6e23f60153b0c73c$export$dbfef9312e394110 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-rovo-innovations-video",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_1mouxncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhk4eum _1q51xncg _85i5xy5q"
                    ]),
                    style: {
                        "--_s8ixyq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple200"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
                            title: intl.formatMessage({
                                id: "HomePageTemplateV2.RovoInnovationVideo.Title",
                                defaultMessage: "Hot off the press: What\u2019s new in AI?"
                            }),
                            titleAs: "h2",
                            text: intl.formatMessage({
                                id: "HomePageTemplateV2.RovoInnovationVideo.Text",
                                defaultMessage: "Agents in Jira are now in open beta and Rovo can connect to MCP-enabled third-party apps, such as Amplitude, Box, Canva, Figma, Intercom, and more."
                            }),
                            callToActionProps: {
                                link: {
                                    text: intl.formatMessage({
                                        id: "HomePageTemplateV2.RovoInnovationVideo.CTA",
                                        defaultMessage: "Watch the full video"
                                    }),
                                    href: "/blog/ai/rovo-ai-agents-at-work",
                                    dataEventProps: {
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "ctaSection",
                                        "data-product-key": "home",
                                        "data-label-english": "Watch the full video"
                                    }
                                }
                            },
                            alignment: "center"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1kt9b3bt _1rus4eum _1mp41osq _cfu11ule _1cs8stnw _1g0v1mrw _kfgt1ssb _rxyg400g _aetrb3bt _1hfk4eum _z0ai1osq _1ywu1ule _18postnw _1bqq1mrw _19nq1ssb _1oj41k3a _1qdg1wqb _1199ys9h _1dqh68cl"
                    ]),
                    style: {
                        "--_s8ixyq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.purple200"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "10",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.EmbeddedVideo), {
                            embedUrl: "https://youtu.be/YNDHFg_uNcw",
                            title: "Rovo at work: AI agents in action",
                            thumbnail: {
                                src: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EXEC.png",
                                alt: ""
                            }
                        })
                    })
                })
            ]
        })
    });
};
$6e23f60153b0c73c$export$dbfef9312e394110.displayName = "RovoInnovationsVideo";
const $6e23f60153b0c73c$var$mainSectionStyles = null;
const $6e23f60153b0c73c$var$contentSectionStyles = null;
const $6e23f60153b0c73c$var$videoSectionStyles = null;

});


parcelRegister("5TYKZ", function(module, exports) {
$parcel$export(module.exports, "HeroTakeoverTeam26", function () { return $c78b07a2c96a763b$export$7b1db1f2f1cdd8f8; });
/* hero-takeover-team-26.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");

var $7aqu5 = parcelRequire("7aqu5");
// Mobile/small viewport breakpoint: below 1160px custom for this video and content to ensure it isn't cut off
const $c78b07a2c96a763b$var$mediaBelow1160 = "@media (max-width: 1160px)";
// Background images for different viewport widths
const $c78b07a2c96a763b$var$BG_IMAGES = {
    // Up to 1440px
    small: {
        left: "https://dam-cdn.atl.orangelogic.com/AssetLink/b25ni6jq86en824330eb181373404py3.svg",
        right: "https://dam-cdn.atl.orangelogic.com/AssetLink/72737qhytbe162wp8518852f85krd8jn.svg"
    },
    // Up to 1920px
    medium: {
        left: "https://dam-cdn.atl.orangelogic.com/AssetLink/w8asdprwnlr3ga7g2h43yi55c7lkkc0j.svg",
        right: "https://dam-cdn.atl.orangelogic.com/AssetLink/3n8vb435pvy77552h511lrvdg84f22tw.svg"
    },
    // 2560px and beyond
    large: {
        left: "https://dam-cdn.atl.orangelogic.com/AssetLink/7n8glrg7ika480x6aod11g33m84p0umk.svg",
        right: "https://dam-cdn.atl.orangelogic.com/AssetLink/k331kq8e41686dh833iahp6vj44x0283.svg"
    }
};
const $c78b07a2c96a763b$export$7b1db1f2f1cdd8f8 = ()=>{
    const intl = (0, $8e22h.default)();
    const heroTakeoverTeam26Body = intl.formatMessage({
        id: "HomePage.hero-takeover-team-26.body",
        defaultMessage: "Join the global conference for AI-forward teams, their leaders, and the apps and agents that fuel them."
    });
    const heroTakeoverTeam26DateInfo = intl.formatMessage({
        id: "HomePage.hero-takeover-team-26.date-info",
        defaultMessage: "May 5 - 7"
    });
    const heroTakeoverTeam26LocationInfo = intl.formatMessage({
        id: "HomePage.hero-takeover-team-26.location-info",
        defaultMessage: "Anaheim, California and online"
    });
    const heroTakeoverTeam26CTASecondaryText = intl.formatMessage({
        id: "HomePage.hero-takeover-team-26.cta-secondary-text",
        defaultMessage: "See the agenda"
    }) || "See the agenda";
    const registerLink = "https://events.atlassian.com/team?utm_medium=event-web-referral&utm_source=cross-promo&utm_campaign=701qb00000tzh4byar&utm_content=K:event%7CH:in-person%7CN:team_26%7CP:agnostic%7CO:event-marketing%7CF:pre-event%7CC:event-home%7CQ:agnostic&event_context=wac-takeover-feb-2026&event_id=288640";
    const agendaLink = "https://events.atlassian.com/team/agenda?utm_medium=event-web-referral&utm_source=cross-promo&utm_campaign=701qb00000tzh4byar&utm_content=K:event%7CH:in-person%7CN:team_26%7CP:agnostic%7CO:event-marketing%7CF:pre-event%7CC:event-home%7CQ:agnostic&event_context=wac-takeover-feb-2026&event_id=288640";
    if (!(0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9191Team26HeroHomepageTakeover)) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-v2-hero-team-26",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1reo15vq _18m915vq _18s8zucw _kqswh2mm _1e0c1txw _4t3i1feq _4cvr1fhb _1bah1h6o _181z1wug _10c812pl _1o88idpf _7ru1idpf _7hsxidpf _xgvridpf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1bahesu3 _onhmglyw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3i1osq _1e0c1ule _13stglyw _bna71osq _mezj1wug _1jpx1dfr"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: $c78b07a2c96a763b$var$BG_IMAGES.small.left,
                                    alt: ""
                                },
                                style: {
                                    maxWidth: "none"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3i1osq _1e0cglyw _13st1ule _q56sglyw _bna71osq _mezj1wug _1jpx1dfr"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: $c78b07a2c96a763b$var$BG_IMAGES.medium.left,
                                    alt: ""
                                },
                                style: {
                                    maxWidth: "none"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3i1osq _1e0cglyw _q56s1ule _bna71osq _mezj1wug _1jpx1dfr"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: $c78b07a2c96a763b$var$BG_IMAGES.large.left,
                                    alt: ""
                                },
                                style: {
                                    maxWidth: "none"
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1txw _4cvr1h6o _zulpxy5q _1bsb17gh _bfhkqlpt _1yt431tj _19it1dfy _ahbq1n1a _12l21n1a _1lmn1osq _9ctun5oa _5am91bp4 _1e401h6o _oue01h6o _1ikfpxbi _8ghy1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _1e0c1txw _zulp1ejb _2lx21bp4 _4cvr1y6m _1bsb1oh5 _acteni7l _qpk8yn4p _dd34idpf _l0uhidpf _ldjiidpf _g49yidpf _mihdcjiy _m78dcd5j _1bwb1ule _1qf11ule _yy0z1fw0 _ymbn1b66 _jqwezwfg _125xcd5j _q7gq1k92 _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _pa6o1cby _1lmn1wug _9ctuz6oa _1e401h6o _oue01h6o _8ghy1h6o"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _2lx21bp4 _zulppxbi _1ikf1ejb"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.Team26Logo), {}),
                                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c1txw _1n261g80 _zulp1ejb _1wyb1j6v _onhm1txw _5am91bp4 _oue01h6o _8ghy1h6o _1ikfu2gc _65g0cd5j _dvzt1h6o _tkqh1txw _jh2tu2gc"
                                            ]),
                                            style: {
                                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyb7vkz _k48p1nn1 _vwz41tcg"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.CalendarIcon), {}),
                                                        heroTakeoverTeam26DateInfo
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_1wyb7vkz _k48p1nn1 _vwz41tcg"
                                                    ]),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aqu5.MapDropIcon), {}),
                                                        heroTakeoverTeam26LocationInfo
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                            className: "hero hero-26",
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                id: "HomePage.hero-takeover-team-26.heading",
                                                defaultMessage: "Unlock human-AI collaboration at scale",
                                                values: (0, $kooLp.DEFAULT_VALUES)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: (0, $2jatx.default)([
                                                "_1wyb7vkz _k48p1nn1 _vwz41tcg"
                                            ]),
                                            children: heroTakeoverTeam26Body
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1n261g80 _zulp1ejb _4cvr1h6o _1bah1y6m _onhm1txw _5am91bp4 _oue01h6o _8ghy1h6o _1ikfxy5q _1m2dcd5j _hvo2cd5j _1cva1ybm _1hoicd5j _1twccd5j"
                                    ]),
                                    style: {
                                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                        "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                            variant: "primary_alt",
                                            href: registerLink,
                                            size: "large",
                                            dataEventProps: {
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                // @ts-ignore
                                                "data-event-container": "heroTakeoverteam26",
                                                "data-product-key": "home",
                                                "data-label-english": "Register now"
                                            },
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                id: "HomePage.hero-takeover-team-26.cta-primary-text",
                                                defaultMessage: "Register now"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                            text: heroTakeoverTeam26CTASecondaryText,
                                            href: agendaLink,
                                            type: "primary",
                                            bgColor: "bgBlackBlue",
                                            "aria-label": heroTakeoverTeam26CTASecondaryText,
                                            ariaLabel: heroTakeoverTeam26CTASecondaryText,
                                            anchorProps: {
                                                "aria-label": heroTakeoverTeam26CTASecondaryText
                                            },
                                            dataEventProps: {
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                // @ts-ignore
                                                "data-event-container": "heroTakeoverteam26",
                                                "data-product-key": "home",
                                                "data-label-english": "See the agenda"
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_kqswh2mm _1bsb1erl _1lmnauwl"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq _z52xidpf _1y2k1erl _z18o1hiv _npsn1dfr _2usp1osq _1o7k1osq _1r801wug"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Video), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3ay0vx05s3f7c071q06nhyju23ex68r8.mp4",
                                    alt: "Team 26 conference video",
                                    loop: true,
                                    disableAutoplay: false,
                                    poster: "https://dam-cdn.atl.orangelogic.com/AssetLink/42wp4t8o843x2uj0cc217d1ycn2r3ra3.svg"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1bah1y6m _onhmglyw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3i1osq _1e0c1ule _13stglyw _bna71osq _mezj1wug _1jpx1dfr"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: $c78b07a2c96a763b$var$BG_IMAGES.small.right,
                                    alt: ""
                                },
                                style: {
                                    maxWidth: "none"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3i1osq _1e0cglyw _13st1ule _q56sglyw _bna71osq _mezj1wug _1jpx1dfr"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: $c78b07a2c96a763b$var$BG_IMAGES.medium.right,
                                    alt: ""
                                },
                                style: {
                                    maxWidth: "none"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3i1osq _1e0cglyw _q56s1ule _bna71osq _mezj1wug _1jpx1dfr"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: $c78b07a2c96a763b$var$BG_IMAGES.large.right,
                                    alt: ""
                                },
                                style: {
                                    maxWidth: "none"
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $c78b07a2c96a763b$var$heroTeam26CSS = null;
const $c78b07a2c96a763b$var$sideDecoration = null;
const $c78b07a2c96a763b$var$sideDecorationRight = null;
// Left decoration - small (up to 1440px)
const $c78b07a2c96a763b$var$leftDecorationSmall = null;
// Left decoration - medium (1441px to 1920px)
const $c78b07a2c96a763b$var$leftDecorationMedium = null;
// Left decoration - large (1921px and beyond)
const $c78b07a2c96a763b$var$leftDecorationLarge = null;
// Right decoration - small (up to 1440px)
const $c78b07a2c96a763b$var$rightDecorationSmall = null;
// Right decoration - medium (1441px to 1920px)
const $c78b07a2c96a763b$var$rightDecorationMedium = null;
// Right decoration - large (1921px and beyond)
const $c78b07a2c96a763b$var$rightDecorationLarge = null;
const $c78b07a2c96a763b$var$containingWidth = null;
const $c78b07a2c96a763b$var$leftHero = null;
const $c78b07a2c96a763b$var$rightHero = null;
const $c78b07a2c96a763b$var$videoWrapper = null;
const $c78b07a2c96a763b$var$timePlaceDetails = null;
const $c78b07a2c96a763b$var$logoAndTimePlaceDetails = null;
const $c78b07a2c96a763b$var$heroTakeoverTeam26BodyText = null;
const $c78b07a2c96a763b$var$buttonArea = null;
$c78b07a2c96a763b$export$7b1db1f2f1cdd8f8.displayName = "HeroTakeoverTeam26";

});

parcelRegister("azsFT", function(module, exports) {
$parcel$export(module.exports, "HeroTWCHeader", function () { return $c1dba920c4d67767$export$d39bb8af515a1f9e; });
/* hero-twc-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $l22jm = parcelRequire("l22jm");

var $imIsw = parcelRequire("imIsw");

var $lqyi6 = parcelRequire("lqyi6");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $c1dba920c4d67767$export$d39bb8af515a1f9e = ()=>{
    const signupLink = (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=teamwork-collection&edition=premium");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _6a6z1h6o _1q511ylp"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/45u0b4ppp52x032pe78p58n2335x8235.svg",
                            alt: "teamwork collection logo",
                            width: 165,
                            height: 40
                        }
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                        className: (0, $2jatx.default)([
                            "_1pfh7vkz _6rthidpf _y3gn1h6o",
                            "superhero-contrast"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                            id: "HomePageTemplateV2.jiraHero",
                            defaultMessage: "The platform for{br}<teamwork>AI-powered</teamwork> teamwork",
                            values: {
                                // eslint-disable-next-line react/no-unstable-nested-components
                                teamwork: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $l22jm.Adg4TextUnderline), {
                                        underlineInset: "-13.5%",
                                        underline: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "100%",
                                            height: "8",
                                            viewBox: "0 0 329 8",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                                d: "M6.46577 0.23741C-1.85858 0.389397 -2.31998 3.55263 6.1005 4.07508C18.0199 4.80652 30.4776 5.20549 46.5303 5.43347C64.717 5.49046 69.2733 4.88251 81.5964 5.08199C102.417 5.30047 137.483 6.51637 145.923 6.82035C147.172 6.86784 148.422 6.88684 149.671 6.87734C158.63 6.84884 197.964 6.72535 231.781 7.3238C255.658 7.59928 270.442 7.77976 278.17 7.86526C296.357 8.11223 310.064 7.97924 323.252 7.78926C329.923 7.78926 331.634 5.10099 323.81 4.36955C310.353 3.33414 296.741 2.83069 278.459 2.52672C271.365 2.43173 256.619 1.4723 235.76 1.11133C232.357 1.05434 228.955 1.06384 225.59 1.14933C196.445 1.87127 158.707 1.22533 158.707 1.22533C158.707 1.22533 102.378 0.664871 78.5973 0.427391C60.699 0.237407 52.0863 0.151916 46.7994 0.0949209C30.7852 -0.0855637 18.3083 0.0094276 6.46577 0.227909V0.23741Z",
                                                fill: "#FCA700"
                                            })
                                        }),
                                        children: str
                                    }),
                                br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_p12f1hnn _y3gn1h6o _1pfhgktf _6rth7vkz",
                            "body-lg"
                        ]),
                        children: "Unlock the future of teamwork with software solutions that break down silos, boost productivity, and put Rovo AI to work"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lqyi6.Button), {
                        variant: "primary",
                        color: "blue",
                        href: signupLink,
                        dataEventProps: {
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "heroSection",
                            "data-product-key": "home",
                            "data-label-english": "Get started"
                        },
                        className: (0, $2jatx.default)([
                            "_6rthymf6"
                        ]),
                        children: [
                            " ",
                            "Get started"
                        ]
                    })
                ]
            })
        })
    });
};
const $c1dba920c4d67767$var$containerStyles = null;
const $c1dba920c4d67767$var$heroTitleStyles = null;
const $c1dba920c4d67767$var$heroGetStartedStyles = null;
const $c1dba920c4d67767$var$subtitleStyles = null;

});

parcelRegister("02nCL", function(module, exports) {
$parcel$export(module.exports, "HeroTeamworkCollection", function () { return $794a1a8b605ad86b$export$4242578e1c5a7f62; });
/* hero-twc-tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bQjAr = parcelRequire("bQjAr");

var $a9lfn = parcelRequire("a9lfn");

var $i1iCn = parcelRequire("i1iCn");
const $794a1a8b605ad86b$export$4242578e1c5a7f62 = ({ children: children })=>{
    const tabsWrapperRef = (0, $1oC0p.useRef)(null);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-twc-hero",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            id: "hero-twc",
            className: (0, $2jatx.default)([
                "_1reo15vq _18m915vq"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    children,
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4Tabs), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i1iCn.TWCTabs), {
                            tabsWrapperRef: tabsWrapperRef
                        })
                    })
                ]
            })
        })
    });
};
const $794a1a8b605ad86b$var$twcHeroStyles = null;
$794a1a8b605ad86b$export$4242578e1c5a7f62.displayName = "HeroTeamworkCollection";

});
parcelRegister("i1iCn", function(module, exports) {
$parcel$export(module.exports, "TWCTabs", function () { return $d8b97e0fc5c83803$export$aa22aa03256944ed; });
/* twc-tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $a9lfn = parcelRequire("a9lfn");

var $imIsw = parcelRequire("imIsw");

var $8EEDU = parcelRequire("8EEDU");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $knMal = parcelRequire("knMal");
const $d8b97e0fc5c83803$var$tabsWrapperStyle = null;
const $d8b97e0fc5c83803$var$tabsStyle = null;
const $d8b97e0fc5c83803$var$buttonResetStyle = null;
const $d8b97e0fc5c83803$var$fadeIn = null;
const $d8b97e0fc5c83803$var$fadeInSlideUp = null;
const $d8b97e0fc5c83803$var$teamCardStyles = null;
const $d8b97e0fc5c83803$var$teamCardActiveStyles = null;
const $d8b97e0fc5c83803$var$iconWrapperStyles = null;
const $d8b97e0fc5c83803$var$iconContainerStyles = null;
const $d8b97e0fc5c83803$var$iconGestureStyles = null;
const $d8b97e0fc5c83803$var$teamCardTextStyles = null;
const $d8b97e0fc5c83803$var$imageContainerStyles = null;
const $d8b97e0fc5c83803$var$backgroundStyles = null;
const $d8b97e0fc5c83803$var$heroImageStyles = null;
// Memoized TabButton component for better performance
const $d8b97e0fc5c83803$var$TabButton = /*#__PURE__*/ (0, $1oC0p.memo)(({ tab: tab, index: index, isActive: isActive, onTabClick: onTabClick })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
        tabIndex: index,
        onClick: ()=>onTabClick(index),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            "data-product-key": "home",
            "data-event-component": "button",
            "data-event-container": "heroSection",
            "data-event": "clicked",
            "data-label-english": tab.englishLabel,
            "aria-label": intl.formatMessage(tab.title),
            className: (0, $2jatx.default)([
                "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _d0altlke"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                "data-gesture-slide-up": tab.id === "plan-and-track" || tab.id === "ai-teammates" ? "true" : "false",
                className: (0, $2jatx.default)([
                    "_vchhusvi _19itokh7 _1e0c1txw _2lx21bp4 _1bsb7l9q _4t3iucft _4cvr1h6o _1bah1h6o _zulpftgi _ca0q1l7b _u5f3i2wt _n3td1l7b _19bvi2wt _1oqm1r7u _1vai1tvd",
                    isActive && "_19it1wcj _2rkoi2wt _sviakb7n _1kd31fw0"
                ]),
                style: {
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_4t3ickbl _1bsbckbl _1e0c1txw _4cvr1h6o _1bah1h6o",
                                    "default-icon"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                    image: {
                                        src: tab.icon,
                                        alt: "",
                                        draggable: "false",
                                        width: tab.iconDimensions.width,
                                        height: tab.iconDimensions.height
                                    },
                                    forceEagerLoad: true
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_4t3ickbl _1bsbckbl _1e0c1txw _4cvr1h6o _1bah1h6o",
                                    "_kqswstnw _152tidpf _1e02idpf _tzy4idpf",
                                    "gesture-icon"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                    image: {
                                        src: tab.iconGesture,
                                        alt: "",
                                        draggable: "false",
                                        width: tab.iconDimensions.width,
                                        height: tab.iconDimensions.height,
                                        loading: "eager",
                                        fetchpriority: "low"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_ect4bzd7 _k48p1nn1 _1wyb1j6v _vwz41k8s _syaz1hlo"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: intl.formatMessage(tab.title)
                    })
                ]
            })
        })
    }, tab.id);
});
$d8b97e0fc5c83803$var$TabButton.displayName = "TabButton";
// Memoized HeroImageSection component
const $d8b97e0fc5c83803$var$HeroImageSection = /*#__PURE__*/ (0, $1oC0p.memo)(({ isCurrentTab: isCurrentTab, isInitialLoad: isInitialLoad })=>{
    const images = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "10",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8EEDU.Video), {
                    videoLink: "https://dam-cdn.atl.orangelogic.com/AssetLink/eu28pc4e878343vnpg2oxq0agjibv336.mp4",
                    videoType: "mp4",
                    videoPreviewImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/p6tm7xy6w8hg08jx772v11u8tesvl456.webp",
                    loop: true,
                    muted: true,
                    aspectRatio: "16/9",
                    className: isInitialLoad ? "active-hero-image" : "",
                    fallbackText: ""
                })
            }),
            (0, $knMal.TWC_TAB_DATA).map((tab, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                    image: {
                        src: tab.heroImage,
                        alt: tab.englishLabel,
                        width: tab.heroImageDimensions.imageWidth,
                        height: tab.heroImageDimensions.imageHeight
                    },
                    forceEagerLoad: index === 0,
                    className: isCurrentTab(index) && !isInitialLoad ? "active-hero-image" : ""
                }, index);
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _1h1tbb7n _kqswh2mm _6rth1a0z _d2ikgktf _exxmgktf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1elaidpf _1rleidpf _18zxbb7n _f45rstnw _12xtidpf _siplidpf _rtys1osq _19l31osq _1cjjkb7n _m5zw12am _1ueiftgi _7g0o130s _dbykkb7n"
                        ]),
                        children: images
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswstnw _1e02r8pp _152ty99k _1bsb12eq _4t3imlf1 _bfhk17la _1pby1mrw _mkrz1gzl _1eg61fm0 _1rfm4diq"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                        }
                    })
                ]
            })
        })
    });
});
$d8b97e0fc5c83803$var$HeroImageSection.displayName = "HeroImageSection";
const $d8b97e0fc5c83803$export$aa22aa03256944ed = /*#__PURE__*/ (0, $1oC0p.memo)(({ tabsWrapperRef: tabsWrapperRef })=>{
    const { goToTab: goToTab, isCurrentTab: isCurrentTab } = (0, $a9lfn.useAdg4TabsContext)();
    const [isInitialLoad, setIsInitialLoad] = (0, $1oC0p.useState)(true);
    const handleTabClick = (0, $1oC0p.useCallback)((index)=>{
        setIsInitialLoad(false);
        goToTab(index);
    }, [
        goToTab
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: tabsWrapperRef,
                className: (0, $2jatx.default)([
                    "_ahbqftgi _12l2ftgi"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTabList), {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1bah1yb4 _19pkidpf _2hwx1wug _otyridpf _18u01wug _6rth19bv"
                    ]),
                    children: (0, $knMal.TWC_TAB_DATA).map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($d8b97e0fc5c83803$var$TabButton, {
                            tab: tab,
                            index: index,
                            isActive: isCurrentTab(index) && !isInitialLoad,
                            onTabClick: handleTabClick
                        }, tab.id))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($d8b97e0fc5c83803$var$HeroImageSection, {
                isCurrentTab: isCurrentTab,
                isInitialLoad: isInitialLoad
            })
        ]
    });
});
$d8b97e0fc5c83803$export$aa22aa03256944ed.displayName = "TWCTabs";

});
parcelRegister("knMal", function(module, exports) {
$parcel$export(module.exports, "TWC_TAB_DATA", function () { return $fc02c5ff8b3f42f6$export$ea98ccd28e2fa648; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $46SoL = parcelRequire("46SoL");
const $fc02c5ff8b3f42f6$export$ea98ccd28e2fa648 = [
    {
        id: "align-to-goals",
        title: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplate.twcHero.label.tab1",
            defaultMessage: "Align to goals"
        }),
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/bib125707t53vc4725oi23y27k840f25.svg",
        iconDimensions: {
            width: 33.4,
            height: 33.4
        },
        iconGesture: "https://dam-cdn.atl.orangelogic.com/AssetLink/dh5k7r067860c2lw755qk4225lnh064h.svg",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $46SoL.AlignToGoalsTabContent), {}),
        englishLabel: "Board of goals in customer portal",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/l3x685vh5v3848m7ahn64ck0w1tv4542.webp",
        heroImageDimensions: {
            imageWidth: 1152,
            imageHeight: 648
        }
    },
    {
        id: "plan-and-track",
        title: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplate.twcHero.label.tab1",
            defaultMessage: "Plan and track"
        }),
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/lem6xq7r2b8b3wj0sm8k007511hml00k.svg",
        iconDimensions: {
            width: 31.4,
            height: 32.8
        },
        iconGesture: "https://dam-cdn.atl.orangelogic.com/AssetLink/41ctiw00g13t41sx3kq52121f77kybmq.svg",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $46SoL.AlignToGoalsTabContent), {}),
        englishLabel: "Timeline in a marketing campaign",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/x77575w704j77xt8mibdp720ubo17pbk.webp",
        heroImageDimensions: {
            imageWidth: 1152,
            imageHeight: 648
        }
    },
    {
        id: "harness-knowledge",
        title: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplate.twcHero.label.tab1",
            defaultMessage: "Harness knowledge"
        }),
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/141bay62mq84i1s1cy46reh1mp0yr57p.svg",
        iconDimensions: {
            width: 34.35,
            height: 42.6
        },
        iconGesture: "https://dam-cdn.atl.orangelogic.com/AssetLink/5dmyh82cu21554ub13d26sx4scs5l625.svg",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $46SoL.AlignToGoalsTabContent), {}),
        englishLabel: "Confluence doc with an AI generated meeting summary",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/v6470jaq0j642skkx7ltj648lixci2so.webp",
        heroImageDimensions: {
            imageWidth: 1152,
            imageHeight: 648
        }
    },
    {
        id: "ai-teammates",
        title: (0, $fnHPc.defineMessage)({
            id: "HomePageTemplate.twcHero.label.tab1",
            defaultMessage: "AI teammates"
        }),
        icon: "https://dam-cdn.atl.orangelogic.com/AssetLink/4056w427ncf5oldsnmk04njn6c01h2t0.svg",
        iconDimensions: {
            width: 35,
            height: 36
        },
        iconGesture: "https://dam-cdn.atl.orangelogic.com/AssetLink/j6qh3wta803dmg5u3117478br61j7f3j.svg",
        tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $46SoL.AlignToGoalsTabContent), {}),
        englishLabel: "Flow chart from a campaign brainstorm with an AI agent asking if it can help",
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/75yxk8rcwh721mj26x2u4wskr8vgaf33.webp",
        heroImageDimensions: {
            imageWidth: 1152,
            imageHeight: 648
        }
    }
];

});
parcelRegister("46SoL", function(module, exports) {
$parcel$export(module.exports, "AlignToGoalsTabContent", function () { return $6a5b77acdab386d0$export$23ffc21bb0cb80dc; });

var $7VQPk = parcelRequire("7VQPk");
const $6a5b77acdab386d0$export$23ffc21bb0cb80dc = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        children: "Content for Align To Goals Tab"
    });
};

});




parcelRegister("98sVM", function(module, exports) {
$parcel$export(module.exports, "JPDCrossflowComponent", function () { return $ff5ea94a800b0604$export$6f176b9b28fc0fb0; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $l22jm = parcelRequire("l22jm");

var $kooLp = parcelRequire("kooLp");

var $5yuBp = parcelRequire("5yuBp");

var $cSmPq = parcelRequire("cSmPq");
const $ff5ea94a800b0604$var$JPDHeroTitle = ()=>{
    const isMobile = (0, $5yuBp.useIsMobile)(430);
    const fontWeight = isMobile ? "bold" : "normal";
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            fontWeight: fontWeight
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "HomePageTemplateV2.jpdCrossflowHero",
            defaultMessage: "Build the right thing with{br} <jpd>Jira Product Discovery</jpd>",
            values: {
                jpd: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $l22jm.Adg4TextUnderline), {
                        underline: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                            width: "100%",
                            height: "30",
                            viewBox: "0 0 306 42",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z",
                                fill: "#FFA900"
                            })
                        }),
                        children: str
                    }),
                br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
            }
        })
    });
};
const $ff5ea94a800b0604$export$6f176b9b28fc0fb0 = ({ contentComponent: contentComponent, gwp10965XflowRecommendation: gwp10965XflowRecommendation })=>{
    const intl = (0, $8e22h.default)();
    const jpdData = {
        heroTitle: /*#__PURE__*/ (0, $7VQPk.jsx)($ff5ea94a800b0604$var$JPDHeroTitle, {}),
        ctaButton: {
            buttonText: intl.formatMessage({
                id: "HomePageTemplateV2.jpdCrossflowHero.ctaButtonText",
                defaultMessage: "Get started"
            }),
            buttonColor: "blue",
            buttonHref: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery"),
            buttonVariant: "primary",
            eventProps: {
                label: "Get started",
                labelEnglish: "Get started"
            }
        },
        contentComponent: contentComponent,
        segmentName: "jpd-crossflow-hero",
        sectionId: "jpd-crossflow-hero",
        scrollTrackingSection: "jpd-crossflow-hero",
        gwp10965XflowRecommendation: gwp10965XflowRecommendation
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cSmPq.ReusableCrossflowHeroComponent), (0, $6ogO3._)({}, jpdData));
};

});

parcelRegister("7qO7m", function(module, exports) {
$parcel$export(module.exports, "ContentTypesSection", function () { return $787e06a7a67c0364$export$375e4d9f76d4c766; });
/* content-types-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $bQjAr = parcelRequire("bQjAr");

var $a9lfn = parcelRequire("a9lfn");

var $doAVE = parcelRequire("doAVE");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $aIFEQ = parcelRequire("aIFEQ");

var $3fuX9 = parcelRequire("3fuX9");

var $8mXGf = parcelRequire("8mXGf");

var $4K0rN = parcelRequire("4K0rN");

var $7VkQP = parcelRequire("7VkQP");

var $7bvfM = parcelRequire("7bvfM");

var $36CvF = parcelRequire("36CvF");

var $ho3WR = parcelRequire("ho3WR");

var $iRjDS = parcelRequire("iRjDS");

var $6gDOZ = parcelRequire("6gDOZ");

var $8VDgu = parcelRequire("8VDgu");

var $2HqHn = parcelRequire("2HqHn");

var $ehh5O = parcelRequire("ehh5O");

var $9iIz3 = parcelRequire("9iIz3");

var $ggkMI = parcelRequire("ggkMI");

var $j9rsS = parcelRequire("j9rsS");
const $787e06a7a67c0364$var$iconTabListStyles = null;
const $787e06a7a67c0364$var$buttonResetStyle = null;
const $787e06a7a67c0364$var$teamCardStyles = null;
const $787e06a7a67c0364$var$teamCardActiveStyles = null;
const $787e06a7a67c0364$var$iconContainerStyles = null;
const $787e06a7a67c0364$var$teamCardTextStyles = null;
const $787e06a7a67c0364$var$opacityIn = null;
const $787e06a7a67c0364$var$contentContainer = null;
const $787e06a7a67c0364$var$TabButtonEventNameAndSubject = {
    jsm: {
        eventName: "jsm-crossflow-content-types-tab-clicked",
        actionSubject: "jsmCrossflowTab"
    },
    jpd: {
        eventName: "jpd-crossflow-content-types-tab-clicked",
        actionSubject: "jpdCrossflowTab"
    },
    loom: {
        eventName: "loom-crossflow-content-types-tab-clicked",
        actionSubject: "loomCrossflowTab"
    },
    confluence: {
        eventName: "confluence-crossflow-tab-cta-clicked",
        actionSubject: "confluenceCrossflowTab"
    }
};
const $787e06a7a67c0364$export$375e4d9f76d4c766 = ()=>{
    const product = (0, $ggkMI.useProduct)();
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $doAVE.useUserContext)();
    const [selectedTabIndex, setSelectedTabIndex] = (0, $1oC0p.useState)(0);
    const [hoveredTabIndex, setHoveredTabIndex] = (0, $1oC0p.useState)(null);
    const jsmTabList = [
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionIntakeRequestMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2q6vu45wf37s1r6ft77267nnf2bq80l1.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r1lsi46gpjde3mwiy7atiq22ru0612tq.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $8mXGf.RequestContentType),
            eventProps: {
                label: "content-type-tab-intake-request",
                labelEnglish: "Intake Request"
            }
        },
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionManageIncidentsMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/n7o6v23b3h38j60o3hlxn578i0j07367.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wqgk3adltt4fhi4ak1t8gbph3jxf2n4b.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $aIFEQ.IncidentContentType),
            eventProps: {
                label: "content-type-tab-manage-incidents",
                labelEnglish: "Manage Incidents"
            }
        },
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionTrackChangesMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hq1b3hi1k03483o3v61542yv73em0h0.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/qirv5p82k5x26d4w8s2b35m2h8505f3m.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $4K0rN.TrackContentType),
            eventProps: {
                label: "content-type-tab-track-changes",
                labelEnglish: "Track Changes"
            }
        },
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionShareKnowledgeMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7oel05emm1t27uy83elnej035wmd7ks6.png",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8348258a4qb10q11s77bfk4uf2lq26n3.png",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $3fuX9.KnowledgeContentType),
            eventProps: {
                label: "content-type-tab-share-knowledge",
                labelEnglish: "Share Knowledge"
            }
        }
    ];
    const jpdTabList = [
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCaptureMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2q6vu45wf37s1r6ft77267nnf2bq80l1.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r1lsi46gpjde3mwiy7atiq22ru0612tq.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $36CvF.CaptureContentType),
            eventProps: {
                label: "content-type-tab-capture-ideas",
                labelEnglish: "Capture"
            }
        },
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionPrioritizeMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/qlj3km422tr2e660ly170r7e1r75yxsy.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6sv55j0705126i28h5dge336nhj753o1.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $iRjDS.PrioritizeContentType),
            eventProps: {
                label: "content-type-tab-prioritize",
                labelEnglish: "Prioritize"
            }
        },
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionRoadmapMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/tk188matl1a71w5g6fwd7c782qp43h5r.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/03h34msxqy7g75r71uv6n253722ryjn2.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $6gDOZ.RoadmapContentType),
            eventProps: {
                label: "content-type-tab-roadmap",
                labelEnglish: "Roadmap"
            }
        },
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCollaborateMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6asfr42x4lw510ievvvk07wca1elpp5x.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/rlr1723i1f7vd1wwx830406184776os8.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $ho3WR.CollaborateContentType),
            eventProps: {
                label: "content-type-tab-collaborate",
                labelEnglish: "Collaborate"
            }
        }
    ];
    const loomTabList = [
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionVideoMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6asfr42x4lw510ievvvk07wca1elpp5x.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/rlr1723i1f7vd1wwx830406184776os8.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $9iIz3.VideoContentType),
            eventProps: {
                label: "content-type-tab-video",
                labelEnglish: "Video"
            }
        },
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionMeetingRecapMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/vo1ut21j6348d32ce6yqi1f46yh1wt0u.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/c0328ih4r348e16n4up5se220hv2h2f3.svg",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $2HqHn.MeetingsContentType),
            eventProps: {
                label: "content-type-tab-meetings",
                labelEnglish: "Meetings"
            }
        },
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionScreenshotsMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7oel05emm1t27uy83elnej035wmd7ks6.png",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8348258a4qb10q11s77bfk4uf2lq26n3.png",
                    alt: "",
                    width: 50,
                    height: 50
                }
            }),
            content: (0, $ehh5O.ScreenshotsContentType),
            eventProps: {
                label: "content-type-tab-screenshots",
                labelEnglish: "Screenshots"
            }
        },
        {
            title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionLoomAIMessages).tabName),
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/bvrt26ign45wa8nt4a841550kq32y3mu.svg",
                    alt: "",
                    width: 55,
                    height: 55
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7u87cc545044c23t12cvgx202l8kw7v4.svg",
                    alt: "",
                    width: 55,
                    height: 55
                }
            }),
            content: (0, $8VDgu.LoomAIContentType),
            eventProps: {
                label: "content-type-tab-loom-ai",
                labelEnglish: "Loom AI"
            }
        }
    ];
    const confluenceTabList = [
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/0yp71as25x875j0ou8y2863k663803pr.svg",
                    alt: "",
                    width: 55,
                    height: 55
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/b866pipr0ftqj6100p268h3db61g1tpl.svg",
                    alt: "",
                    width: 55,
                    height: 55
                }
            }),
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).tabName),
            content: (0, $7bvfM.PagesContentType),
            eventProps: {
                label: intl.formatMessage((0, $7VkQP.tabbedHeroSectionPagesMessages).tabName),
                labelEnglish: (0, $7VkQP.tabbedHeroSectionPagesMessages).tabName.defaultMessage
            }
        },
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/gqb35580xx6i4v18xhk848ab31qmk4f7.svg",
                    alt: "",
                    width: 55,
                    height: 55
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5w72lh08jnk8m3b2d6s67v3ou3nv18x3.svg",
                    alt: "",
                    width: 55,
                    height: 55
                }
            }),
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).tabName),
            content: (0, $7bvfM.WhiteboardsContentType),
            eventProps: {
                label: intl.formatMessage((0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).tabName),
                labelEnglish: (0, $7VkQP.tabbedHeroSectionWhiteboardsMessages).tabName.defaultMessage
            }
        },
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/0fmr3xgk5gqx62q35ndqwngfc11my28b.svg",
                    alt: "",
                    width: 55,
                    height: 55
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/462why1ha7r1y283700yroy7r38m40ig.svg",
                    alt: "",
                    width: 55,
                    height: 55
                }
            }),
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).tabName),
            content: (0, $7bvfM.DatabasesContentType),
            eventProps: {
                label: intl.formatMessage((0, $7VkQP.tabbedHeroSectionDatabasesMessages).tabName),
                labelEnglish: (0, $7VkQP.tabbedHeroSectionDatabasesMessages).tabName.defaultMessage
            }
        },
        {
            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/e66ii4g478c6c331oa7325b7x30220p4.svg",
                    alt: "",
                    width: 55,
                    height: 55
                }
            }),
            iconHover: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7w7igm85y85h5iv8ku53875jmq55yq74.svg",
                    alt: "",
                    width: 55,
                    height: 55
                }
            }),
            title: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).tabName),
            content: (0, $7bvfM.SpacesContentType),
            eventProps: {
                label: intl.formatMessage((0, $7VkQP.tabbedHeroSectionSpacesMessages).tabName),
                labelEnglish: (0, $7VkQP.tabbedHeroSectionSpacesMessages).tabName.defaultMessage
            }
        }
    ];
    let tabList;
    let tabButtonEventName = $787e06a7a67c0364$var$TabButtonEventNameAndSubject.jsm;
    if (product === "jsm") {
        tabList = jsmTabList;
        tabButtonEventName = $787e06a7a67c0364$var$TabButtonEventNameAndSubject.jsm;
    } else if (product === "jpd") {
        tabList = jpdTabList;
        tabButtonEventName = $787e06a7a67c0364$var$TabButtonEventNameAndSubject.jpd;
    } else if (product === "loom") {
        tabList = loomTabList;
        tabButtonEventName = $787e06a7a67c0364$var$TabButtonEventNameAndSubject.loom;
    } else if (product === "confluence") {
        tabList = confluenceTabList;
        tabButtonEventName = $787e06a7a67c0364$var$TabButtonEventNameAndSubject.confluence;
    } else {
        tabList = jsmTabList;
        tabButtonEventName = $787e06a7a67c0364$var$TabButtonEventNameAndSubject.jsm;
    }
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-xflow-contentTypesSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $a9lfn.Adg4Tabs), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTabList), {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulp1ylp _19pkidpf _2hwx1wug _otyridpf _18u01wug _6rthckbl _15pazwfg _qwozzwfg _1egl1tcg _8fz6kd3c _2osn7vkz"
                        ]),
                        children: tabList.map((tab, index)=>{
                            var _tab_eventProps;
                            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                                "aria-describedby": `tab-panel-${index}`,
                                "aria-controls": `tab-panel-${index}`,
                                onClick: ()=>{
                                    var _tab_eventProps_labelEnglish, _tab_eventProps, _user_extended_profile;
                                    setSelectedTabIndex(index);
                                    createAnalyticsEvent({
                                        eventName: tabButtonEventName.eventName,
                                        eventType: "ui",
                                        action: "clicked",
                                        actionSubject: "linkButton",
                                        actionSubjectId: tabButtonEventName.actionSubject,
                                        attributes: {
                                            reactComponent: "ContentTypesSection",
                                            tab: (_tab_eventProps = tab.eventProps) === null || _tab_eventProps === void 0 ? void 0 : (_tab_eventProps_labelEnglish = _tab_eventProps.labelEnglish) === null || _tab_eventProps_labelEnglish === void 0 ? void 0 : _tab_eventProps_labelEnglish.toLowerCase(),
                                            userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                                        }
                                    }).fire();
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                    "data-product-key": "jsm",
                                    "data-event-component": "button",
                                    "data-event-container": "contentTypesSection",
                                    "data-event": "clicked",
                                    "data-label-english": (_tab_eventProps = tab.eventProps) === null || _tab_eventProps === void 0 ? void 0 : _tab_eventProps.labelEnglish,
                                    "aria-label": tab.title,
                                    onMouseEnter: ()=>setHoveredTabIndex(index),
                                    onMouseLeave: ()=>setHoveredTabIndex(null),
                                    className: (0, $2jatx.default)([
                                        "_19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _d0altlke"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_vchhusvi _1e0c1txw _2lx21bp4 _1bsbh2q2 _4t3il1r9 _4cvr1h6o _ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _1j55glyw _kbawglyw _1x381ule",
                                            selectedTabIndex === index && "_19it1wcj _2rkoi2wt _1kd31fw0"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_4t3ickbl _1bsbckbl _1e0c1txw _4cvr1h6o _1bah1h6o _tnru10mc _1rfm10mc _sedtglyw _qp04glyw"
                                                ]),
                                                children: hoveredTabIndex === index && tab.iconHover ? tab.iconHover : tab.icon
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_ect4bzd7 _k48p1nn1 _1wyb7vkz _vwz41tcg _syaz1hlo"
                                                ]),
                                                style: {
                                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                                },
                                                children: tab.title
                                            })
                                        ]
                                    })
                                })
                            }, index);
                        })
                    }),
                    tabList.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4TabPanel), {
                            id: `tab-panel-${index}`,
                            "aria-live": selectedTabIndex === index ? "polite" : "off",
                            "aria-hidden": selectedTabIndex !== index,
                            "aria-label": `${tab.title} content`,
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _2lx21bp4 _195g1wug _1tker5sb _o5kch9n0 _8fz61kdh _1jgo1wug _1rkb1osq _1rgc1wug _y44v1f3w _q41sgktf _168g1tcg _1ia47vkz _1bdo1tcg _167q7vkz _1erg7vkz"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)(tab.content, {
                                    index: index,
                                    context: product
                                })
                            })
                        }, index))
                ]
            })
        })
    });
};
$787e06a7a67c0364$export$375e4d9f76d4c766.displayName = "ContentTypesSection";
var $787e06a7a67c0364$export$2e2bcd8739ae039 = $787e06a7a67c0364$export$375e4d9f76d4c766;

});
parcelRegister("aIFEQ", function(module, exports) {
$parcel$export(module.exports, "IncidentContentType", function () { return $15bd6d094aae5523$export$a09732bb7dacfbb8; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $hXSMk = parcelRequire("hXSMk");

var $lfTOg = parcelRequire("lfTOg");

var $eOOWL = parcelRequire("eOOWL");

var $kAq28 = parcelRequire("kAq28");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $j9rsS = parcelRequire("j9rsS");

var $dJc68 = parcelRequire("dJc68");
const $15bd6d094aae5523$export$a09732bb7dacfbb8 = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/7v45j3bosu45w2lq477u15tjfem5783e.webp",
        imageAlt: "A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionManageIncidentsMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionManageIncidentsMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionManageIncidentsMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hXSMk))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionManageIncidentsMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kAq28))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionManageIncidentsMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lfTOg))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionManageIncidentsMessages).contentFeaturePoint4),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eOOWL))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/jira/service-management",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionManageIncidentsMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "jiraServiceManagement",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Jira Service Management",
                "data-track-event": "jsm-pt.content-types.manage-incidents.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "jsm-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "jsmCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "IncidentContentType",
                        tab: "manage-incidents",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});
parcelRegister("j9rsS", function(module, exports) {
$parcel$export(module.exports, "tabbedHeroSectionIntakeRequestMessages", function () { return $06689f0cc617d0b4$export$8b42fd2a79ca9adc; });
$parcel$export(module.exports, "tabbedHeroSectionManageIncidentsMessages", function () { return $06689f0cc617d0b4$export$2e40b7a79ef8a870; });
$parcel$export(module.exports, "tabbedHeroSectionTrackChangesMessages", function () { return $06689f0cc617d0b4$export$4f530b29789b2b8e; });
$parcel$export(module.exports, "tabbedHeroSectionShareKnowledgeMessages", function () { return $06689f0cc617d0b4$export$cf2d1799a02eba21; });
$parcel$export(module.exports, "tabbedHeroSectionCaptureMessages", function () { return $06689f0cc617d0b4$export$5154de127a2f784a; });
$parcel$export(module.exports, "tabbedHeroSectionPrioritizeMessages", function () { return $06689f0cc617d0b4$export$d9ec5900456af304; });
$parcel$export(module.exports, "tabbedHeroSectionRoadmapMessages", function () { return $06689f0cc617d0b4$export$6ca6e807cb70cffc; });
$parcel$export(module.exports, "tabbedHeroSectionCollaborateMessages", function () { return $06689f0cc617d0b4$export$8cf76c2a162f712; });
$parcel$export(module.exports, "tabbedHeroSectionVideoMessages", function () { return $06689f0cc617d0b4$export$d6218a00864fb570; });
$parcel$export(module.exports, "tabbedHeroSectionMeetingRecapMessages", function () { return $06689f0cc617d0b4$export$f959f1329052a213; });
$parcel$export(module.exports, "tabbedHeroSectionScreenshotsMessages", function () { return $06689f0cc617d0b4$export$de06e936f8917126; });
$parcel$export(module.exports, "tabbedHeroSectionLoomAIMessages", function () { return $06689f0cc617d0b4$export$ed47ad7f6de58814; });

var $fnHPc = parcelRequire("fnHPc");
const $06689f0cc617d0b4$export$8b42fd2a79ca9adc = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "JSMSoftwarePage.ContentTypes.IntakeRequest.tabName",
        defaultMessage: "Intake request"
    },
    contentTitle: {
        id: "JSMSoftwarePage.ContentTypes.IntakeRequest.title",
        defaultMessage: "Request management"
    },
    contentDescription: {
        id: "JSMSoftwarePage.ContentTypes.IntakeRequest.description",
        defaultMessage: "Manage work across teams with one platform so your employees and customers quickly get the help they need."
    },
    contentFeaturePoint1: {
        id: "JSMSoftwarePage.ContentTypes.IntakeRequest.icon1",
        defaultMessage: "Automate support interactions with AI"
    },
    contentFeaturePoint2: {
        id: "JSMSoftwarePage.ContentTypes.IntakeRequest.icon2",
        defaultMessage: "Intake, track, and triage requests"
    },
    contentFeaturePoint3: {
        id: "JSMSoftwarePage.ContentTypes.IntakeRequest.icon3",
        defaultMessage: "Link requests to Jira issues"
    },
    contentFeaturePoint4: {
        id: "JSMSoftwarePage.ContentTypes.IntakeRequest.icon4",
        defaultMessage: "Set unlimited SLA policies"
    },
    contentCta: {
        id: "JSMSoftwarePage.ContentTypes.IntakeRequest.cta",
        defaultMessage: "Explore Jira Service Management"
    }
});
const $06689f0cc617d0b4$export$2e40b7a79ef8a870 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "JSMSoftwarePage.ContentTypes.ManageIncidents.tabName",
        defaultMessage: "Manage incidents"
    },
    contentTitle: {
        id: "JSMSoftwarePage.ContentTypes.ManageIncidents.title",
        defaultMessage: "Incident management"
    },
    contentDescription: {
        id: "JSMSoftwarePage.ContentTypes.ManageIncidents.description",
        defaultMessage: "Bring development and IT operations teams together to detect, resolve, and prevent incidents with AI."
    },
    contentFeaturePoint1: {
        id: "JSMSoftwarePage.ContentTypes.ManageIncidents.icon1",
        defaultMessage: "Centralize SMS, email, and mobile alerts"
    },
    contentFeaturePoint2: {
        id: "JSMSoftwarePage.ContentTypes.ManageIncidents.icon2",
        defaultMessage: "Escalate major incidents"
    },
    contentFeaturePoint3: {
        id: "JSMSoftwarePage.ContentTypes.ManageIncidents.icon3",
        defaultMessage: "Customize on-call schedules"
    },
    contentFeaturePoint4: {
        id: "JSMSoftwarePage.ContentTypes.ManageIncidents.icon4",
        defaultMessage: "Track and analyze reports"
    },
    contentCta: {
        id: "JSMSoftwarePage.ContentTypes.ManageIncidents.cta",
        defaultMessage: "Explore Jira Service Management"
    }
});
const $06689f0cc617d0b4$export$4f530b29789b2b8e = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "JSMSoftwarePage.ContentTypes.TrackChanges.tabName",
        defaultMessage: "Track changes"
    },
    contentTitle: {
        id: "JSMSoftwarePage.ContentTypes.TrackChanges.title",
        defaultMessage: "Change management"
    },
    contentDescription: {
        id: "JSMSoftwarePage.ContentTypes.TrackChanges.description",
        defaultMessage: "Empower IT operations teams with more context around changes to make better decisions and minimize risk."
    },
    contentFeaturePoint1: {
        id: "JSMSoftwarePage.ContentTypes.TrackChanges.icon1",
        defaultMessage: "Assess risk of potential changes"
    },
    contentFeaturePoint2: {
        id: "JSMSoftwarePage.ContentTypes.TrackChanges.icon2",
        defaultMessage: "Configure approval workflows"
    },
    contentFeaturePoint3: {
        id: "JSMSoftwarePage.ContentTypes.TrackChanges.icon3",
        defaultMessage: "Automate deployments"
    },
    contentFeaturePoint4: {
        id: "JSMSoftwarePage.ContentTypes.TrackChanges.icon4",
        defaultMessage: "Track and schedule changes"
    },
    contentCta: {
        id: "JSMSoftwarePage.ContentTypes.TrackChanges.cta",
        defaultMessage: "Explore Jira Service Management"
    }
});
const $06689f0cc617d0b4$export$cf2d1799a02eba21 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "JSMSoftwarePage.ContentTypes.ShareKnowledge.tabName",
        defaultMessage: "Share knowledge"
    },
    contentTitle: {
        id: "JSMSoftwarePage.ContentTypes.ShareKnowledge.title",
        defaultMessage: "Knowledge management"
    },
    contentDescription: {
        id: "JSMSoftwarePage.ContentTypes.ShareKnowledge.description",
        defaultMessage: "Enable self-service, deflect more requests, and manage knowledge articles - all while fostering team collaboration."
    },
    contentFeaturePoint1: {
        id: "JSMSoftwarePage.ContentTypes.ShareKnowledge.icon1",
        defaultMessage: "Enable self-service"
    },
    contentFeaturePoint2: {
        id: "JSMSoftwarePage.ContentTypes.ShareKnowledge.icon2",
        defaultMessage: "Suggest relevant articles with AI"
    },
    contentFeaturePoint3: {
        id: "JSMSoftwarePage.ContentTypes.ShareKnowledge.icon3",
        defaultMessage: "Create and update articles easily"
    },
    contentFeaturePoint4: {
        id: "JSMSoftwarePage.ContentTypes.ShareKnowledge.icon4",
        defaultMessage: "Automate support with an AI agent"
    },
    contentCta: {
        id: "JSMSoftwarePage.ContentTypes.ShareKnowledge.cta",
        defaultMessage: "Explore Jira Service Management"
    }
});
const $06689f0cc617d0b4$export$5154de127a2f784a = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "JSMSoftwarePage.ContentTypes.Capture.tabName",
        defaultMessage: "Capture"
    },
    contentTitle: {
        id: "JPDSoftwarePage.ContentTypes.Capture.title",
        defaultMessage: "Capture ideas and insights"
    },
    contentDescription: {
        id: "JPDSoftwarePage.ContentTypes.Capture.description",
        defaultMessage: "Give unstructured product work a home across product opportunities, user feedback, feature requests and more."
    },
    contentFeaturePoint1: {
        id: "JPDSoftwarePage.ContentTypes.Capture.icon1",
        defaultMessage: "Centralize ideas on a dedicated backlog"
    },
    contentFeaturePoint2: {
        id: "JPDSoftwarePage.ContentTypes.Capture.icon2",
        defaultMessage: "Collect insights anywhere via Chrome extension"
    },
    contentFeaturePoint3: {
        id: "JPDSoftwarePage.ContentTypes.Capture.featureIcon3",
        defaultMessage: "Enrich ideas with customer or data insights"
    },
    contentCta: {
        id: "JPDSoftwarePage.ContentTypes.Capture.cta",
        defaultMessage: "Explore Jira Product Discovery"
    }
});
const $06689f0cc617d0b4$export$d9ec5900456af304 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "JPDSoftwarePage.ContentTypes.Prioritize.tabName",
        defaultMessage: "Prioritize"
    },
    contentTitle: {
        id: "JPDSoftwarePage.ContentTypes.Prioritize.title",
        defaultMessage: "Prioritize with evidence"
    },
    contentDescription: {
        id: "JPDSoftwarePage.ContentTypes.Prioritize.description",
        defaultMessage: "Utilize data and customer insights to help your team prioritize ideas that will make the biggest impact."
    },
    contentFeaturePoint1: {
        id: "JPDSoftwarePage.ContentTypes.Prioritize.icon1",
        defaultMessage: "Prioritize by impact, effort, goals, or more"
    },
    contentFeaturePoint2: {
        id: "JPDSoftwarePage.ContentTypes.Prioritize.icon2",
        defaultMessage: "Use frameworks or your own approach"
    },
    contentFeaturePoint3: {
        id: "JPDSoftwarePage.ContentTypes.Prioritize.icon3",
        defaultMessage: "Compare ideas with list and matrix views"
    },
    contentCta: {
        id: "JPDSoftwarePage.ContentTypes.Prioritize.cta",
        defaultMessage: "Explore Jira Product Discovery"
    }
});
const $06689f0cc617d0b4$export$6ca6e807cb70cffc = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "JPDSoftwarePage.ContentTypes.Roadmap.tabName",
        defaultMessage: "Roadmap"
    },
    contentTitle: {
        id: "JPDSoftwarePage.ContentTypes.Roadmap.title",
        defaultMessage: "Roadmap, as a team"
    },
    contentDescription: {
        id: "JPDSoftwarePage.ContentTypes.Roadmap.description",
        defaultMessage: "Spend less time updating and persuading with roadmaps that give stakeholders the information they need."
    },
    contentFeaturePoint1: {
        id: "JPDSoftwarePage.ContentTypes.Roadmap.icon1",
        defaultMessage: "Communicate the what and why of your roadmap"
    },
    contentFeaturePoint2: {
        id: "JPDSoftwarePage.ContentTypes.Roadmap.icon2",
        defaultMessage: "Engage teams with interactive feedback"
    },
    contentFeaturePoint3: {
        id: "JPDSoftwarePage.ContentTypes.Roadmap.icon3",
        defaultMessage: "Rally stakeholders around a shared vision"
    },
    contentCta: {
        id: "JPDSoftwarePage.ContentTypes.Prioritize.cta",
        defaultMessage: "Explore Jira Product Discovery"
    }
});
const $06689f0cc617d0b4$export$8cf76c2a162f712 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "JPDSoftwarePage.ContentTypes.Collaborate.tabName",
        defaultMessage: "Collaborate"
    },
    contentTitle: {
        id: "JPDSoftwarePage.ContentTypes.Collaborate.title",
        defaultMessage: "Connect teams, all in Jira"
    },
    contentDescription: {
        id: "JPDSoftwarePage.ContentTypes.Collaborate.description",
        defaultMessage: "Improve collaboration across product and engineering."
    },
    contentFeaturePoint1: {
        id: "JPDSoftwarePage.ContentTypes.Collaborate.icon1",
        defaultMessage: "Link your ideas to delivery work in Jira"
    },
    contentFeaturePoint2: {
        id: "JPDSoftwarePage.ContentTypes.Collaborate.icon2",
        defaultMessage: "Centralize goals, priorities, and progress"
    },
    contentFeaturePoint3: {
        id: "JPDSoftwarePage.ContentTypes.Collaborate.icon3",
        defaultMessage: "Uplevel prioritization with shared context"
    },
    contentCta: {
        id: "JPDSoftwarePage.ContentTypes.Collaborate.cta",
        defaultMessage: "Explore Jira Product Discovery"
    }
});
const $06689f0cc617d0b4$export$d6218a00864fb570 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "LoomSoftwarePage.ContentTypes.Video.tabName",
        defaultMessage: "Video messages"
    },
    contentTitle: {
        id: "LoomSoftwarePage.ContentTypes.Video.title",
        defaultMessage: "Record, share, collaborate"
    },
    contentDescription: {
        id: "LoomSoftwarePage.ContentTypes.Video.description",
        defaultMessage: "Sending a clear message is easy with video. Simply record your screen and talk through any updates, feedback, or presentations \u2014 no meetings required."
    },
    contentFeaturePoint1: {
        id: "LoomSoftwarePage.ContentTypes.Video.icon1",
        defaultMessage: "Free video hosting"
    },
    contentFeaturePoint2: {
        id: "LoomSoftwarePage.ContentTypes.Video.icon2",
        defaultMessage: "Cross-device recording"
    },
    contentFeaturePoint3: {
        id: "LoomSoftwarePage.ContentTypes.Video.icon3",
        defaultMessage: "Intutive editing tools"
    },
    contentFeaturePoint4: {
        id: "LoomSoftwarePage.ContentTypes.Video.icon4",
        defaultMessage: "AI-powered enhancements"
    },
    contentCta: {
        id: "LoomSoftwarePage.ContentTypes.Video.cta",
        defaultMessage: "Explore Loom"
    }
});
const $06689f0cc617d0b4$export$f959f1329052a213 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "LoomSoftwarePage.ContentTypes.MeetingRecap.tabName",
        defaultMessage: "Meeting recaps"
    },
    contentTitle: {
        id: "LoomSoftwarePage.ContentTypes.MeetingRecap.title",
        defaultMessage: "Better meetings, less work"
    },
    contentDescription: {
        id: "LoomSoftwarePage.ContentTypes.MeetingRecap.description",
        defaultMessage: "Invite Loom to video calls for instant recaps and action items. It can even add meeting notes to Confluence automatically \u2013 keeping everyone on the same page."
    },
    contentFeaturePoint1: {
        id: "LoomSoftwarePage.ContentTypes.MeetingRecap.icon1",
        defaultMessage: "Automated note-taking"
    },
    contentFeaturePoint2: {
        id: "LoomSoftwarePage.ContentTypes.MeetingRecap.icon2",
        defaultMessage: "Instant recap tracking"
    },
    contentFeaturePoint3: {
        id: "LoomSoftwarePage.ContentTypes.MeetingRecap.icon3",
        defaultMessage: "Seamless confluence integration"
    },
    contentCta: {
        id: "LoomSoftwarePage.ContentTypes.Video.cta",
        defaultMessage: "Explore Loom"
    }
});
const $06689f0cc617d0b4$export$de06e936f8917126 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "LoomSoftwarePage.ContentTypes.Screenshot.tabName",
        defaultMessage: "Screenshots"
    },
    contentTitle: {
        id: "LoomSoftwarePage.ContentTypes.Screenshot.title",
        defaultMessage: "Screenshots for clarity"
    },
    contentDescription: {
        id: "LoomSoftwarePage.ContentTypes.Screenshot.description",
        defaultMessage: "Show exactly what you mean with the Loom screenshot tool. Capture and annotate an image fast, then share with a link."
    },
    contentFeaturePoint1: {
        id: "LoomSoftwarePage.ContentTypes.Screenshot.icon1",
        defaultMessage: "Instant capture & automation"
    },
    contentFeaturePoint2: {
        id: "LoomSoftwarePage.ContentTypes.Screenshot.icon2",
        defaultMessage: "Unlimited cloud storage"
    },
    contentFeaturePoint3: {
        id: "LoomSoftwarePage.ContentTypes.Screenshot.icon3",
        defaultMessage: "Effortless sharing"
    },
    contentCta: {
        id: "LoomSoftwarePage.ContentTypes.Video.cta",
        defaultMessage: "Explore Loom"
    }
});
const $06689f0cc617d0b4$export$ed47ad7f6de58814 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "LoomSoftwarePage.ContentTypes.LoomAI.tabName",
        defaultMessage: "Loom AI"
    },
    contentTitle: {
        id: "LoomSoftwarePage.ContentTypes.LoomAI.title",
        defaultMessage: "Let AI do the work"
    },
    contentDescription: {
        id: "LoomSoftwarePage.ContentTypes.LoomAI.description",
        defaultMessage: "Communicate with confidence knowing Loom AI will instantly add a title, chapters, and summary to your video. Need a doc or bug report? Loom can write it for you."
    },
    contentFeaturePoint1: {
        id: "LoomSoftwarePage.ContentTypes.LoomAI.icon1",
        defaultMessage: "Auto notes & action tracking"
    },
    contentFeaturePoint2: {
        id: "LoomSoftwarePage.ContentTypes.LoomAI.icon2",
        defaultMessage: "Auto-create Jira tasks/bugs"
    },
    contentFeaturePoint3: {
        id: "LoomSoftwarePage.ContentTypes.LoomAI.icon3",
        defaultMessage: "Summaries for Slack, email, chat"
    },
    contentFeaturePoint4: {
        id: "LoomSoftwarePage.ContentTypes.LoomAI.icon4",
        defaultMessage: "AI-powered video enhancements"
    },
    contentCta: {
        id: "LoomSoftwarePage.ContentTypes.Video.cta",
        defaultMessage: "Explore Loom"
    }
});

});

parcelRegister("dJc68", function(module, exports) {
$parcel$export(module.exports, "ContentTypeImage", function () { return $60ccc0a1b6fb7a9a$export$ca7d4051caa8560f; });
/* content-type-image.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hnmMQ = parcelRequire("hnmMQ");

var $9D0tJ = parcelRequire("9D0tJ");
const $60ccc0a1b6fb7a9a$var$imageStyle = null;
const $60ccc0a1b6fb7a9a$var$imageSizing = null;
const $60ccc0a1b6fb7a9a$var$iconSpacingOverride = null;
const $60ccc0a1b6fb7a9a$export$ca7d4051caa8560f = (_param)=>{
    var { active: active, imageSrc: imageSrc, imageAlt: imageAlt } = _param, props = (0, $aPnCa._)(_param, [
        "active",
        "imageSrc",
        "imageAlt"
    ]);
    const FeatureInfoImage = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_bozg7vkz _y4ti7vkz _v736idpf _chtuidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _1gdl1wug _zzrm1osq _1y8oauwl _z9so1wug _161z1wug _2a8r1wug _ikcg1wug _lkug1wug"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: imageSrc,
                    alt: imageAlt,
                    width: 736,
                    height: 433
                }
            })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_pi1jftgi _w0qwidpf _8lhcftgi _1lre1osq _10mf1wug _1ya5idpf _445tidpf",
            "tab-content-image-container"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9D0tJ.FeatureInfo), (0, $dPABA._)((0, $6ogO3._)({}, props), {
            reverseLayout: true,
            children: FeatureInfoImage
        }))
    });
};

});


parcelRegister("3fuX9", function(module, exports) {
$parcel$export(module.exports, "KnowledgeContentType", function () { return $4fe01a07df45a31a$export$49ccb187dc50a174; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $cnoa5 = parcelRequire("cnoa5");

var $b2tob = parcelRequire("b2tob");

var $kzcfD = parcelRequire("kzcfD");

var $PQhz5 = parcelRequire("PQhz5");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $j9rsS = parcelRequire("j9rsS");

var $dJc68 = parcelRequire("dJc68");
const $4fe01a07df45a31a$export$49ccb187dc50a174 = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/56m2ndu02rfu3qa17o7yl2i13t0628s0.webp",
        imageAlt: "A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionShareKnowledgeMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionShareKnowledgeMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionShareKnowledgeMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kzcfD))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionShareKnowledgeMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($PQhz5))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionShareKnowledgeMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b2tob))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionShareKnowledgeMessages).contentFeaturePoint4),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cnoa5))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/jira/service-management",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionShareKnowledgeMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "jiraServiceManagement",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Jira Service Management",
                "data-track-event": "jsm-pt.content-types.share-knowledge.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "jsm-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "jsmCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "KnowledgeContentType",
                        tab: "share-knowledge",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});
parcelRegister("cnoa5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec2830ef4a5653740a2b8f60e21924b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0253439cf148f099$var$_react = $0253439cf148f099$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0253439cf148f099$var$_baseNew = $0253439cf148f099$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $0253439cf148f099$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0253439cf148f099$var$AiAgentIcon = (props)=>/*#__PURE__*/ $0253439cf148f099$var$_react.default.createElement($0253439cf148f099$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$0253439cf148f099$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $0253439cf148f099$var$_default = module.exports.default = $0253439cf148f099$var$AiAgentIcon;

});


parcelRegister("8mXGf", function(module, exports) {
$parcel$export(module.exports, "RequestContentType", function () { return $502aa55b299cecd6$export$3c77af3f87b8ca19; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $b2tob = parcelRequire("b2tob");

var $leqii = parcelRequire("leqii");

var $j0gMs = parcelRequire("j0gMs");

var $hp8xM = parcelRequire("hp8xM");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $j9rsS = parcelRequire("j9rsS");

var $dJc68 = parcelRequire("dJc68");
const $502aa55b299cecd6$export$3c77af3f87b8ca19 = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/0386o60lcs23u0wxo60c181728fvqa65.webp",
        imageAlt: "A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionIntakeRequestMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionIntakeRequestMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionIntakeRequestMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hp8xM))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionIntakeRequestMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b2tob))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionIntakeRequestMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($leqii))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionIntakeRequestMessages).contentFeaturePoint4),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j0gMs))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/jira/service-management",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionIntakeRequestMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "jiraServiceManagement",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Jira Service Management",
                "data-track-event": "jsm-pt.content-types.intake-request.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "jsm-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "jsmCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "RequestContentType",
                        tab: "intake-request",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});
parcelRegister("j0gMs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16a72127bfc0e3d91a970ca1d9129c37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd5b08a809eb0ce8$var$_react = $dd5b08a809eb0ce8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $dd5b08a809eb0ce8$var$_baseNew = $dd5b08a809eb0ce8$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $dd5b08a809eb0ce8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Flag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: flags in Editor, feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd5b08a809eb0ce8$var$FlagIcon = (props)=>/*#__PURE__*/ $dd5b08a809eb0ce8$var$_react.default.createElement($dd5b08a809eb0ce8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.22 1.22A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2V1.75a.75.75 0 0 1 .22-.53M3.5 9h9l-2.1-2.8a.75.75 0 0 1 0-.9l2.1-2.8h-9z" clip-rule="evenodd"/>`
    }, props));
$dd5b08a809eb0ce8$var$FlagIcon.displayName = 'FlagIcon';
var $dd5b08a809eb0ce8$var$_default = module.exports.default = $dd5b08a809eb0ce8$var$FlagIcon;

});

parcelRegister("hp8xM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::821d8a868bec01d1b9c95a45239911fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cabb6613500f378e$var$_react = $cabb6613500f378e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cabb6613500f378e$var$_baseNew = $cabb6613500f378e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $cabb6613500f378e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cabb6613500f378e$var$PremiumIcon = (props)=>/*#__PURE__*/ $cabb6613500f378e$var$_react.default.createElement($cabb6613500f378e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$cabb6613500f378e$var$PremiumIcon.displayName = 'PremiumIcon';
var $cabb6613500f378e$var$_default = module.exports.default = $cabb6613500f378e$var$PremiumIcon;

});


parcelRegister("4K0rN", function(module, exports) {
$parcel$export(module.exports, "TrackContentType", function () { return $420ee588baa4597b$export$f0340377a70d6151; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $9Cyyz = parcelRequire("9Cyyz");

var $lfTOg = parcelRequire("lfTOg");

var $efg6m = parcelRequire("efg6m");

var $lshIt = parcelRequire("lshIt");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $j9rsS = parcelRequire("j9rsS");

var $dJc68 = parcelRequire("dJc68");
const $420ee588baa4597b$export$f0340377a70d6151 = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/27g7egubc3xn45a4r7e0t26d4q2p23r1.webp",
        imageAlt: "A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionTrackChangesMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionTrackChangesMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionTrackChangesMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($efg6m))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionTrackChangesMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lshIt))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionTrackChangesMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Cyyz))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionTrackChangesMessages).contentFeaturePoint4),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lfTOg))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/jira/service-management",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionTrackChangesMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "jiraServiceManagement",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Jira Service Management",
                "data-track-event": "jsm-pt.content-types.track-changes.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "jsm-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "jsmCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "TrackContentType",
                        tab: "track-changes",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});
parcelRegister("lshIt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e9795e597b52fb83fbace5cb1978ff6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9e9f49737749ade$var$_react = $f9e9f49737749ade$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f9e9f49737749ade$var$_baseNew = $f9e9f49737749ade$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f9e9f49737749ade$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DataFlow".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Database schema in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f9e9f49737749ade$var$DataFlowIcon = (props)=>/*#__PURE__*/ $f9e9f49737749ade$var$_react.default.createElement($f9e9f49737749ade$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.75 1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5H9.563C8.976 3 8.5 3.476 8.5 4.063V7.25h3.128a2.251 2.251 0 1 1 0 1.5H8.5v3.188c0 .586.476 1.062 1.063 1.062h2.065a2.251 2.251 0 1 1 0 1.5H9.563A2.563 2.563 0 0 1 7 11.938V8.75H4.372a2.25 2.25 0 1 1 0-1.5H7V4.063A2.56 2.56 0 0 1 9.563 1.5zM2.25 7.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m11.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0 5.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$f9e9f49737749ade$var$DataFlowIcon.displayName = 'DataFlowIcon';
var $f9e9f49737749ade$var$_default = module.exports.default = $f9e9f49737749ade$var$DataFlowIcon;

});


parcelRegister("7bvfM", function(module, exports) {
$parcel$export(module.exports, "PagesContentType", function () { return $244bb25c4645892e$export$3914470415d96f5f; });
$parcel$export(module.exports, "WhiteboardsContentType", function () { return $244bb25c4645892e$export$163a1257b16e076f; });
$parcel$export(module.exports, "DatabasesContentType", function () { return $244bb25c4645892e$export$abd9e762d8d9ba66; });
$parcel$export(module.exports, "SpacesContentType", function () { return $244bb25c4645892e$export$31e6bce70211a7b2; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $FI4AH = parcelRequire("FI4AH");

var $gey2B = parcelRequire("gey2B");

var $lshIt = parcelRequire("lshIt");

var $ppCkT = parcelRequire("ppCkT");

var $10jed = parcelRequire("10jed");

var $6zF1U = parcelRequire("6zF1U");

var $PQhz5 = parcelRequire("PQhz5");

var $bf5rK = parcelRequire("bf5rK");

var $ggVkr = parcelRequire("ggVkr");

var $hp8xM = parcelRequire("hp8xM");

var $gjva1 = parcelRequire("gjva1");

var $dTPlE = parcelRequire("dTPlE");

var $a9lfn = parcelRequire("a9lfn");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $cLuPb = parcelRequire("cLuPb");
const $244bb25c4645892e$var$getCtaDataEventProps = (contentType, defaultMessage, formattedCtaText)=>{
    return {
        "data-product-key": "confluence",
        "data-event-component": "linkButton",
        "data-event-container": "contentTypesSection",
        "data-event": "clicked",
        "data-label": formattedCtaText.toLowerCase().replace(" ", "-"),
        "data-label-english": defaultMessage,
        "data-track-event": `confluence-pt.content-types.${contentType}.cta`
    };
};
const $244bb25c4645892e$export$3914470415d96f5f = ({ index: index })=>{
    const { isCurrentTab: isCurrentTab } = (0, $a9lfn.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const pagesCtaText = (0, $fnHPc.defineMessage)({
        id: "HomePageTemplateV2.confluenceCrossflowHero.pagesCtaButton",
        defaultMessage: "Explore pages"
    });
    const formattedPagesCtaText = intl.formatMessage(pagesCtaText);
    const pagesCtaLink = (0, $kooLp.useLocalizedHref)("/software/confluence/pages");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: "Get everyone on the same page",
        description: "Take notes, plan projects, and refine ideas with flexible Confluence live docs and pages. Or let AI do it for you.",
        iconCollection: [
            {
                description: "Brainstorming templates",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf5rK))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                description: "Real-time collaboration with live docs",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTPlE))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                description: "AI editor to fill in the blanks",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hp8xM))), {
                    label: "",
                    spacing: "spacious"
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                href: pagesCtaLink,
                text: formattedPagesCtaText,
                type: "primary",
                dataEventProps: $244bb25c4645892e$var$getCtaDataEventProps("pages", pagesCtaText.defaultMessage, formattedPagesCtaText)
            })
        }),
        videoSrcMp4: "https://dam-cdn.atl.orangelogic.com/AssetLink/mp73h78mrau2cl0p7jc381iml8cgd2iy.mp4",
        videoSrcWebm: "https://dam-cdn.atl.orangelogic.com/AssetLink/8842i0ee1unjy3355235q4bb838pnv40.webm",
        videoPreviewSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/6i87746a6ini3oyk1hxql81x7yq10ew6.webp",
        showBackground: true,
        useSpecificBackgroundStyle: "purple",
        isUseReusableXflowFeatureInfo: true,
        hideSeparator: true,
        addPaddingAboveList: true
    });
};
const $244bb25c4645892e$export$163a1257b16e076f = ({ index: index })=>{
    const { isCurrentTab: isCurrentTab } = (0, $a9lfn.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const whiteboardsCtaText = (0, $fnHPc.defineMessage)({
        id: "HomePageTemplateV2.confluenceCrossflowHero.whiteboardsCtaButton",
        defaultMessage: "Explore whiteboards"
    });
    const formattedWhiteboardsCtaText = intl.formatMessage(whiteboardsCtaText);
    const ctaLink = (0, $kooLp.useLocalizedHref)("/software/confluence/whiteboards");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: "Next-gen brainstorming",
        description: "Capture free-flowing thoughts and collaborate on ideas with Confluence Whiteboards.",
        iconCollection: [
            {
                description: "Countless templates to get started fast",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($PQhz5))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                description: "Diagrams and flow charts",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($FI4AH))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                description: "Team retrospectives",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gjva1))), {
                    label: "",
                    spacing: "spacious"
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                href: ctaLink,
                text: formattedWhiteboardsCtaText,
                type: "primary",
                dataEventProps: $244bb25c4645892e$var$getCtaDataEventProps("whiteboards", whiteboardsCtaText.defaultMessage, formattedWhiteboardsCtaText)
            })
        }),
        videoSrcMp4: "https://dam-cdn.atl.orangelogic.com/AssetLink/77d2gcld0682t52faah0nqs5u52r5bv5.mp4",
        videoSrcWebm: "https://dam-cdn.atl.orangelogic.com/AssetLink/a16ohebx20rk4821sq27884jymn32uw1.webm",
        videoPreviewSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/02rq48pu8edm8x711iva8pervsq4b726.webp",
        showBackground: true,
        useSpecificBackgroundStyle: "green",
        isUseReusableXflowFeatureInfo: true,
        hideSeparator: true,
        addPaddingAboveList: true
    });
};
const $244bb25c4645892e$export$abd9e762d8d9ba66 = ({ index: index })=>{
    const { isCurrentTab: isCurrentTab } = (0, $a9lfn.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const databasesCtaText = (0, $fnHPc.defineMessage)({
        id: "HomePageTemplateV2.confluenceCrossflowHero.databasesCtaButton",
        defaultMessage: "Explore databases"
    });
    const formattedDatabasesCtaText = intl.formatMessage(databasesCtaText);
    const ctaLink = (0, $kooLp.useLocalizedHref)("/software/confluence/databases");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: "A new way to stay in sync",
        description: "Add structure, sync in real-time, and visualize your team\u2019s work with Confluence Databases.",
        iconCollection: [
            {
                description: "Dynamic fields",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($10jed))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                description: "Configurable views",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gey2B))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                description: "Aggregated data sources",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lshIt))), {
                    label: "",
                    spacing: "spacious"
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                href: ctaLink,
                text: formattedDatabasesCtaText,
                type: "primary",
                dataEventProps: $244bb25c4645892e$var$getCtaDataEventProps("databases", databasesCtaText.defaultMessage, formattedDatabasesCtaText)
            })
        }),
        videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR_reencode.mp4",
        videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm",
        videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp",
        showBackground: true,
        useSpecificBackgroundStyle: "orange",
        isUseReusableXflowFeatureInfo: true,
        hideSeparator: true,
        addPaddingAboveList: true
    });
};
const $244bb25c4645892e$export$31e6bce70211a7b2 = ({ index: index })=>{
    const { isCurrentTab: isCurrentTab } = (0, $a9lfn.useAdg4TabsContext)();
    const intl = (0, $8e22h.default)();
    const spacesCtaText = (0, $fnHPc.defineMessage)({
        id: "HomePageTemplateV2.confluenceCrossflowHero.spacesCtaButton",
        defaultMessage: "Explore knowledge sharing"
    });
    const formattedSpacesCtaText = intl.formatMessage(spacesCtaText);
    const ctaLink = (0, $kooLp.useLocalizedHref)("/software/confluence/spaces");
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cLuPb.ContentTypeVideo), {
        active: isCurrentTab(index),
        title: "Find what you need",
        description: "Organize knowledge across teams, projects, and goals with Spaces in Confluence.",
        iconCollection: [
            {
                description: "Structured page tree",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ppCkT))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                description: "Centralized access to knowledge",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zF1U))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                description: "Customizable permissions",
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggVkr))), {
                    label: "",
                    spacing: "spacious"
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                href: ctaLink,
                text: formattedSpacesCtaText,
                type: "primary",
                dataEventProps: $244bb25c4645892e$var$getCtaDataEventProps("spaces", spacesCtaText.defaultMessage, formattedSpacesCtaText)
            })
        }),
        videoSrcMp4: "https://dam-cdn.atl.orangelogic.com/AssetLink/336lite38u32861f1m4a00tt0yw543w3.mp4",
        videoSrcWebm: "https://dam-cdn.atl.orangelogic.com/AssetLink/74a2y7d1bv6n64nh77m0x2t5c22324u0.webm",
        videoPreviewSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/02s15d6mx7653268b02ow84vr1uug611.webp",
        showBackground: true,
        useSpecificBackgroundStyle: "green",
        isUseReusableXflowFeatureInfo: true,
        hideSeparator: true,
        addPaddingAboveList: true
    });
};

});
parcelRegister("gey2B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4502f1006918f00802afd208dfed8019>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd185bf85fc7b518$var$_react = $bd185bf85fc7b518$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bd185bf85fc7b518$var$_baseNew = $bd185bf85fc7b518$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $bd185bf85fc7b518$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd185bf85fc7b518$var$DashboardIcon = (props)=>/*#__PURE__*/ $bd185bf85fc7b518$var$_react.default.createElement($bd185bf85fc7b518$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$bd185bf85fc7b518$var$DashboardIcon.displayName = 'DashboardIcon';
var $bd185bf85fc7b518$var$_default = module.exports.default = $bd185bf85fc7b518$var$DashboardIcon;

});

parcelRegister("10jed", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::012d66b4638df27988cb46b8baf9afaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bb4b4e384b6a0b5$var$_react = $0bb4b4e384b6a0b5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0bb4b4e384b6a0b5$var$_baseNew = $0bb4b4e384b6a0b5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $0bb4b4e384b6a0b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldCheckboxGroup".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Checkbox group field type in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0bb4b4e384b6a0b5$var$FieldCheckboxGroupIcon = (props)=>/*#__PURE__*/ $0bb4b4e384b6a0b5$var$_react.default.createElement($0bb4b4e384b6a0b5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 2.75A.75.75 0 0 1 1.75 2h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5A.75.75 0 0 1 1 6.25zm1.5.75v2h2v-2zM16 5.25H8v-1.5h8zM1 9.75A.75.75 0 0 1 1.75 9h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75zm1.5.75v2h2v-2zM16 12.25H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$0bb4b4e384b6a0b5$var$FieldCheckboxGroupIcon.displayName = 'FieldCheckboxGroupIcon';
var $0bb4b4e384b6a0b5$var$_default = module.exports.default = $0bb4b4e384b6a0b5$var$FieldCheckboxGroupIcon;

});

parcelRegister("dTPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1e83e1969f37e79$var$_react = $a1e83e1969f37e79$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a1e83e1969f37e79$var$_baseNew = $a1e83e1969f37e79$var$_interopRequireDefault((parcelRequire("jcI35")));
function $a1e83e1969f37e79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1e83e1969f37e79$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a1e83e1969f37e79$var$_react.default.createElement($a1e83e1969f37e79$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a1e83e1969f37e79$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a1e83e1969f37e79$var$_default = module.exports.default = $a1e83e1969f37e79$var$PageLiveDocIcon;

});


parcelRegister("36CvF", function(module, exports) {
$parcel$export(module.exports, "CaptureContentType", function () { return $a2f45fe3d99c5ce7$export$63a57a20db9bf602; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $4szpS = parcelRequire("4szpS");

var $35vmV = parcelRequire("35vmV");

var $k2zyM = parcelRequire("k2zyM");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $dJc68 = parcelRequire("dJc68");

var $j9rsS = parcelRequire("j9rsS");
const $a2f45fe3d99c5ce7$export$63a57a20db9bf602 = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/4rto2jp1t0bj3a27w6785p1a4ynon8bp.webp",
        imageAlt: "This is an image of Jira Product Discovery's backlog, that shows a list of ideas, and how insights are generated from them.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCaptureMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCaptureMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCaptureMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4szpS))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCaptureMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($35vmV))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCaptureMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k2zyM))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/jira/product-discovery",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCaptureMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "jiraProductDiscovery",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Jira Product Discovery",
                "data-track-event": "jpd-pt.content-types.capture-ideas.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "jpd-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "jpdCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "CaptureContentType",
                        tab: "capture-ideas",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});

parcelRegister("ho3WR", function(module, exports) {
$parcel$export(module.exports, "CollaborateContentType", function () { return $70ff5a6e52bd2e33$export$d03c6cd6f809e069; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $9dCmO = parcelRequire("9dCmO");

var $leqii = parcelRequire("leqii");

var $ehGJT = parcelRequire("ehGJT");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $dJc68 = parcelRequire("dJc68");

var $j9rsS = parcelRequire("j9rsS");
const $70ff5a6e52bd2e33$export$d03c6cd6f809e069 = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/w3t1q5q216ig76vqf8uw64s328t01641.webp",
        imageAlt: "This is an image of Jira Product Discovery's ideas linked to delivery work.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCollaborateMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCollaborateMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCollaborateMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($leqii))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCollaborateMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ehGJT))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCollaborateMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dCmO))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/jira/product-discovery",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionCollaborateMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "jiraProductDiscovery",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Jira Product Discovery",
                "data-track-event": "jpd-pt.content-types.collaborate.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "jpd-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "jpdCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "CollaborateContentType",
                        tab: "collaborate",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});
parcelRegister("ehGJT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa0a7a20e9878c1f12b50feba4970dc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a663ce5ab5e4ae47$var$_react = $a663ce5ab5e4ae47$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a663ce5ab5e4ae47$var$_baseNew = $a663ce5ab5e4ae47$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $a663ce5ab5e4ae47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a663ce5ab5e4ae47$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $a663ce5ab5e4ae47$var$_react.default.createElement($a663ce5ab5e4ae47$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$a663ce5ab5e4ae47$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $a663ce5ab5e4ae47$var$_default = module.exports.default = $a663ce5ab5e4ae47$var$WorkItemsIcon;

});


parcelRegister("iRjDS", function(module, exports) {
$parcel$export(module.exports, "PrioritizeContentType", function () { return $e2440d9a48df722c$export$cbe1044f38dde60e; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7JEHy = parcelRequire("7JEHy");

var $96j6d = parcelRequire("96j6d");

var $6zF1U = parcelRequire("6zF1U");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $dJc68 = parcelRequire("dJc68");

var $j9rsS = parcelRequire("j9rsS");
const $e2440d9a48df722c$export$cbe1044f38dde60e = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/68qe62s0jlq27ca036c8bj6kg6albvgt.webp",
        imageAlt: "This is an image of Jira Product Discovery with a list of ideas and how they are priorized by impact and effort.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionPrioritizeMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionPrioritizeMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionPrioritizeMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7JEHy))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionPrioritizeMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zF1U))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionPrioritizeMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96j6d))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/jira/product-discovery",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionPrioritizeMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "jiraProductDiscovery",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Jira Product Discovery",
                "data-track-event": "jpd-pt.content-types.prioritize-ideas.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "jpd-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "jpdCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "PrioritizeContentType",
                        tab: "prioritize-ideas",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});
parcelRegister("96j6d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7b5804889990b150be57e7707dfe0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a037d4d5e538885$var$_react = $6a037d4d5e538885$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6a037d4d5e538885$var$_baseNew = $6a037d4d5e538885$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6a037d4d5e538885$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a037d4d5e538885$var$GridIcon = (props)=>/*#__PURE__*/ $6a037d4d5e538885$var$_react.default.createElement($6a037d4d5e538885$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$6a037d4d5e538885$var$GridIcon.displayName = 'GridIcon';
var $6a037d4d5e538885$var$_default = module.exports.default = $6a037d4d5e538885$var$GridIcon;

});


parcelRegister("6gDOZ", function(module, exports) {
$parcel$export(module.exports, "RoadmapContentType", function () { return $23eb48e0e5f8b517$export$c26611fdf31552ff; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $9dCmO = parcelRequire("9dCmO");

var $7surG = parcelRequire("7surG");

var $8BlKa = parcelRequire("8BlKa");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $dJc68 = parcelRequire("dJc68");

var $j9rsS = parcelRequire("j9rsS");
const $23eb48e0e5f8b517$export$c26611fdf31552ff = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/52hxc2u4jyp725y2bvn7643d5v5si26i.webp",
        imageAlt: "This is an image of Jira Product Discovery's roadmap.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionRoadmapMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionRoadmapMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionRoadmapMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8BlKa))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionRoadmapMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dCmO))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionRoadmapMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7surG))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/jira/product-discovery",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionRoadmapMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "jiraProductDiscovery",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Jira Product Discovery",
                "data-track-event": "jpd-pt.content-types.roadmap.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "jpd-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "jpdCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "RoadmapContentType",
                        tab: "roadmap",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});

parcelRegister("8VDgu", function(module, exports) {
$parcel$export(module.exports, "LoomAIContentType", function () { return $0f1ade25de9adc59$export$d63e67d5c2f95a1e; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $hegho = parcelRequire("hegho");

var $bOuCy = parcelRequire("bOuCy");

var $g7U5A = parcelRequire("g7U5A");

var $2GO8b = parcelRequire("2GO8b");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $dJc68 = parcelRequire("dJc68");

var $j9rsS = parcelRequire("j9rsS");
const $0f1ade25de9adc59$export$d63e67d5c2f95a1e = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/y0ysg6vype03e3v0y686iyq6j207nv8b.webp",
        imageAlt: "This is an screenshot of a Loom video with an arrow pointing to a document of an AI generated summary.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionLoomAIMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionLoomAIMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionLoomAIMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2GO8b))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionLoomAIMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bOuCy))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionLoomAIMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hegho))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionLoomAIMessages).contentFeaturePoint4),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g7U5A))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/loom",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionLoomAIMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "loom",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Loom",
                "data-track-event": "loom-pt.content-types.video.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "loom-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "loomCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "LoomAIContentType",
                        tab: "loom-ai",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});
parcelRegister("hegho", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21c7c38467d82a38f61fac3c4f24f045>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c8b05f3ca790cc3f$var$_react = $c8b05f3ca790cc3f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c8b05f3ca790cc3f$var$_baseNew = $c8b05f3ca790cc3f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $c8b05f3ca790cc3f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c8b05f3ca790cc3f$var$AiChatIcon = (props)=>/*#__PURE__*/ $c8b05f3ca790cc3f$var$_react.default.createElement($c8b05f3ca790cc3f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$c8b05f3ca790cc3f$var$AiChatIcon.displayName = 'AiChatIcon';
var $c8b05f3ca790cc3f$var$_default = module.exports.default = $c8b05f3ca790cc3f$var$AiChatIcon;

});

parcelRegister("g7U5A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d7f4cbe44d53d27d30976de2191c923>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbd8cee92c5291a5$var$_react = $bbd8cee92c5291a5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bbd8cee92c5291a5$var$_baseNew = $bbd8cee92c5291a5$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $bbd8cee92c5291a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbd8cee92c5291a5$var$VideoIcon = (props)=>/*#__PURE__*/ $bbd8cee92c5291a5$var$_react.default.createElement($bbd8cee92c5291a5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$bbd8cee92c5291a5$var$VideoIcon.displayName = 'VideoIcon';
var $bbd8cee92c5291a5$var$_default = module.exports.default = $bbd8cee92c5291a5$var$VideoIcon;

});


parcelRegister("2HqHn", function(module, exports) {
$parcel$export(module.exports, "MeetingsContentType", function () { return $76709a0198740a65$export$677a2f0667186a3d; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $PQhz5 = parcelRequire("PQhz5");

var $lVBDF = parcelRequire("lVBDF");

var $6xXDI = parcelRequire("6xXDI");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $dJc68 = parcelRequire("dJc68");

var $j9rsS = parcelRequire("j9rsS");
const $76709a0198740a65$export$677a2f0667186a3d = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/5dt721bjgk6lx68w8xdt14h2080w882f.webp",
        imageAlt: "This is an screenshot of a Loom meeting recap.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionMeetingRecapMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionMeetingRecapMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionMeetingRecapMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($PQhz5))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionMeetingRecapMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lVBDF))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionMeetingRecapMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6xXDI))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/loom",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionMeetingRecapMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "loom",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Loom",
                "data-track-event": "loom-pt.content-types.video.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "loom-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "loomCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "MeetingsContentType",
                        tab: "meetings",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});
parcelRegister("lVBDF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccb1509d7e2270e6a953aebace8cfd49>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff6c1e24b0c02e0d$var$_react = $ff6c1e24b0c02e0d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ff6c1e24b0c02e0d$var$_baseNew = $ff6c1e24b0c02e0d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ff6c1e24b0c02e0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff6c1e24b0c02e0d$var$ShareIcon = (props)=>/*#__PURE__*/ $ff6c1e24b0c02e0d$var$_react.default.createElement($ff6c1e24b0c02e0d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$ff6c1e24b0c02e0d$var$ShareIcon.displayName = 'ShareIcon';
var $ff6c1e24b0c02e0d$var$_default = module.exports.default = $ff6c1e24b0c02e0d$var$ShareIcon;

});


parcelRegister("ehh5O", function(module, exports) {
$parcel$export(module.exports, "ScreenshotsContentType", function () { return $9f1d2755bb9f20ed$export$8afb64b0b0386eec; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $fBECg = parcelRequire("fBECg");

var $2DdEy = parcelRequire("2DdEy");

var $lVBDF = parcelRequire("lVBDF");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $dJc68 = parcelRequire("dJc68");

var $j9rsS = parcelRequire("j9rsS");
const $9f1d2755bb9f20ed$export$8afb64b0b0386eec = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/3y864mx2vd23i1eemvvv6q6524cg5p45.webp",
        imageAlt: "This is an screenshot of a Loom screenshot and the popup that appear to annotate the screenshot with text.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionScreenshotsMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionScreenshotsMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionScreenshotsMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2DdEy))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionScreenshotsMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBECg))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionScreenshotsMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lVBDF))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/loom",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionScreenshotsMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "loom",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Loom",
                "data-track-event": "loom-pt.content-types.video.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "loom-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "loomCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "ScreenshotsContentType",
                        tab: "screenshots",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});
parcelRegister("fBECg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5c9d13f63e125af$var$_react = $b5c9d13f63e125af$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $b5c9d13f63e125af$var$_baseNew = $b5c9d13f63e125af$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $b5c9d13f63e125af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5c9d13f63e125af$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b5c9d13f63e125af$var$_react.default.createElement($b5c9d13f63e125af$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b5c9d13f63e125af$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b5c9d13f63e125af$var$_default = module.exports.default = $b5c9d13f63e125af$var$CloudArrowUpIcon;

});

parcelRegister("2DdEy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cea8cfd29428997d16ab57b549672759>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ea9d08510906431$var$_react = $1ea9d08510906431$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1ea9d08510906431$var$_baseNew = $1ea9d08510906431$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $1ea9d08510906431$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Note".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ea9d08510906431$var$NoteIcon = (props)=>/*#__PURE__*/ $1ea9d08510906431$var$_react.default.createElement($1ea9d08510906431$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 15H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6V9.75A.75.75 0 0 1 9.75 9h3.75V3a.5.5 0 0 0-.5-.5zm9.94 8H10.5v2.44zM11 6H4V4.5h7zM7 9.5H4V8h3z" clip-rule="evenodd"/>`
    }, props));
$1ea9d08510906431$var$NoteIcon.displayName = 'NoteIcon';
var $1ea9d08510906431$var$_default = module.exports.default = $1ea9d08510906431$var$NoteIcon;

});


parcelRegister("9iIz3", function(module, exports) {
$parcel$export(module.exports, "VideoContentType", function () { return $6183e31e05e5f253$export$1b254fc966dd152f; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $7H8sx = parcelRequire("7H8sx");

var $b2tob = parcelRequire("b2tob");

var $hp8xM = parcelRequire("hp8xM");

var $g7U5A = parcelRequire("g7U5A");

var $7GVWk = parcelRequire("7GVWk");

var $2fk4i = parcelRequire("2fk4i");

var $dJc68 = parcelRequire("dJc68");

var $j9rsS = parcelRequire("j9rsS");
const $6183e31e05e5f253$export$1b254fc966dd152f = ({})=>{
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { user: user } = (0, $7GVWk.useUserContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dJc68.ContentTypeImage), {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/o5n375kcfv44lp12616c455j37582rcp.webp",
        imageAlt: "This is an screenshot of a Loom video.",
        title: intl.formatMessage((0, $j9rsS.tabbedHeroSectionVideoMessages).contentTitle),
        description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionVideoMessages).contentDescription),
        hideSeparator: true,
        iconCollection: [
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionVideoMessages).contentFeaturePoint1),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g7U5A))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionVideoMessages).contentFeaturePoint2),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7H8sx))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionVideoMessages).contentFeaturePoint3),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b2tob))), {
                    label: ""
                })
            },
            {
                description: intl.formatMessage((0, $j9rsS.tabbedHeroSectionVideoMessages).contentFeaturePoint4),
                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hp8xM))), {
                    label: ""
                })
            }
        ],
        cta: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            href: "/software/loom",
            text: intl.formatMessage((0, $j9rsS.tabbedHeroSectionVideoMessages).contentCta),
            type: "primary",
            dataEventProps: {
                "data-product-key": "loom",
                "data-event-component": "linkButton",
                "data-event-container": "tabsMenu",
                "data-event": "clicked",
                "data-label": "try-it-out",
                "data-label-english": "Explore Loom",
                "data-track-event": "loom-pt.content-types.video.cta"
            },
            onClick: ()=>{
                var _user_extended_profile;
                createAnalyticsEvent({
                    eventName: "loom-crossflow-tab-cta-clicked",
                    eventType: "ui",
                    action: "clicked",
                    actionSubject: "linkButton",
                    actionSubjectId: "loomCrossFlowHeroSection",
                    attributes: {
                        reactComponent: "VideoContentType",
                        tab: "video",
                        userTeamType: (_user_extended_profile = user.extended_profile) === null || _user_extended_profile === void 0 ? void 0 : _user_extended_profile.team_type
                    }
                }).fire();
            }
        }),
        reverseLayout: true
    });
};

});

parcelRegister("ggkMI", function(module, exports) {
$parcel$export(module.exports, "ProductProvider", function () { return $8915b41f22787dca$export$7d76ff5e8c6ff5f2; });
$parcel$export(module.exports, "useProduct", function () { return $8915b41f22787dca$export$7d7dab0d475ba5fb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $8915b41f22787dca$var$ProductContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createContext("jsm");
const $8915b41f22787dca$export$7d76ff5e8c6ff5f2 = ({ children: children, product: product })=>/*#__PURE__*/ (0, $7VQPk.jsx)($8915b41f22787dca$var$ProductContext.Provider, {
        value: product,
        children: children
    });
const $8915b41f22787dca$export$7d7dab0d475ba5fb = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useContext($8915b41f22787dca$var$ProductContext);
    if (!context) throw new Error("useProduct must be used within ProductProvider");
    return context;
};

});


parcelRegister("7eYgY", function(module, exports) {
$parcel$export(module.exports, "JSMCrossflowComponent", function () { return $a87e7811c4d9028a$export$cc4a7ed51ca95fe2; });
/* homepage-jsm-xflow.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $l22jm = parcelRequire("l22jm");

var $kooLp = parcelRequire("kooLp");

var $5yuBp = parcelRequire("5yuBp");

var $cSmPq = parcelRequire("cSmPq");
const $a87e7811c4d9028a$var$JSM_UNDERLINE_SVG = /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
    width: "100%",
    height: "30",
    viewBox: "0 0 306 42",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
        d: "M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z",
        fill: "#FFA900"
    })
});
const $a87e7811c4d9028a$var$JsmTextFormatter = ({ children: children })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $l22jm.Adg4TextUnderline), {
        underline: $a87e7811c4d9028a$var$JSM_UNDERLINE_SVG,
        children: children
    });
const $a87e7811c4d9028a$var$subtitleStyles = null;
const $a87e7811c4d9028a$var$JSMHeroTitle = ()=>{
    const isMobile = (0, $5yuBp.useIsMobile)(430);
    const fontWeight = isMobile ? "bold" : "normal";
    const jsmFormatter = (0, $1oC0p.useCallback)((str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($a87e7811c4d9028a$var$JsmTextFormatter, {
            children: str
        }), []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            fontWeight: fontWeight
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "HomePageTemplateV2.jsmCrossflowHero",
            defaultMessage: "Unlock teams with{br} <jsm>Jira Service Management</jsm>",
            values: {
                jsm: jsmFormatter,
                br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
            }
        })
    });
};
const $a87e7811c4d9028a$var$JSMHeroVariantTitle = ()=>{
    const isMobile = (0, $5yuBp.useIsMobile)(430);
    const fontWeight = isMobile ? "bold" : "normal";
    const jsmFormatter = (0, $1oC0p.useCallback)((str)=>/*#__PURE__*/ (0, $7VQPk.jsx)($a87e7811c4d9028a$var$JsmTextFormatter, {
            children: str
        }), []);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            fontWeight: fontWeight
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "HomePageTemplateV2.jsmCrossflowHero2",
            defaultMessage: "Deliver great service with{br} <jsm>Jira Service Management</jsm>",
            values: {
                jsm: jsmFormatter,
                br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
            }
        })
    });
};
const $a87e7811c4d9028a$var$JSMSubtitle = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _1pfh7vkz _6rth7vkz _s51szwfg",
            "body-lg"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "HomePageTemplateV2.crossflowHero.jsmSubtitle",
            defaultMessage: "Jira Service Management is now part of Service Collection."
        })
    });
const $a87e7811c4d9028a$export$cc4a7ed51ca95fe2 = ({ contentComponent: contentComponent, gwp10965XflowRecommendation: gwp10965XflowRecommendation })=>{
    const intl = (0, $8e22h.default)();
    const jsmData = {
        heroTitle: gwp10965XflowRecommendation ? /*#__PURE__*/ (0, $7VQPk.jsx)($a87e7811c4d9028a$var$JSMHeroVariantTitle, {}) : /*#__PURE__*/ (0, $7VQPk.jsx)($a87e7811c4d9028a$var$JSMHeroTitle, {}),
        ctaButton: {
            buttonText: intl.formatMessage({
                id: "HomePageTemplateV2.jsmCrossflowHero.ctaButtonText",
                defaultMessage: "Get started"
            }),
            buttonColor: "blue",
            buttonHref: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=jira-service-management"),
            buttonVariant: "primary",
            eventProps: {
                label: "Get started",
                labelEnglish: "Get started"
            }
        },
        contentComponent: contentComponent,
        segmentName: "jsm-crossflow-hero",
        sectionId: "jsm-crossflow-hero",
        scrollTrackingSection: "jsm-crossflow-hero",
        gwp10965XflowRecommendation: gwp10965XflowRecommendation,
        heroSubtitle: gwp10965XflowRecommendation ? /*#__PURE__*/ (0, $7VQPk.jsx)($a87e7811c4d9028a$var$JSMSubtitle, {}) : undefined
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cSmPq.ReusableCrossflowHeroComponent), (0, $6ogO3._)({}, jsmData));
};

});

parcelRegister("8TCg5", function(module, exports) {
$parcel$export(module.exports, "LoomCrossflowComponent", function () { return $b58ae9257ed77c04$export$d0a10191faf0f83c; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $l22jm = parcelRequire("l22jm");

var $kooLp = parcelRequire("kooLp");

var $5yuBp = parcelRequire("5yuBp");

var $cSmPq = parcelRequire("cSmPq");
const $b58ae9257ed77c04$var$LoomHeroTitle = ()=>{
    const isMobile = (0, $5yuBp.useIsMobile)(430);
    const fontWeight = isMobile ? "bold" : "normal";
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            fontWeight: fontWeight
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "HomePageTemplateV2.loomCrossflowHero",
            defaultMessage: "Sync smarter with <loom>Loom</loom>",
            values: {
                loom: (str)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $l22jm.Adg4TextUnderline), {
                        underline: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                            width: "100%",
                            height: isMobile ? "20" : "30",
                            viewBox: "0 0 306 42",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                d: "M0.314542 22.3672C52.9464 14.9125 91.8245 33.6666 144.966 18.1254C147.46 24.7349 153.892 33.0058 163.497 33.1094C155.486 32.9725 142.641 15.7178 155.536 27.2686C163.119 36.0683 196.172 25.2364 170.842 32.944C188.334 31.2885 204.356 20.5339 216.163 10.9702C235.811 -2.65832 220.928 23.6737 235.178 36.8756C255.37 55.2242 316.463 7.29572 304.134 7.28816C296.296 13.2947 285.769 17.046 281.423 23.6985C204.757 63.1757 259.992 -9.72674 214.311 2.55426C139.744 53.2533 177.393 7.4163 133.572 10.6223C108.06 28.9946 -0.613806 0.46356 0.29434 22.3672L0.314542 22.3672Z",
                                fill: "#FFA900"
                            })
                        }),
                        children: str
                    }),
                br: /*#__PURE__*/ (0, $7VQPk.jsx)("br", {})
            }
        })
    });
};
const $b58ae9257ed77c04$export$d0a10191faf0f83c = ({ contentComponent: contentComponent, gwp10965XflowRecommendation: gwp10965XflowRecommendation })=>{
    const intl = (0, $8e22h.default)();
    const loomData = {
        heroTitle: /*#__PURE__*/ (0, $7VQPk.jsx)($b58ae9257ed77c04$var$LoomHeroTitle, {}),
        ctaButton: {
            buttonText: intl.formatMessage({
                id: "HomePageTemplateV2.loomCrossflowHero.ctaButtonText",
                defaultMessage: "Get started"
            }),
            buttonColor: "blue",
            buttonHref: (0, $kooLp.useLocalizedHref)("/try/cloud/signup?bundle=loom"),
            buttonVariant: "primary",
            eventProps: {
                label: "Get started",
                labelEnglish: "Get started"
            }
        },
        contentComponent: contentComponent,
        segmentName: "loom-crossflow-hero",
        sectionId: "loom-crossflow-hero",
        scrollTrackingSection: "loom-crossflow-hero",
        gwp10965XflowRecommendation: gwp10965XflowRecommendation
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cSmPq.ReusableCrossflowHeroComponent), (0, $6ogO3._)({}, loomData));
};

});





//# sourceMappingURL=home.6b85e24b.js.map
